import { mapGetters } from 'vuex';

export default {
  data: () => ({
    i18n_mode: process.env.VUE_APP_LANG_MODE,
    i18n_message: {
      '発送するカード': {
        'en': 'card to send',
        'it': 'carta da inviare',
        'de': 'Karte zum Versenden',
        'es': 'tarjeta para enviar',
        'fr': 'carte à envoyer',
        'ko': '발송할 카드',
        'zh': '待寄送的卡片',
        'zh-TW': '待寄送的卡片',
      },
      '登録情報': {
        'en': 'Account Info',
        'it': 'Informazioni sull\'account',
        'de': 'Kontoinformationen',
        'es': 'Información de la cuenta',
        'fr': 'Infos du compte',
        'ko': '계정 정보',
        'zh': '帳戶資訊',
        'zh-TW': '账户信息',
      },
      '個人情報': {
        'en': 'personal information',
        'it': 'informazioni personali',
        'de': 'persönliche Informationen',
        'es': 'información personal',
        'fr': 'informations personnelles',
        'ko': '개인정보',
        'zh': '個人資訊',
        'zh-TW': '个人信息',
      },
      'パスワード変更': {
        'en': 'Change password',
        'it': 'Cambiare la password',
        'de': 'Kennwort ändern',
        'es': 'Cambiar la contraseña',
        'fr': 'Changer le mot de passe',
        'ko': '비밀번호 변경',
        'zh': '更改密碼',
        'zh-TW': '更改密码',
      },
      '戻る': {
        'en': 'Back',
        'it': 'Indietro',
        'de': 'Zurück',
        'es': 'Atrás',
        'fr': 'Retour',
        'ko': '뒤로',
        'zh': '返回',
        'zh-TW': '返回',
      },
      '最終確認': {
        'en': 'Confirm your choice',
        'it': 'Conferma la tua scelta',
        'de': 'Bestätigen Sie Ihre Auswahl',
        'es': 'Confirma tu elección',
        'fr': 'Confirmez votre choix',
        'ko': '선택을 확인하세요',
        'zh': '確認您的選擇',
        'zh-TW': '确认你的选择',
      },
      '選択したものでお間違いないでしょうか？': {
        'en': 'This action can’t be undone.',
        'it': 'Questa azione non può essere annullata.',
        'de': 'Diese Aktion kann nicht rückgängig gemacht werden.',
        'es': 'Esta acción no se puede deshacer.',
        'fr': 'Cette action ne peut pas être annulée.',
        'ko': '이 작업은 취소할 수 없습니다.',
        'zh': '此操作無法復原。',
        'zh-TW': '此操作无法撤销。',
      },
      '(※確定後の変更はできません)': {
        'en': '',
        'it': '',
        'de': '',
        'es': '',
        'fr': '',
        'ko': '',
        'zh': '',
        'zh-TW': '',
      },
      'キャンセル': {
        'en': 'Cancel',
        'it': 'Cancellare',
        'de': 'Stornieren',
        'es': 'Cancelar',
        'fr': 'Annuler',
        'ko': '취소',
        'zh': '取消',
        'zh-TW': '取消',
      },
      'はい': {
        'en': 'Yes',
        'it': 'Sì',
        'de': 'Ja',
        'es': 'Sí',
        'fr': 'Oui',
        'ko': '네',
        'zh': '是',
        'zh-TW': '是',
      },
      '同じガチャを買う': {
        'en': 'Play Again',
        'it': 'Gioca di nuovo',
        'de': 'Nochmal spielen',
        'es': 'Jugar de nuevo',
        'fr': 'Rejouer',
        'ko': '다시 하기',
        'zh': '再玩一次',
        'zh-TW': '再玩一次',
      },
      'Xmarketリストへ': {
        'en': 'Go to my Xmarket list',
        'it': 'Vai alla mia lista Xmarket',
        'de': 'Gehen Sie zu meiner Xmarket-Liste',
        'es': 'Ir a mi lista de Xmarket',
        'fr': 'Accédez à ma liste Xmarket',
        'ko': '내 Xmarket 목록에',
        'zh': '前往我的 Xmarket 名單',
        'zh-TW': '前往我的 Xmarket 列表',
      },
      'TOPページへ': {
        'en': 'Back to Home',
        'it': 'Torna alla Home',
        'de': 'Zurück zur Startseite',
        'es': 'Volver al inicio',
        'fr': 'Retour à l’accueil',
        'ko': '홈으로 돌아가기',
        'zh': '返回首頁',
        'zh-TW': '返回首页',
      },
      '会員登録完了': {
        'en': 'Registration complete',
        'it': 'Registrazione completata',
        'de': 'Registrierung abgeschlossen',
        'es': 'Registro completado',
        'fr': 'Inscription terminée',
        'ko': '등록 완료',
        'zh': '註冊完成',
        'zh-TW': '注册完成',
      },
      '会員登録ありがとうございます！': {
        'en': 'Thanks for signing up!',
        'it': 'Grazie per esserti registrato!',
        'de': 'Vielen Dank für Ihre Anmeldung!',
        'es': '¡Gracias por registrarte!',
        'fr': 'Merci de vous être inscrit !',
        'ko': '가입해 주셔서 감사합니다!',
        'zh': '感謝您的註冊！',
        'zh-TW': '感谢注册！',
      },
      '引き続きガチャの購入をお楽しみください': {
        'en': 'Enjoy playing!',
        'it': 'Buon divertimento!',
        'de': 'Viel Spaß beim Spielen!',
        'es': '¡Disfruta jugando!',
        'fr': 'Amusez-vous bien !',
        'ko': '즐겁게 플레이하세요!',
        'zh': '祝你玩得開心！',
        'zh-TW': '玩得开心！',
      },
      '確認': {
        'en': 'Confirmation',
        'it': 'Conferma',
        'de': 'Bestätigung',
        'es': 'Confirmación',
        'fr': 'Confirmation',
        'ko': '확인',
        'zh': '確認',
        'zh-TW': '确认',
      },
      '友達紹介コードの登録が完了しました': {
        'en': 'Referral code registered',
        'it': 'Codice di referral registrato',
        'de': 'Empfehlungscode registriert',
        'es': 'Código de referencia registrado',
        'fr': 'Code de parrainage enregistré',
        'ko': '추천 코드가 등록되었습니다',
        'zh': '推薦代碼已註冊',
        'zh-TW': '推荐码已注册',
      },
      '友達紹介コードを入力してください': {
        'en': 'Please enter the friend referral code.',
        'it': 'Inserisci il codice di invito dell\'amico.',
        'de': 'Bitte geben Sie den Freundesempfehlungscode ein.',
        'es': 'Por favor, introduce el código de referencia de tu amigo.',
        'fr': 'Veuillez saisir le code de parrainage de votre ami.',
        'ko': '친구 추천 코드를 입력하세요.',
        'zh': '請輸入好友推薦碼。',
        'zh-TW': '请输入好友推荐码。',
      },
      '購入内容確認': {
        'en': 'Confirm purchase details',
        'it': 'Conferma i dettagli dell\'acquisto',
        'de': 'Bestätigen Sie die Kaufdetails',
        'es': 'Confirmar detalles de compra',
        'fr': 'Confirmer les détails de l\'achat',
        'ko': '구매 내용 확인',
        'zh': '購買詳情確認',
        'zh-TW': '购买详情确认',
      },
      '購入商品名': {
        'en': 'Purchased product name',
        'it': 'Nome del prodotto acquistato',
        'de': 'Name des gekauften Produkts',
        'es': 'Nombre del producto comprado',
        'fr': 'Nom du produit acheté',
        'ko': '구매상품명',
        'zh': '購買的產品名稱',
        'zh-TW': '购买的产品名称',
      },
      '消費コイン': {
        'en': 'Coins Spent',
        'it': 'Monete spese',
        'de': 'Münzen ausgegeben',
        'es': 'Monedas gastadas',
        'fr': 'Pièces dépensées',
        'ko': '사용한 코인',
        'zh': '已花費的硬幣',
        'zh-TW': '花费的硬币',
      },
      'を消費し': {
        'en': 'Spend',
        'it': 'Spend',
        'de': 'Ausgeben',
        'es': 'Gastar',
        'fr': 'Dépenser',
        'ko': '지출하다',
        'zh': '花費',
        'zh-TW': '花费',
      },
      '回ガチャを引く': {
        'en': 'to play?',
        'it': 'giocare?',
        'de': 'spielen?',
        'es': 'jugar?',
        'fr': 'jouer ?',
        'ko': '놀다?',
        'zh': '要玩嗎？',
        'zh-TW': '玩吗？',
      },
      '所持コイン': {
        'en': 'Your Coins',
        'it': 'Le tue monete',
        'de': 'Deine Münzen',
        'es': 'Tus monedas',
        'fr': 'Vos pièces',
        'ko': '당신의 코인',
        'zh': '你的硬幣',
        'zh-TW': '你的金币',
      },
      'よろしいですか？': {
        'en': 'Are you sure?',
        'it': 'Sei sicuro?',
        'de': 'Bist du sicher?',
        'es': '¿Está seguro?',
        'fr': 'Es-tu sûr?',
        'ko': '괜찮습니까?',
        'zh': '這樣可以嗎？',
        'zh-TW': '这样可以吗？',
      },
      '商品ページに戻る': {
        'en': 'Return to product page',
        'it': 'Ritorna alla pagina del prodotto',
        'de': 'Zurück zur Produktseite',
        'es': 'Volver a la página del producto',
        'fr': 'Retour à la page produit',
        'ko': '상품 페이지로 돌아가기',
        'zh': '返回產品頁面',
        'zh-TW': '返回产品页面',
      },
      'いいえ': {
        'en': 'no',
        'it': 'NO',
        'de': 'NEIN',
        'es': 'No',
        'fr': 'Non',
        'ko': '아니오',
        'zh': '不',
        'zh-TW': '不',
      },
      'コインが不足しています': {
        'en': 'Not enough coins',
        'it': 'Monete insufficienti',
        'de': 'Nicht genug Münzen',
        'es': 'No hay suficientes monedas',
        'fr': 'Pas assez de pièces',
        'ko': '코인이 부족합니다',
        'zh': '硬幣不足',
        'zh-TW': '金币不足',
      },
      'コイン購入': {
        'en': 'Get Coins',
        'it': 'Ottieni monete',
        'de': 'Münzen erhalten',
        'es': 'Obtén monedas',
        'fr': 'Obtenir des pièces',
        'ko': '코인 받기',
        'zh': '取得硬幣',
        'zh-TW': '获取金币',
      },
      '購入コイン': {
        'en': 'Get Coins',
        'it': 'Ottieni monete',
        'de': 'Münzen erhalten',
        'es': 'Obtén monedas',
        'fr': 'Obtenez des pièces',
        'ko': '코인을 획득하세요',
        'zh': '獲得硬幣',
        'zh-TW': '获取金币',
      },
      'お支払い金額': {
        'en': 'Payment amount',
        'it': 'Importo del pagamento',
        'de': 'Zahlungsbetrag',
        'es': 'Monto del pago',
        'fr': 'Montant du paiement',
        'ko': '지불 금액',
        'zh': '付款金額',
        'zh-TW': '付款金额',
      },
      '購入する': {
        'en': 'Buy',
        'it': 'Compra',
        'de': 'Kaufen',
        'es': 'Comprar',
        'fr': 'Acheter',
        'ko': '구매',
        'zh': '購買',
        'zh-TW': '购买',
      },
      '決済が成功し、コインが反映しました。': {
        'en': 'Payment successful. Coins added to your account.',
        'it': 'Pagamento riuscito. Monete aggiunte al tuo account.',
        'de': 'Zahlung erfolgreich. Münzen wurden Ihrem Konto hinzugefügt.',
        'es': 'Pago exitoso. Monedas añadidas a tu cuenta.',
        'fr': 'Paiement réussi. Des pièces ont été ajoutées à votre compte.',
        'ko': '결제가 완료되었습니다. 코인이 계정에 추가되었습니다.',
        'zh': '付款成功。金幣已加入您的帳戶。',
        'zh-TW': '支付成功。金币已添加到您的账户。',
      },
      '決済が失敗しました。クレジットカードの状態をご確認ください。\n原因不明な場合は、クレジットカード会社にお問い合わせください。': {
        'en': 'Payment failed. Please check your card.',
        'it': 'Pagamento non riuscito. Controlla la tua carta.',
        'de': 'Zahlung fehlgeschlagen. Bitte überprüfen Sie Ihre Karte.',
        'es': 'El pago falló. Por favor, revise su tarjeta.',
        'fr': 'Le paiement a échoué. Veuillez vérifier votre carte.',
        'ko': '결제에 실패했습니다. 카드를 확인해 주세요.',
        'zh': '付款失敗。請檢查您的卡片。',
        'zh-TW': '支付失败。请检查您的银行卡。',
      },
      'ご入力いただいたカード情報が確認できませんでした。\n再度ご入力内容をご確認ください。': {
        'en': 'Card information could not be verified',
        'it': 'Impossibile verificare le informazioni della carta',
        'de': 'Karteninformationen konnten nicht verifiziert werden',
        'es': 'No se pudo verificar la información de la tarjeta',
        'fr': 'Les informations de la carte n’ont pas pu être vérifiées',
        'ko': '카드 정보를 확인할 수 없습니다',
        'zh': '無法驗證卡片資訊',
        'zh-TW': '无法验证卡信息',
      },
      'カード番号': {
        'en': 'Card number',
        'it': 'Numero della carta',
        'de': 'Kartennummer',
        'es': 'Número de tarjeta',
        'fr': 'Numéro de carte',
        'ko': '카드 번호',
        'zh': '卡號',
        'zh-TW': '卡号',
      },
      'カード(年月)': {
        'en': 'Card (year/month)',
        'it': 'Carta (year/month)',
        'de': 'Karte (year/month)',
        'es': 'Tarjeta (year/month)',
        'fr': 'Carte (year/month)',
        'ko': '카드(year/month)',
        'zh': '卡(year/month)',
        'zh-TW': '卡(year/month)',
      },
      'カード(セキュリティコード)': {
        'en': 'Card (security code)',
        'it': 'Carta (codice di sicurezza)',
        'de': 'Karte (Sicherheitscode)',
        'es': 'Tarjeta (código de seguridad)',
        'fr': 'Carte (code de sécurité)',
        'ko': '카드 (보안 코드)',
        'zh': '卡（安全碼）',
        'zh-TW': '卡（安全码）',
      },
      'カード名義': {
        'en': 'Card holder name',
        'it': 'Nome del titolare',
        'de': 'Name des Karteninhabers',
        'es': 'Nombre del titular de la tarjeta',
        'fr': 'Nom du titulaire de la carte',
        'ko': '카드 명의',
        'zh': '持卡人姓名',
        'zh-TW': '持卡人姓名',
      },
      'システムメンテナンス': {
        'en': 'System Maintenance',
        'it': 'Manutenzione del sistema',
        'de': 'Systemwartung',
        'es': 'Mantenimiento del sistema',
        'fr': 'Maintenance du système',
        'ko': '시스템 유지 관리',
        'zh': '系統維護',
        'zh-TW': '系统维护',
      },
      '通信エラー': {
        'en': 'Communication error',
        'it': 'Errore di comunicazione',
        'de': 'Kommunikationsfehler',
        'es': 'Error de comunicación',
        'fr': 'Erreur de communication',
        'ko': '통신 오류',
        'zh': '通訊錯誤',
        'zh-TW': '通信错误',
      },
      'その他': {
        'en': 'Other',
        'it': 'Altro',
        'de': 'Andere',
        'es': 'Otro',
        'fr': 'Autre',
        'ko': '기타',
        'zh': '其他',
        'zh-TW': '其他',
      },
      'が不正です': {
        'en': 'is incorrect',
        'it': 'non è corretto',
        'de': 'ist falsch',
        'es': 'es incorrecto',
        'fr': 'est incorrect',
        'ko': '불법입니다.',
        'zh': '這是違法的。',
        'zh-TW': '这是违法的。',
      },
      '仮パスワード発行': {
        'en': 'Temporary password created',
        'it': 'Password temporanea creata',
        'de': 'Temporäres Passwort erstellt',
        'es': 'Contraseña temporal creada',
        'fr': 'Mot de passe temporaire créé',
        'ko': '임시 비밀번호가 생성되었습니다',
        'zh': '已建立臨時密碼',
        'zh-TW': '已创建临时密码',
      },
      '登録されたメールアドレスに仮パスワードを送信します。': {
        'en': 'A temporary password will be sent to the registered email.',
        'it': 'Una password temporanea verrà inviata all\'email registrata.',
        'de': 'Ein temporäres Passwort wird an die registrierte E-Mail-Adresse gesendet.',
        'es': 'Se enviará una contraseña temporal al correo electrónico registrado.',
        'fr': 'Un mot de passe temporaire sera envoyé à l’adresse e-mail enregistrée.',
        'ko': '등록된 이메일로 임시 비밀번호가 전송됩니다.',
        'zh': '系統將把暫時密碼寄送至已註冊的電子郵件。',
        'zh-TW': '临时密码将发送到已注册的电子邮箱。',
      },
      'メール送信': {
        'en': 'Send Email',
        'it': 'Invia email',
        'de': 'E-Mail senden',
        'es': 'Enviar correo electrónico',
        'fr': 'Envoyer un e-mail',
        'ko': '이메일 보내기',
        'zh': '傳送電子郵件',
        'zh-TW': '发送电子邮件',
      },
      '購入日': {
        'en': 'Purchase date',
        'it': 'Data di acquisto',
        'de': 'Kaufdatum',
        'es': 'Fecha de compra',
        'fr': 'Date d\'achat',
        'ko': '구매일',
        'zh': '購買日期',
        'zh-TW': '购买日期',
      },
      '履歴': {
        'en': 'Transactions',
        'it': 'Transazioni',
        'de': 'Transaktionen',
        'es': 'Transacciones',
        'fr': 'Transactions',
        'ko': '거래',
        'zh': '交易',
        'zh-TW': '交易',
      },
      '日付': {
        'en': 'date',
        'it': 'data',
        'de': 'Datum',
        'es': 'fecha',
        'fr': 'date',
        'ko': '날짜',
        'zh': '日期',
        'zh-TW': '日期',
      },
      '商品名': {
        'en': 'Item name',
        'it': 'Nome dell\'articolo',
        'de': 'Artikelname',
        'es': 'Item name',
        'fr': 'Nom de l\'article',
        'ko': '품목 이름',
        'zh': '品項名稱',
        'zh-TW': '项目名称',
      },
      '発送状況': {
        'en': 'Shipping status',
        'it': 'Stato della spedizione',
        'de': 'Versandstatus',
        'es': 'Estado de envío',
        'fr': 'Statut d\'expédition',
        'ko': '배송 상황',
        'zh': '出貨狀態',
        'zh-TW': '发货状态',
      },
      'コイン購入完了': {
        'en': 'Purchase complete',
        'it': 'Acquisto completato',
        'de': 'Kauf abgeschlossen',
        'es': 'Compra completada',
        'fr': 'Achat terminé',
        'ko': '구매 완료',
        'zh': '購買完成',
        'zh-TW': '购买完成',
      },
      '購入失敗': {
        'en': 'Purchase failed',
        'it': 'Acquisto non riuscito',
        'de': 'Kauf fehlgeschlagen',
        'es': 'La compra falló',
        'fr': 'Échec de l’achat',
        'ko': '구매에 실패했습니다',
        'zh': '購買失敗',
        'zh-TW': '购买失败',
      },
      'コインのご購入ありがとうございました。': {
        'en': 'Thank you for purchasing coins.',
        'it': 'Grazie per aver acquistato monete.',
        'de': 'Vielen Dank für den Kauf von Münzen.',
        'es': 'Gracias por comprar monedas.',
        'fr': 'Merci d\'avoir acheté des pièces.',
        'ko': '동전을 구입해 주셔서 감사합니다.',
        'zh': '感謝您購買這些紀念幣。',
        'zh-TW': '感谢您购买这些纪念币。',
      },
      '引き続きGTCHAX Onlineをお楽しみください。': {
        'en': 'Please continue to enjoy GTCHAX Online.',
        'it': 'Continuate a utilizzare GTCHAX Online.',
        'de': 'Viel Spaß weiterhin mit GTCHAX Online!',
        'es': 'Por favor, continúen disfrutando de GTCHAX Online.',
        'fr': 'Nous espérons que vous continuerez à apprécier GTCHAX Online.',
        'ko': '계속 GTCHAX Online을 즐길 수 있습니다.',
        'zh': '請繼續暢玩 GTCHAX Online。',
        'zh-TW': '请继续畅玩 GTCHAX Online。',
      },
      '決済に失敗しました。': {
        'en': 'Payment failed.',
        'it': 'Pagamento non riuscito.',
        'de': 'Die Zahlung ist fehlgeschlagen.',
        'es': 'El pago falló.',
        'fr': 'Le paiement a échoué.',
        'ko': '결제에 실패했습니다.',
        'zh': '付款失敗。',
        'zh-TW': '付款失败。',
      },
      '他の決済方法をご利用ください。': {
        'en': 'Please use another payment method.',
        'it': 'Utilizza un altro metodo di pagamento.',
        'de': 'Bitte verwenden Sie eine andere Zahlungsmethode.',
        'es': 'Utilice otro método de pago.',
        'fr': 'Veuillez utiliser un autre mode de paiement.',
        'ko': '다른 결제 방법을 이용하십시오.',
        'zh': '請使用其他付款方式。',
        'zh-TW': '请使用其他付款方式。',
      },
      'HOMEへ戻る': {
        'en': 'Back to Home',
        'it': 'Torna alla Home',
        'de': 'Zurück zur Startseite',
        'es': 'Volver al inicio',
        'fr': 'Retour à l’accueil',
        'ko': '홈으로 돌아가기',
        'zh': '返回首頁',
        'zh-TW': '返回首页',
      },
      '名前': {
        'en': 'Name',
        'it': 'Nome',
        'de': 'Name',
        'es': 'Nombre',
        'fr': 'Nom',
        'ko': '이름',
        'zh': '姓名',
        'zh-TW': '姓名',
      },
      '国': {
        'en': 'Country',
        'it': 'Paese',
        'de': 'Land',
        'es': 'País',
        'fr': 'Pays',
        'ko': '국가',
        'zh': '國家',
        'zh-TW': '国家',
      },
      '郵便番号': {
        'en': 'Post code',
        'it': 'Codice postale',
        'de': 'Postleitzahl',
        'es': 'Código postal',
        'fr': 'Code postal',
        'ko': '우편번호',
        'zh': '郵遞區號',
        'zh-TW': '邮政编码',
      },
      '都道府県': {
        'en': 'State',
        'it': 'Stato',
        'de': 'Zustand',
        'es': 'Estado',
        'fr': 'État',
        'ko': '상태',
        'zh': '州',
        'zh-TW': '州',
      },
      '市区町村': {
        'en': 'City',
        'it': 'Città',
        'de': 'Stadt',
        'es': 'Ciudad',
        'fr': 'Ville',
        'ko': '도시',
        'zh': '城市',
        'zh-TW': '城市',
      },
      '番地': {
        'en': 'Street address',
        'it': 'Indirizzo stradale',
        'de': 'Straßenadresse',
        'es': 'Dirección postal',
        'fr': 'Adresse de la rue',
        'ko': '번지',
        'zh': '街道地址',
        'zh-TW': '街道地址',
      },
      '建物名': {
        'en': 'Address Line 2 (optional)',
        'it': 'Indirizzo 2 (facoltativo)',
        'de': 'Adresszeile 2 (optional)',
        'es': 'Línea de dirección 2 (opcional)',
        'fr': 'Adresse ligne 2 (facultatif)',
        'ko': '주소 2(선택 사항)',
        'zh': '地址第二行（選填）',
        'zh-TW': '地址第 2 行（可选）',
      },
      '電話番号': {
        'en': 'Telephone number',
        'it': 'Numero di telefono',
        'de': 'Telefonnummer',
        'es': 'Número telefónico',
        'fr': 'Numéro de téléphone',
        'ko': '전화번호',
        'zh': '電話號碼',
        'zh-TW': '电话号码',
      },
      'SMS認証': {
        'en': 'SMS authentication',
        'it': 'Autenticazione tramite SMS',
        'de': 'SMS-Authentifizierung',
        'es': 'Autenticación por SMS',
        'fr': 'Authentification SMS',
        'ko': 'SMS 인증',
        'zh': '簡訊認證',
        'zh-TW': '短信认证',
      },
      'メールアドレス': {
        'en': 'Email',
        'it': 'Email',
        'de': 'E-Mail',
        'es': 'Correo electrónico',
        'fr': 'E-mail',
        'ko': '이메일',
        'zh': '電子郵件',
        'zh-TW': '电子邮件',
      },
      '友達紹介コード': {
        'en': 'Friend referral code',
        'it': 'Codice di invito amico',
        'de': 'Freundesempfehlungscode',
        'es': 'Código de recomendación de amigos',
        'fr': 'Code de parrainage d\'un ami',
        'ko': '친구 소개 코드',
        'zh': '好友推薦碼',
        'zh-TW': '好友推荐码',
      },
      '個人情報を変更するには、お問い合わせください。': {
        'en': 'To change your personal information, please contact us.',
        'it': 'Per modificare le tue informazioni personali, contattaci.',
        'de': 'Um Ihre persönlichen Daten zu ändern, kontaktieren Sie uns bitte.',
        'es': 'Para cambiar su información personal, por favor contáctenos.',
        'fr': 'Pour modifier vos informations personnelles, veuillez nous contacter.',
        'ko': '개인정보를 변경하려면 문의하시기 바랍니다.',
        'zh': '如需更改您的個人訊息，請聯絡我們。',
        'zh-TW': '如需更改您的个人信息，请联系我们。',
      },
      '初めて配送を選択する際に、この情報を入力できます。': {
        'en': 'Enter this when you request shipping',
        'it': 'Inserisci questo quando richiedi la spedizione',
        'de': 'Geben Sie dies ein, wenn Sie den Versand anfordern',
        'es': 'Introduzca esto cuando solicite el envío',
        'fr': 'Saisissez ceci lorsque vous demandez l’expédition',
        'ko': '배송을 요청할 때 이것을 입력하세요',
        'zh': '申請運送時輸入此項',
        'zh-TW': '请在申请配送时输入此项',
      },
      'お問い合わせ': {
        'en': 'inquiry',
        'it': 'inchiesta',
        'de': 'Anfrage',
        'es': 'consulta',
        'fr': 'enquête',
        'ko': '문의',
        'zh': '詢問',
        'zh-TW': '询问',
      },
      '変更が完了しました': {
        'en': 'Changes saved',
        'it': 'Modifiche salvate',
        'de': 'Änderungen gespeichert',
        'es': 'Cambios guardados',
        'fr': 'Modifications enregistrées',
        'ko': '변경 사항이 저장되었습니다',
        'zh': '變更已儲存',
        'zh-TW': '更改已保存',
      },
      'SMSコードを送信しますか？': {
        'en': 'Send SMS code?',
        'it': 'Inviare il codice SMS?',
        'de': 'SMS-Code senden?',
        'es': '¿Enviar código SMS?',
        'fr': 'Envoyer le code SMS ?',
        'ko': 'SMS 코드를 보내시겠습니까?',
        'zh': '傳送簡訊驗證碼？',
        'zh-TW': '发送短信验证码？',
      },
      'お知らせ': {
        'en': 'Notifications',
        'it': 'Notifiche',
        'de': 'Benachrichtigungen',
        'es': 'Notificaciones',
        'fr': 'Notifications',
        'ko': '알림',
        'zh': '通知',
        'zh-TW': '通知',
      },
      '大切なお知らせ': {
        'en': 'Important notifications',
        'it': 'Notifiche importanti',
        'de': 'Wichtige Benachrichtigungen',
        'es': 'Notificaciones importantes',
        'fr': 'Notifications importantes',
        'ko': '중요한 알림',
        'zh': '重要通知',
        'zh-TW': '重要通知',
      },
      '確認コードを入力': {
        'en': 'Enter verification code',
        'it': 'Inserisci il codice di verifica',
        'de': 'Geben Sie den Bestätigungscode ein',
        'es': 'Ingrese el código de verificación',
        'fr': 'Entrez le code de vérification',
        'ko': '확인 코드 입력',
        'zh': '請輸入驗證碼',
        'zh-TW': '请输入验证码',
      },
      'メールで送信された確認コードを入力してください。': {
        'en': 'Enter the code sent to your email',
        'it': 'Inserisci il codice inviato alla tua email',
        'de': 'Geben Sie den an Ihre E-Mail gesendeten Code ein',
        'es': 'Introduce el código enviado a tu correo electrónico',
        'fr': 'Saisissez le code envoyé à votre adresse e-mail',
        'ko': '이메일로 전송된 코드를 입력하세요',
        'zh': '輸入寄送到您電子郵件的代碼',
        'zh-TW': '输入发送到您电子邮箱的验证码',
      },
      '動画を見てコインを獲得': {
        'en': 'Earn Free Coins',
        'it': 'Guadagna monete gratis',
        'de': 'Verdiene kostenlose Münzen',
        'es': 'Gana monedas gratis',
        'fr': 'Gagnez des pièces gratuites',
        'ko': '무료 코인 받기',
        'zh': '賺取免費金幣',
        'zh-TW': '赚取免费金币',
      },
      '視聴済み': {
        'en': 'Already watched',
        'it': 'Già guardato',
        'de': 'Schon angeschaut',
        'es': 'Ya visto',
        'fr': 'Déjà regardé',
        'ko': '시청됨',
        'zh': '觀看',
        'zh-TW': '观看',
      },
      '引換履歴&コイン履歴': {
        'en': 'Transaction History',
        'it': 'Cronologia delle transazioni',
        'de': 'Transaktionsverlauf',
        'es': 'Historial de transacciones',
        'fr': 'Historique des transactions',
        'ko': '거래 내역',
        'zh': '交易歷史',
        'zh-TW': '交易历史',
      },
      '取引日': {
        'en': 'Transaction Date',
        'it': 'Data della transazione',
        'de': 'Transaktionsdatum',
        'es': 'Fecha de la transacción',
        'fr': 'Date de transaction',
        'ko': '거래일자',
        'zh': '交易日期',
        'zh-TW': '交易日期',
      },
      '取引内容': {
        'en': 'Transaction details',
        'it': 'Dettagli della transazione',
        'de': 'Transaktionsdetails',
        'es': 'Detalles de la transacción',
        'fr': 'Détails de la transaction',
        'ko': '거래 내용',
        'zh': '交易詳情',
        'zh-TW': '交易详情',
      },
      '引換・付与コイン': {
        'en': 'Coin Transactions',
        'it': 'Transazioni di monete',
        'de': 'Münztransaktionen',
        'es': 'Transacciones de monedas',
        'fr': 'Transactions de pièces',
        'ko': '코인 거래',
        'zh': '硬幣交易',
        'zh-TW': '硬币交易',
      },
      '引換履歴&コイン履歴がありません。': {
        'en': 'No transaction history',
        'it': 'Nessuna cronologia delle transazioni',
        'de': 'Keine Transaktionshistorie',
        'es': 'Sin historial de transacciones',
        'fr': 'Aucun historique des transactions',
        'ko': '거래 내역 없음',
        'zh': '無交易紀錄',
        'zh-TW': '无交易记录',
      },
      '円': {
        'en': 'yen',
        'it': 'yen',
        'de': 'Yen',
        'es': 'yen',
        'fr': 'yen',
        'ko': 'yen',
        'zh': '圓圈',
        'zh-TW': '圆圈',
      },
      '仮パスワード送信完了': {
        'en': 'Temporary password sent',
        'it': 'Password temporanea inviata',
        'de': 'Temporäres Passwort gesendet',
        'es': 'Contraseña temporal enviada',
        'fr': 'Mot de passe temporaire envoyé',
        'ko': '임시 비밀번호를 보냈습니다',
        'zh': '已傳送暫時密碼',
        'zh-TW': '已发送临时密码',
      },
      '登録されたメールアドレスに仮パスワードを送信しました。': {
        'en': 'Temporary password sent to your email',
        'it': 'Password temporanea inviata alla tua email',
        'de': 'Vorläufiges Passwort wurde an Ihre E-Mail-Adresse gesendet',
        'es': 'Contraseña temporal enviada a tu correo electrónico',
        'fr': 'Mot de passe temporaire envoyé à votre adresse e-mail',
        'ko': '임시 비밀번호를 이메일로 보냈습니다',
        'zh': '臨時密碼已寄送至您的電子郵件 հասցર',
        'zh-TW': '临时密码已发送到您的电子邮箱',
      },
      'メールを確認してください。': {
        'en': 'Check your email',
        'it': 'Controlla la tua email',
        'de': 'Überprüfen Sie Ihre E-Mails',
        'es': 'Revisa tu correo electrónico',
        'fr': 'Vérifiez votre e-mail',
        'ko': '이메일을 확인하세요',
        'zh': '查看你的電子郵件',
        'zh-TW': '查看您的电子邮件',
      },
      'ログイン': {
        'en': 'Login',
        'it': 'Login',
        'de': 'Login',
        'es': 'Acceso',
        'fr': 'Se connecter',
        'ko': '로그인',
        'zh': '登入',
        'zh-TW': '登录',
      },
      '日にち': {
        'en': 'Date',
        'it': 'Data',
        'de': 'Datum',
        'es': 'Fecha',
        'fr': 'Date',
        'ko': '하루',
        'zh': '日期',
        'zh-TW': '日期',
      },
      'コイン': {
        'en': 'Coins',
        'it': 'Monete',
        'de': 'Münzen',
        'es': 'Monedas',
        'fr': 'Pièces',
        'ko': '동전',
        'zh': '硬幣',
        'zh-TW': '硬币',
      },
      '金額': {
        'en': 'Price',
        'it': 'Prezzo',
        'de': 'Preis',
        'es': 'Precio',
        'fr': 'Prix',
        'ko': '가격',
        'zh': '價格',
        'zh-TW': '价格',
      },
      '備考': {
        'en': 'Notes (optional)',
        'it': 'Note (facoltative)',
        'de': 'Hinweise (optional)',
        'es': 'Notas (opcional)',
        'fr': 'Notes (facultatives)',
        'ko': '메모(선택 사항)',
        'zh': '備註（選填）',
        'zh-TW': '备注（可选）',
      },
      '次へ': {
        'en': 'Next',
        'it': 'Prossimo',
        'de': 'Weiter',
        'es': 'Siguiente',
        'fr': 'Suivant',
        'ko': '다음',
        'zh': '下一個',
        'zh-TW': '下一个',
      },
      '配送コード': {
        'en': 'shipping code',
        'it': 'codice di spedizione',
        'de': 'Versandcode',
        'es': 'código de envío',
        'fr': 'code d\'expédition',
        'ko': '배송 코드',
        'zh': '運費代碼',
        'zh-TW': '运费代码',
      },
      '一覧に戻る': {
        'en': 'Back to list',
        'it': 'Torna all\'elenco',
        'de': 'Zurück zur Liste',
        'es': 'Volver a la lista',
        'fr': 'Retour à la liste',
        'ko': '목록으로 돌아가기',
        'zh': '返回清單',
        'zh-TW': '返回列表',
      },
      'ラインナップ': {
        'en': 'What You Can Win',
        'it': 'Cosa puoi vincere',
        'de': 'Was Sie gewinnen können',
        'es': 'Qué puedes ganar',
        'fr': 'Ce que vous pouvez gagner',
        'ko': '받을 수 있는 것',
        'zh': '你可以贏得什麼',
        'zh-TW': '你能赢得什么',
      },
      '販売開始まで': {
        'en': 'Until sales start',
        'it': 'Fino all\'inizio delle vendite',
        'de': 'Bis zum Verkaufsstart',
        'es': 'Hasta que comiencen las rebajas',
        'fr': 'Jusqu\'au début des soldes',
        'ko': '판매 개시까지',
        'zh': '直到銷售開始',
        'zh-TW': '直到销售开始',
      },
      '新しいパスワード': {
        'en': 'New Password',
        'it': 'Nuova parola d\'ordine',
        'de': 'Neues Passwort',
        'es': 'Nueva contraseña',
        'fr': 'Nouveau mot de passe',
        'ko': '새로운 비밀번호',
        'zh': '新密碼',
        'zh-TW': '新密码',
      },
      '半角英数字15文字以内': {
        'en': 'Max 15 characters',
        'it': 'Max 15 car.',
        'de': 'Max. 15 Zeichen',
        'es': 'Máx. 15 caracteres',
        'fr': '15 caractères max',
        'ko': '최대 15자',
        'zh': '最多15個字元',
        'zh-TW': '最多15个字符',
      },
      '新しいパスワード確認用': {
        'en': 'Confirm New Password',
        'it': 'Conferma nuova password',
        'de': 'Neues Passwort bestätigen',
        'es': 'Confirmar nueva contraseña',
        'fr': 'Confirmer le nouveau mot de passe',
        'ko': '새 비밀번호 확인',
        'zh': '確認新密碼',
        'zh-TW': '确认新密码',
      },
      '変更する': {
        'en': 'Save Changes',
        'it': 'Salva modifiche',
        'de': 'Änderungen speichern',
        'es': 'Guardar cambios',
        'fr': 'Enregistrer les modifications',
        'ko': '변경 사항 저장',
        'zh': '儲存變更',
        'zh-TW': '保存更改',
      },
      '発送': {
        'en': 'Ship to me',
        'it': 'Spediscilo a me',
        'de': 'Schicken Sie es mir.',
        'es': 'Envíamelo',
        'fr': 'Expédiez-moi',
        'ko': '저에게 배송하세요',
        'zh': '寄給我',
        'zh-TW': '寄给我',
      },
      '発送のみ': {
        'en': 'Shipping only',
        'it': 'Solo spedizione',
        'de': 'Versand nur',
        'es': 'Solo envíos',
        'fr': 'Expédition uniquement',
        'ko': '배송만',
        'zh': '僅限配送',
        'zh-TW': '仅限配送',
      },
      'コインのみ': {
        'en': 'Coin only',
        'it': 'Solo moneta',
        'de': 'Nur Münze',
        'es': 'Solo moneda',
        'fr': 'Pièce seulement',
        'ko': '코인 전용',
        'zh': '僅限硬幣',
        'zh-TW': '仅限硬币',
      },
      'Xmarketへ出品': {
        'en': 'Listing on Xmarket',
        'it': 'Annuncio su Xmarket',
        'de': 'Eintrag auf Xmarket',
        'es': 'Listado en Xmarket',
        'fr': 'Annonce sur Xmarket',
        'ko': 'Xmarket에 출품',
        'zh': 'Xmarket上的商品列表',
        'zh-TW': 'Xmarket上的商品列表',
      },
      '登録': {
        'en': 'Registration',
        'it': 'Registrazione',
        'de': 'Anmeldung',
        'es': 'Registro',
        'fr': 'Inscription',
        'ko': '등록',
        'zh': '登記',
        'zh-TW': '登记',
      },
      'コインへ': {
        'en': 'Convert to coins',
        'it': 'Converti in monete',
        'de': 'In Münzen umwandeln',
        'es': 'Convertir a monedas',
        'fr': 'Convertir en pièces',
        'ko': '코인으로 변환',
        'zh': '兌換成硬幣',
        'zh-TW': '转换为金币',
      },
      'Xmarketへ販売': {
        'en': 'Sell ​​to Xmarket',
        'it': 'Vendi su Xmarket',
        'de': 'Verkauf an Xmarket',
        'es': 'Vender a Xmarket',
        'fr': 'Vendre sur Xmarket',
        'ko': 'Xmarket에 판매',
        'zh': '賣給 Xmarket',
        'zh-TW': '卖给 Xmarket',
      },
      '1タップで「発送依頼」、2タップで「Xmarketへ出品」となります。': {
        'en': 'Choose an action',
        'it': 'Scegli un\'azione',
        'de': 'Wählen Sie eine Aktion',
        'es': 'Elige una acción',
        'fr': 'Choisissez une action',
        'ko': '행동을 선택하세요',
        'zh': '選擇一個動作',
        'zh-TW': '选择一个操作',
      },
      'コインへの合計還元数': {
        'en': 'Total coins:',
        'it': 'Monete totali:',
        'de': 'Gesamtmünzen:',
        'es': 'Monedas totales:',
        'fr': 'Nombre total de pièces:',
        'ko': '총 코인 수:',
        'zh': '總硬幣數：',
        'zh-TW': '总硬币数:',
      },
      'Xmarketへ出品ボタンが押された商品は、出品リストに表示されます。そこで販売価格を決定してXmarketへ出品してください。': {
        'en': 'Products for which the "List on Xmarket" button has been pressed will appear in the listing list. Please set the selling price there and list them on Xmarket.',
        'it': 'I prodotti per i quali è stato premuto il pulsante "Elenca su Xmarket" appariranno nell\'elenco delle inserzioni. Imposta lì il prezzo di vendita e mettili in vendita su Xmarket.',
        'de': 'Produkte, für die die Schaltfläche „Auf Xmarket listen“ gedrückt wurde, erscheinen in der Angebotsliste. Bitte legen Sie dort den Verkaufspreis fest und listen Sie sie auf Xmarket.',
        'es': 'Los productos para los que se ha pulsado el botón "List on Xmarket" aparecerán en la lista de publicaciones. Por favor, establezca allí el precio de venta y publíquelos en Xmarket.',
        'fr': 'Les produits pour lesquels le bouton « List on Xmarket » a été pressé apparaîtront dans la liste des annonces. Veuillez y définir le prix de vente et les mettre en vente sur Xmarket.',
        'ko': '"Xmarket에 등록" 버튼을 누른 상품이 등록 목록에 표시됩니다. 그곳에서 판매 가격을 설정하고 Xmarket에 등록해 주세요.',
        'zh': '按下「在 Xmarket 上架」按鈕的商品將會顯示在上架清單中。請在那裡設定售價，並將其上架到 Xmarket。',
        'zh-TW': '已点击“在 Xmarket 上架”按钮的商品将显示在上架列表中。请在该处设置售价并在 Xmarket 上架。',
      },
      '最終確認へ': {
        'en': 'Continue',
        'it': 'Continua',
        'de': 'Weiter',
        'es': 'Continuar',
        'fr': 'Continuer',
        'ko': '계속',
        'zh': '繼續',
        'zh-TW': '继续',
      },
      '支払方法を選択': {
        'en': 'Select payment method',
        'it': 'Seleziona il metodo di pagamento',
        'de': 'Zahlungsart auswählen',
        'es': 'Selecciona el método de pago',
        'fr': 'Sélectionnez le mode de paiement',
        'ko': '지불 방법 선택',
        'zh': '選擇付款方式',
        'zh-TW': '选择付款方式',
      },
      '有効期限': {
        'en': 'Expiry Date',
        'it': 'Data di scadenza',
        'de': 'Ablaufdatum',
        'es': 'Fecha de caducidad',
        'fr': 'Date d’expiration',
        'ko': '유효기간',
        'zh': '到期日',
        'zh-TW': '有效期',
      },
      'セキュリティコード': {
        'en': 'security code',
        'it': 'codice di sicurezza',
        'de': 'Sicherheitscode',
        'es': 'codigo de seguridad',
        'fr': 'code de sécurité',
        'ko': '보안 코드',
        'zh': '安全碼',
        'zh-TW': '安全码',
      },
      '住所1': {
        'en': 'Address Line 1',
        'it': 'Indirizzo Linea 1',
        'de': 'Adresszeile 1',
        'es': 'Dirección Línea 1',
        'fr': 'Adresse Ligne 1',
        'ko': '주소 1',
        'zh': '地址第一行',
        'zh-TW': '地址第一行',
      },
      '住所2': {
        'en': 'Address 2',
        'it': 'Indirizzo 2',
        'de': 'Adresse 2',
        'es': 'Dirección 2',
        'fr': 'Adresse 2',
        'ko': '주소 2',
        'zh': '地址 2',
        'zh-TW': '地址 2',
      },
      '会員登録': {
        'en': 'Member registration',
        'it': 'Registrazione del membro',
        'de': 'Mitgliederregistrierung',
        'es': 'Registro de miembros',
        'fr': 'Inscription des membres',
        'ko': '회원등록',
        'zh': '會員註冊',
        'zh-TW': '会员注册',
      },
      '枚セット': {
        'en': 'set of sheets',
        'it': 'set di lenzuola',
        'de': 'Satz Blätter',
        'es': 'juego de sábanas',
        'fr': 'ensemble de feuilles',
        'ko': '매 세트',
        'zh': '一套 1',
        'zh-TW': '一套 1',
      },
      '申し込みへ': {
        'en': 'Sell Now',
        'it': 'Vendi ora',
        'de': 'Jetzt verkaufen',
        'es': 'Vender ahora',
        'fr': 'Vendre maintenant',
        'ko': '지금 판매하기',
        'zh': '立即出售',
        'zh-TW': '立即出售',
      },
      '会員ID': {
        'en': 'Member ID',
        'it': 'ID membro',
        'de': 'Mitglieds-ID',
        'es': 'ID de miembro',
        'fr': 'Identifiant de membre',
        'ko': '회원 ID',
        'zh': '會員編號',
        'zh-TW': '会员编号',
      },
      '会員ランク': {
        'en': 'Membership Rank',
        'it': 'Grado di appartenenza',
        'de': 'Mitgliedschaftsrang',
        'es': 'Rango de membresía',
        'fr': 'Rang de membre',
        'ko': '회원 순위',
        'zh': '會員等級',
        'zh-TW': '会员等级',
      },
      '次のランクまで': {
        'en': 'Up to next rank',
        'it': 'Fino al grado successivo',
        'de': 'Bis zum nächsten Rang',
        'es': 'Hasta el siguiente rango',
        'fr': 'Jusqu\'au rang suivant',
        'ko': '다음 순위까지',
        'zh': '升至下一級',
        'zh-TW': '升至下一级',
      },
      '※ランクに応じた各種特典が受けられます': {
        'en': '*Rank-based bonuses',
        'it': '*Bonus basati sul grado',
        'de': '*Rangbasierte Boni',
        'es': 'Bonificaciones basadas en rango',
        'fr': '*Bonus basés sur le rang',
        'ko': '*순위 기반 보너스',
        'zh': '*按排名的獎勵',
        'zh-TW': '*基于排名的奖金',
      },
      '詳細': {
        'en': 'Detail',
        'it': 'dettaglio',
        'de': 'Detail',
        'es': 'detalle',
        'fr': 'détail',
        'ko': '상세',
        'zh': '細節',
        'zh-TW': '细节',
      },
      '友達紹介': {
        'en': 'Refer friends',
        'it': 'Invita amici',
        'de': 'Freunde empfehlen',
        'es': 'Recomienda a amigos',
        'fr': 'Parrainez des amis',
        'ko': '친구 추천',
        'zh': '推薦朋友',
        'zh-TW': '推荐朋友',
      },
      'あと': {
        'en': 'After',
        'it': 'Dopo',
        'de': 'Nach',
        'es': 'Después',
        'fr': 'Après',
        'ko': '나중에',
        'zh': '後',
        'zh-TW': '后',
      },
      '%d 人紹介可能': {
        'en': 'You can refer %d friends',
        'it': 'Puoi invitare %d amici',
        'de': 'Du kannst %d Freunde empfehlen',
        'es': 'Puedes recomendar a %d amigos',
        'fr': 'Vous pouvez parrainer %d amis',
        'ko': '친구 %d명을 추천할 수 있습니다',
        'zh': '你可以推薦 %d 位朋友',
        'zh-TW': '你可以推荐 %d 位朋友',
      },
      '紹介コード': {
        'en': 'Referral code',
        'it': 'Codice di riferimento',
        'de': 'Empfehlungscode',
        'es': 'Código de referencia',
        'fr': 'Code de parrainage',
        'ko': '추천 코드',
        'zh': '推薦碼',
        'zh-TW': '推荐码',
      },
      'コピー': {
        'en': 'Copy',
        'it': 'Copia',
        'de': 'Kopie',
        'es': 'Copiar',
        'fr': 'Copie',
        'ko': '복사',
        'zh': '複製',
        'zh-TW': '复制',
      },
      'あなたも友達も 500コインがもらえる': {
        'en': 'You and your friend will both receive 500 coins.',
        'it': 'Tu e il tuo amico riceverete entrambi 500 monete.',
        'de': 'Du und dein Freund erhaltet beide 500 Münzen.',
        'es': 'Tú y tu amigo recibiréis 500 monedas cada uno.',
        'fr': 'Vous et votre ami recevrez tous deux 500 pièces.',
        'ko': '당신과 친구 모두 500 동전을받을 수 있습니다.',
        'zh': '你和你的朋友都將獲得500枚金幣。',
        'zh-TW': '你和你的朋友都将获得500枚金币。',
      },
      '友達に会員登録をしてもらうとき、': {
        'en': 'Your friends has to enter your code',
        'it': 'I tuoi amici devono inserire il tuo codice',
        'de': 'Deine Freunde müssen deinen Code eingeben',
        'es': 'Tus amigos tienen que introducir tu código.',
        'fr': 'Vos amis doivent entrer votre code',
        'ko': '친구가 귀하의 코드를 입력해야 합니다.',
        'zh': '您的朋友必須輸入您的代碼',
        'zh-TW': '您的朋友必须输入您的代码',
      },
      'あなたのコードを入力してもらう': {
        'en': 'when he or she registers as a member and then',
        'it': 'quando lui o lei si registra come membro e poi',
        'de': 'wenn er oder sie sich als Mitglied registriert und dann',
        'es': 'cuando se registra como miembro y luego',
        'fr': 'lorsqu\'il s\'inscrit en tant que membre et ensuite',
        'ko': '회원으로 등록한 후',
        'zh': '當他或她註冊為會員時，然後',
        'zh-TW': '当他或她注册为会员时，然后',
      },
      'その友達が': {
        'en': 'That friend completes',
        'it': 'Quell\'amico completa',
        'de': 'Dieser Freund ist fertig',
        'es': 'ese amigo completa',
        'fr': 'Cet ami termine',
        'ko': '그 친구가 완성했어요',
        'zh': '這位朋友完成了',
        'zh-TW': '这位朋友完成了',
      },
      'コインの購入': {
        'en': 'purchasing Coins',
        'it': 'Acquisto di monete',
        'de': 'Münzen kaufen',
        'es': 'Comprar monedas',
        'fr': 'Acheter des pièces',
        'ko': '코인 구매',
        'zh': '購買金幣',
        'zh-TW': '购买金币',
      },
      'クーポン': {
        'en': 'Coupon',
        'it': 'Buono',
        'de': 'Coupon',
        'es': 'Cupón',
        'fr': 'Coupon',
        'ko': '쿠폰',
        'zh': '優惠券',
        'zh-TW': '优惠券',
      },
      'お知らせなどで配布': {
        'en': 'Available via Instagram & announcements',
        'it': 'Disponibile tramite Instagram e annunci',
        'de': 'Verfügbar über Instagram & Ankündigungen',
        'es': 'Disponible a través de Instagram y anuncios',
        'fr': 'Disponible sur Instagram et via les annonces',
        'ko': '인스타그램 및 공지를 통해 제공됩니다',
        'zh': '可透過 Instagram 與公告取得',
        'zh-TW': '可通过 Instagram 和公告获取',
      },
      'クーポンコードを入力してください': {
        'en': 'Coupon code',
        'it': 'Codice coupon',
        'de': 'Gutscheincode',
        'es': 'Kupongkod',
        'fr': 'Code promo',
        'ko': '쿠폰 코드',
        'zh': '優惠代碼',
        'zh-TW': '优惠码',
      },
      '適用': {
        'en': 'Apply',
        'it': 'Applica',
        'de': 'Anwenden',
        'es': 'Ansök',
        'fr': 'Appliquer',
        'ko': '적용',
        'zh': '申請',
        'zh-TW': '申请',
      },
      '動画を見てコインをもらう': {
        'en': 'Earn Free Coins',
        'it': 'Guadagna monete gratis',
        'de': 'Verdiene kostenlose Münzen',
        'es': 'Gana monedas gratis',
        'fr': 'Gagnez des pièces gratuites',
        'ko': '무료 코인 받기',
        'zh': '賺取免費金幣',
        'zh-TW': '赚取免费金币',
      },
      'Xmarket 出品リスト': {
        'en': 'My Xmarket list',
        'it': 'La mia lista Xmarket',
        'de': 'Meine Xmarket-Liste',
        'es': 'Mi lista de Xmarket',
        'fr': 'Ma liste Xmarket',
        'ko': '내 Xmarket 목록',
        'zh': '我的 Xmarket 列表',
        'zh-TW': '我的 Xmarket 列表',
      },
      'Appleとの連携に失敗しました。もう一度お試しください。': {
        'en': 'Failed to cooperate with Apple. Please try again.',
        'it': 'Impossibile collaborare con Apple. Per favore riprova.',
        'de': 'Die Zusammenarbeit mit Apple ist fehlgeschlagen. Bitte versuchen Sie es erneut.',
        'es': 'No se pudo cooperar con Apple. Por favor inténtalo de nuevo.',
        'fr': 'Échec de la coopération avec Apple. Veuillez réessayer.',
        'ko': 'Apple과의 협력에 실패했습니다. 다시 시도해 주세요.',
        'zh': '與蘋果設備的連線失敗，請重試。',
        'zh-TW': '与苹果设备的连接失败，请重试。',
      },
      '以下のURLから当サイト情報との紐付けを削除し再度お試し下さい。': {
        'en': 'Please remove the link to this site information from the URL below and try again.',
        'it': 'Rimuovi il collegamento alle informazioni su questo sito dall\'URL riportato di seguito e riprova.',
        'de': 'Bitte entfernen Sie den Link zu diesen Website-Informationen von der unten stehenden URL und versuchen Sie es erneut.',
        'es': 'Elimine el enlace a la información de este sitio de la siguiente URL e inténtelo de nuevo.',
        'fr': 'Veuillez supprimer le lien vers les informations de ce site de l\'URL ci-dessous et réessayer.',
        'ko': '아래 URL에서 사이트 정보와의 연결을 삭제하고 다시 시도하십시오.',
        'zh': '請從以下網址中移除指向我們網站的鏈接，然後重試。',
        'zh-TW': '请从以下网址中移除指向我们网站的链接，然后重试。',
      },
      'このアカウントは既に登録されています。ログインしてお楽しみください。': {
        'en': 'This account is already registered. Please log in and enjoy.',
        'it': 'Questo account è già registrato. Per favore accedi e divertiti.',
        'de': 'Dieses Konto ist bereits registriert. Bitte loggen Sie sich ein und genießen Sie es.',
        'es': 'Esta cuenta ya está registrada. Por favor inicia sesión y disfruta.',
        'fr': 'Ce compte est déjà enregistré. Veuillez vous connecter et profiter.',
        'ko': '이 계정은 이미 등록되어 있습니다.',
        'zh': '此帳號已註冊。請登入以查看內容。',
        'zh-TW': '此账号已注册。请登录以查看内容。',
      },
      'メールアドレスまたはパスワードが一致しません。': {
        'en': 'Email or passwords do not match.',
        'it': 'L\'email o la password non corrispondono.',
        'de': 'E-Mail oder Passwörter stimmen nicht überein.',
        'es': 'El correo electrónico o las contraseñas no coinciden.',
        'fr': 'L’adresse e-mail ou le mot de passe ne correspondent pas.',
        'ko': '이메일 또는 비밀번호가 일치하지 않습니다.',
        'zh': '電子郵件或密碼不相符。',
        'zh-TW': '电子邮件或密码不匹配。',
      },
      '利用規約': {
        'en': 'Terms of service',
        'it': 'Termini di servizio',
        'de': 'Nutzungsbedingungen',
        'es': 'Términos de servicio',
        'fr': 'Conditions de service',
        'ko': '이용 약관',
        'zh': '服務條款',
        'zh-TW': '服务条款',
      },
      'に同意し、会員登録をします': {
        'en': 'I agree and register as a member.',
        'it': 'Accetto e mi registro come membro.',
        'de': 'Ich stimme zu und melde mich als Mitglied an.',
        'es': 'Acepto y me registro como miembro.',
        'fr': 'J\'accepte et m\'inscris en tant que membre.',
        'ko': '동의하고 회원 등록',
        'zh': '我同意，並將註冊成為會員。',
        'zh-TW': '我同意，并将注册成为会员。',
      },
      '住所は、「発送依頼」をされた際にご登録いただきます。': {
        'en': 'Please enter your address when you make your first shipping request.',
        'it': 'Inserisci il tuo indirizzo quando effettui la prima richiesta di spedizione.',
        'de': 'Bitte geben Sie bei Ihrer ersten Versandanfrage Ihre Adresse ein.',
        'es': 'Ingrese su dirección cuando realice su primera solicitud de envío.',
        'fr': 'Veuillez saisir votre adresse lors de votre première demande d\'expédition.',
        'ko': '주소는, 최초의 「발송 의뢰」를 되었을 때에 입력해 주십니다.',
        'zh': '當您提交「出貨請求」時，您的地址將被登記。',
        'zh-TW': '当您提交“发货请求”时，您的地址将被登记。',
      },
      '利用規約に同意してください': {
        'en': 'Please agree to the terms of use',
        'it': 'Si prega di accettare i termini di utilizzo',
        'de': 'Bitte stimmen Sie den Nutzungsbedingungen zu',
        'es': 'Por favor acepta los términos de uso.',
        'fr': 'Veuillez accepter les conditions d\'utilisation',
        'ko': '이용 약관에 동의하십시오.',
        'zh': '請同意服務條款。',
        'zh-TW': '请同意服务条款。',
      },
      '会社概要': {
        'en': 'Company Profile',
        'it': 'Profilo Aziendale',
        'de': 'Unternehmensprofil',
        'es': 'Perfil de la empresa',
        'fr': 'Profil de l\'entreprise',
        'ko': '회사개요',
        'zh': '公司簡介',
        'zh-TW': '公司简介',
      },
      '資金決済法': {
        'en': 'Payment Services Act (Japan)',
        'it': 'Legge sui servizi di pagamento (Giappone)',
        'de': 'Zahlungsdienstegesetz (Japan)',
        'es': 'Ley de Servicios de Pago (Japón)',
        'fr': 'Loi sur les services de paiement (Japon)',
        'ko': '자금결제에 관한 법률(일본)',
        'zh': '日本《支付服務法》',
        'zh-TW': '《支付服务法》（日本）',
      },
      '特定商取引法': {
        'en': 'Legal Disclosure (Japan)',
        'it': 'Note legali (Giappone)',
        'de': 'Rechtliche Hinweise (Japan)',
        'es': 'Aviso legal (Japón)',
        'fr': 'Mentions légales (Japon)',
        'ko': '법적 고지(일본)',
        'zh': '法律聲明（日本）',
        'zh-TW': '法律声明（日本）',
      },
      'ご利用ガイド': {
        'en': 'User Guide',
        'it': 'Guida per l\'utente',
        'de': 'Benutzerhandbuch',
        'es': 'Guía del usuario',
        'fr': 'Guide de l’utilisateur',
        'ko': '사용자 안내서',
        'zh': '使用者指南',
        'zh-TW': '用户指南',
      },
      '個人情報保護ポリシー': {
        'en': 'Privacy Policy',
        'it': 'Informativa sulla privacy',
        'de': 'Datenschutzerklärung',
        'es': 'Política de privacidad',
        'fr': 'Politique de confidentialité',
        'ko': '개인정보 처리방침',
        'zh': '隱私權政策',
        'zh-TW': '隐私政策',
      },
      '申し込み': {
        'en': 'application',
        'it': 'applicazione',
        'de': 'Anwendung',
        'es': 'solicitud',
        'fr': 'application',
        'ko': '신청',
        'zh': '應用',
        'zh-TW': '应用',
      },
      'マイページ': {
        'en': 'My page',
        'it': 'La mia pagina',
        'de': 'Meine Seite',
        'es': 'mi pagina',
        'fr': 'Ma page',
        'ko': '내 페이지',
        'zh': '我的頁面',
        'zh-TW': '我的页面',
      },
      'コイン履歴': {
        'en': 'Coin history',
        'it': 'storia della moneta',
        'de': 'Münzgeschichte',
        'es': 'historia de la moneda',
        'fr': 'histoire des pièces de monnaie',
        'ko': '동전 이력',
        'zh': '硬幣歷史',
        'zh-TW': '硬币历史',
      },
      '商品購入履歴': {
        'en': 'Product purchase history',
        'it': 'Cronologia degli acquisti del prodotto',
        'de': 'Produktkaufhistorie',
        'es': 'Historial de compra de productos',
        'fr': 'Historique des achats de produits',
        'ko': '상품 구매 이력',
        'zh': '產品購買歷史',
        'zh-TW': '产品购买历史',
      },
      'ログアウト': {
        'en': 'Logout',
        'it': 'Esci',
        'de': 'Abmelden',
        'es': 'Cerrar sesión',
        'fr': 'Déconnexion',
        'ko': '로그아웃',
        'zh': '登出登入',
        'zh-TW': '退出登录',
      },
      'コイン利用規約': {
        'en': 'Coin Terms of Use',
        'it': 'Termini di utilizzo della moneta',
        'de': 'Nutzungsbedingungen der Kryptowährung',
        'es': 'Condiciones de uso de Coin',
        'fr': 'Conditions d\'utilisation de Coin',
        'ko': '코인 이용 약관',
        'zh': '硬幣使用條款',
        'zh-TW': '硬币使用条款',
      },
      '資金決済法に基づく表記': {
        'en': 'Description based on the Payment Services Act',
        'it': 'Descrizione basata sulla legge sui servizi di pagamento',
        'de': 'Beschreibung basierend auf dem Zahlungsdienstegesetz',
        'es': 'Descripción basada en la Ley de Servicios de Pago',
        'fr': 'Description basée sur la loi sur les services de paiement',
        'ko': '자금결제법에 따른 표기',
        'zh': '根據《支付服務法》進行資訊揭露',
        'zh-TW': '根据《支付服务法》进行信息披露',
      },
      '特定商取引法に基づく表記': {
        'en': 'Description based on Specified Commercial Transactions Law',
        'it': 'Descrizione basata sulla legge sulle transazioni commerciali specifiche',
        'de': 'Beschreibung basierend auf dem Gesetz über bestimmte Handelstransaktionen',
        'es': 'Descripción basada en la Ley de Transacciones Comerciales Específicas',
        'fr': 'Description basée sur la loi sur les transactions commerciales spécifiées',
        'ko': '특정 상거래법에 근거한 표기',
        'zh': '根據《特定商業交易法》進行揭露',
        'zh-TW': '根据《特定商业交易法》进行披露',
      },
      '会員登録 / ログイン': {
        'en': 'Register / Log in',
        'it': 'Registrati / Accedi',
        'de': 'Registrieren / Anmelden',
        'es': 'Registrarse / Iniciar sesión',
        'fr': 'S\'inscrire / Se connecter',
        'ko': '등록 / 로그인',
        'zh': '註冊/登入',
        'zh-TW': '注册/登录',
      },
      'ガチャ': {
        'en': 'Gacha',
        'it': 'Gacha',
        'de': 'Gacha',
        'es': 'Gacha',
        'fr': 'Gacha',
        'ko': '가챠',
        'zh': '扭蛋',
        'zh-TW': '扭蛋',
      },
      '買取': {
        'en': 'Sales',
        'it': 'Vendite',
        'de': 'Verkauf',
        'es': 'Ventas',
        'fr': 'Ventes',
        'ko': '판매',
        'zh': '銷售',
        'zh-TW': '销售',
      },
      '発送待ち': {
        'en': 'Awaiting Shipment',
        'it': 'In attesa di spedizione',
        'de': 'Warten auf Versand',
        'es': 'En espera de envío',
        'fr': 'En attente d\'expédition',
        'ko': '배송 대기 중',
        'zh': '待出貨',
        'zh-TW': '待发货',
      },
      '身分証(表)を設定してください': {
        'en': 'Please set your ID (front)',
        'it': 'Per favore imposta il tuo ID (fronte)',
        'de': 'Bitte geben Sie Ihren Ausweis ein (vorne)',
        'es': 'Por favor configura tu ID (frente)',
        'fr': 'Veuillez définir votre identifiant (recto)',
        'ko': '신분증(표)을 설정해 주세요',
        'zh': '請填寫您的身分證件（正面）。',
        'zh-TW': '请填写您的身份证件（正面）。',
      },
      '身分証(裏)を設定してください': {
        'en': 'Please set your ID (back)',
        'it': 'Per favore imposta il tuo ID (indietro)',
        'de': 'Bitte setzen Sie Ihre ID (zurück)',
        'es': 'Por favor configura tu ID (atrás)',
        'fr': 'Veuillez définir votre identifiant (retour)',
        'ko': '신분증(뒤)을 설정해 주세요',
        'zh': '請將身分證背面放好。',
        'zh-TW': '请将身份证背面放好。',
      },
      'お申し込みありがとうございます。お品物が到着次第、ご連絡いたします。引き続きどうぞよろしくお願いいたします。': {
        'en': 'Thank you for your application. We will contact you as soon as the item arrives. Thank you for your continued support.',
        'it': 'Grazie per la tua candidatura Ti contatteremo non appena arriverà l\'articolo. Grazie per il vostro continuo supporto.',
        'de': 'Vielen Dank für Ihre Bewerbung. Wir werden Sie kontaktieren, sobald der Artikel bei Ihnen eintrifft. Vielen Dank für Ihre anhaltende Unterstützung.',
        'es': 'Gracias por tu solicitud. Nos comunicaremos con usted tan pronto como llegue el artículo. Gracias por su continuo apoyo.',
        'fr': 'Merci pour votre candidature. Nous vous contacterons dès l\'arrivée de l\'article. Merci pour votre soutien continu.',
        'ko': '신청해 주셔서 감사합니다. 물건이 도착하는 대로 연락 드리겠습니다.',
        'zh': '感謝您的訂購。商品到貨後，我們會立即與您聯繫。期待繼續為您服務。',
        'zh-TW': '感谢您的订购。商品到货后，我们会立即与您联系。期待继续为您服务。',
      },
      '価格帯': {
        'en': 'price range',
        'it': 'fascia di prezzo',
        'de': 'Preisklasse',
        'es': 'gama de precios',
        'fr': 'fourchette de prix',
        'ko': '가격대',
        'zh': '價格範圍',
        'zh-TW': '价格范围',
      },
      'タイトル': {
        'en': 'title',
        'it': 'titolo',
        'de': 'Titel',
        'es': 'título',
        'fr': 'titre',
        'ko': '제목',
        'zh': '標題',
        'zh-TW': '标题',
      },
      '検索結果': {
        'en': 'Search results',
        'it': 'Risultati della ricerca',
        'de': 'Suchergebnisse',
        'es': 'Resultados de la búsqueda',
        'fr': 'Résultats de la recherche',
        'ko': '검색결과',
        'zh': '搜尋結果',
        'zh-TW': '搜索结果',
      },
      '手順確認': {
        'en': 'How it works',
        'it': 'Come funziona',
        'de': 'Wie es funktioniert',
        'es': 'Cómo funciona',
        'fr': 'Comment ça marche',
        'ko': '작동 방식',
        'zh': '它是如何運作的',
        'zh-TW': '它是如何工作的',
      },
      '買取申込': {
        'en': 'Sell Now',
        'it': 'Vendi ora',
        'de': 'Jetzt verkaufen',
        'es': 'Vender ahora',
        'fr': 'Vendre maintenant',
        'ko': '지금 판매하기',
        'zh': '立即出售',
        'zh-TW': '立即出售',
      },
      '買取詳細履歴': {
        'en': 'Purchase details history',
        'it': 'Cronologia dei dettagli dell\'acquisto',
        'de': 'Verlauf der Kaufdetails',
        'es': 'Historial de detalles de compra',
        'fr': 'Historique des détails d\'achat',
        'ko': '구매 상세 내역',
        'zh': '購買歷史',
        'zh-TW': '购买历史',
      },
      '追跡番号': {
        'en': 'Tracking Number',
        'it': 'Numero di tracciamento',
        'de': 'Sendungsnummer',
        'es': 'Número de seguimiento',
        'fr': 'Numéro de suivi',
        'ko': '운송장 번호',
        'zh': '追蹤號碼',
        'zh-TW': '追踪号码',
      },
      '発送業者': {
        'en': 'Shipping method',
        'it': 'Metodo di spedizione',
        'de': 'Versandart',
        'es': 'Método de envío',
        'fr': 'Méthode d\'expédition',
        'ko': '배송 방법',
        'zh': '航運公司',
        'zh-TW': '航运公司',
      },
      '発送枚数': {
        'en': 'Number of cards shipped',
        'it': 'Numero di schede spedite',
        'de': 'Anzahl der versendeten Karten',
        'es': 'Número de tarjetas enviadas',
        'fr': 'Nombre de cartes expédiées',
        'ko': '발송된 카드 수',
        'zh': '已出貨卡片數量',
        'zh-TW': '已发货卡片数量',
      },
      '受け取り方法': {
        'en': 'Payment Method',
        'it': 'Metodo di pagamento',
        'de': 'Zahlungsmethode',
        'es': 'Método de pago',
        'fr': 'Mode de paiement',
        'ko': '결제 방법',
        'zh': '付款方式',
        'zh-TW': '支付方式',
      },
      '口座情報': {
        'en': 'Account information',
        'it': 'Informazioni sull\'account',
        'de': 'Kontoinformationen',
        'es': 'Información de la cuenta',
        'fr': 'Informations sur le compte',
        'ko': '계좌 정보',
        'zh': '帳號資訊',
        'zh-TW': '账户信息',
      },
      '銀行名': {
        'en': 'bank name',
        'it': 'nome della banca',
        'de': 'Bankname',
        'es': 'nombre del banco',
        'fr': 'nom de la banque',
        'ko': '은행 이름',
        'zh': '銀行名稱',
        'zh-TW': '银行名称',
      },
      '支店名': {
        'en': 'Branch name',
        'it': 'Nome della filiale',
        'de': 'Filialname',
        'es': 'Nombre de la sucursal',
        'fr': 'Nom de la succursale',
        'ko': '지점명',
        'zh': '分支名稱',
        'zh-TW': '分支名称',
      },
      '支店番号': {
        'en': 'Branch number',
        'it': 'Numero della filiale',
        'de': 'Filialnummer',
        'es': 'Número de sucursal',
        'fr': 'Numéro de succursale',
        'ko': '지점 번호',
        'zh': '分行號',
        'zh-TW': '分行号',
      },
      '口座種別': {
        'en': 'Account type',
        'it': 'Tipo di conto',
        'de': 'Kontotyp',
        'es': 'Tipo de cuenta',
        'fr': 'Type de compte',
        'ko': '계좌 유형',
        'zh': '帳戶類型',
        'zh-TW': '账户类型',
      },
      '当座': {
        'en': 'current',
        'it': 'attuale',
        'de': 'aktuell',
        'es': 'actual',
        'fr': 'actuel',
        'ko': '당좌',
        'zh': '目前的',
        'zh-TW': '当前的',
      },
      '名義': {
        'en': 'Name',
        'it': 'Nome',
        'de': 'Name',
        'es': 'Nombre',
        'fr': 'Nom',
        'ko': '명의',
        'zh': '姓名',
        'zh-TW': '姓名',
      },
      '身分証アップロード': {
        'en': 'ID card upload',
        'it': 'Caricamento carta d\'identità',
        'de': 'Ausweis hochladen',
        'es': 'cargar tarjeta de identificación',
        'fr': 'Téléchargement de la carte d\'identité',
        'ko': '신분증 업로드',
        'zh': '上傳您的身分證',
        'zh-TW': '上传您的身份证',
      },
      '表': {
        'en': 'table',
        'it': 'tavolo',
        'de': 'Tisch',
        'es': 'mesa',
        'fr': 'tableau',
        'ko': '표',
        'zh': '桌子',
        'zh-TW': '桌子',
      },
      '裏(マイナンバーは表面のみ)': {
        'en': 'back',
        'it': 'Indietro',
        'de': 'zurück',
        'es': 'atrás',
        'fr': 'dos',
        'ko': '뒤',
        'zh': '背面（我的號碼只在正面）',
        'zh-TW': '背面（我的号码只在正面）',
      },
      '買取フローを確認しました。その全てに同意します。': {
        'en': 'I agree to the terms and process',
        'it': 'Accetto i termini e il trattamento',
        'de': 'Ich stimme den Bedingungen und dem Verfahren zu',
        'es': 'Acepto los términos y el proceso',
        'fr': 'J’accepte les conditions et le traitement',
        'ko': '약관 및 절차에 동의합니다',
        'zh': '我同意條款和處理程序',
        'zh-TW': '我同意这些条款和流程',
      },
      '買取表': {
        'en': 'Sell Your Cards',
        'it': 'Vendi le tue carte',
        'de': 'Verkaufen Sie Ihre Karten',
        'es': 'Vende tus tarjetas',
        'fr': 'Vendez vos cartes',
        'ko': '카드를 판매하세요',
        'zh': '出售你的卡片',
        'zh-TW': '出售您的卡片',
      },
      '閉じる': {
        'en': 'close',
        'it': 'vicino',
        'de': 'schließen',
        'es': 'cerca',
        'fr': 'fermer',
        'ko': '닫다',
        'zh': '關閉',
        'zh-TW': '关闭',
      },
      '買取手順': {
        'en': 'How it works',
        'it': 'Come funziona',
        'de': 'Wie es funktioniert',
        'es': 'Cómo funciona',
        'fr': 'Comment ça marche',
        'ko': '작동 방식',
        'zh': '它是如何運作的',
        'zh-TW': '它是如何工作的',
      },
      '弊社へ査定依頼品の発送(発払い) & 買取申込フォームの送信': {
        'en': 'Send your cards (prepaid shipping)',
        'it': 'Spedisci le tue carte (spedizione prepagata)',
        'de': 'Senden Sie Ihre Karten ein (portofreier Versand)',
        'es': 'Envíe sus tarjetas (envío prepagado)',
        'fr': 'Envoyez vos cartes (expédition prépayée)',
        'ko': '카드를 보내세요(배송비 선불)',
        'zh': '寄送您的卡片（運費已預付）',
        'zh-TW': '寄送您的卡片（预付运费）',
      },
      'メールにて査定結果の送信(到着後2営業日以内)': {
        'en': 'Get your quote by email (within 2 business days)',
        'it': 'Ricevi il tuo preventivo via email (entro 2 giorni lavorativi)',
        'de': 'Erhalten Sie Ihr Angebot per E-Mail (innerhalb von 2 Werktagen)',
        'es': 'Recibe tu presupuesto por correo electrónico (en un plazo de 2 días hábiles)',
        'fr': 'Obtenez votre devis par e-mail (sous 2 jours ouvrés)',
        'ko': '이메일로 견적을 받아보세요(영업일 기준 2일 이내)',
        'zh': '在 2 個工作天內透過電子郵件取得報價',
        'zh-TW': '通过电子邮件获取报价（2个工作日内）',
      },
      'お振込(査定結果へのご同意後2営業日以内)': {
        'en': 'Payment via PayPal (within 2 business days)',
        'it': 'Pagamento tramite PayPal (entro 2 giorni lavorativi)',
        'de': 'Zahlung per PayPal (innerhalb von 2 Werktagen)',
        'es': 'Pago a través de PayPal (dentro de 2 días laborables)',
        'fr': 'Paiement via PayPal (sous 2 jours ouvrés)',
        'ko': 'PayPal을 통한 결제(영업일 기준 2일 이내)',
        'zh': '透過 PayPal 付款（2 個工作天內）',
        'zh-TW': '通过 PayPal 付款（2 个工作日内）',
      },
      'ご留意事項': {
        'en': 'Important Notes',
        'it': 'Note importanti',
        'de': 'Wichtige Hinweise',
        'es': 'Notas importantes',
        'fr': 'Notes importantes',
        'ko': '중요 참고사항',
        'zh': '重要注意事項',
        'zh-TW': '重要说明',
      },
      '1）買取表に掲載しているカードのみ買取可能です。': {
        'en': '1) Only cards listed on our buyback list are accepted.',
        'it': '1) Sono accettate solo le carte elencate nella nostra lista di riacquisto.',
        'de': '1) Es werden nur Karten akzeptiert, die auf unserer Ankaufsliste aufgeführt sind.',
        'es': '1) Solo se aceptan las tarjetas que figuran en nuestra lista de recompra.',
        'fr': '1) Seules les cartes figurant sur notre liste de rachat sont acceptées.',
        'ko': '1) 저희 매입 목록에 있는 카드만 접수 가능합니다.',
        'zh': '1) 僅接受列於我們回收清單上的卡片。',
        'zh-TW': '1）仅接受我们回购清单上列出的卡片。',
      },
      '2）身分証は「運転免許証」「パスポート」「マイナンバー」のいずれかでお願いいたします。': {
        'en': '2) Valid ID is required (driver’s license, passport, etc.)',
        'it': '2) È richiesto un documento d’identità valido (patente di guida, passaporto, ecc.)',
        'de': '2) Ein gültiger Ausweis ist erforderlich (Führerschein, Reisepass usw.)',
        'es': '2) Se requiere una identificación válida (licencia de conducir, pasaporte, etc.)',
        'fr': '2) Une pièce d’identité valide est requise (permis de conduire, passeport, etc.)',
        'ko': '2) 유효한 신분증이 필요합니다(운전면허증, 여권 등).',
        'zh': '2) 必須提供有效身分證件（駕照、護照等）',
        'zh-TW': '2）需要提供有效身份证件（驾驶执照、护照等。）',
      },
      '3）100枚までの発送、同名同種のカードは5枚まででお願いいたします。': {
        'en': '3) Max 100 cards per shipment',
        'it': '3) Massimo 100 carte per spedizione',
        'de': '3) Max. 100 Karten pro Sendung',
        'es': '3) Máximo 100 tarjetas por envío',
        'fr': '3) Maximum 100 cartes par expédition',
        'ko': '3) 배송당 최대 100장 카드',
        'zh': '3) 每批出貨最多 100 張卡片',
        'zh-TW': '3) 每批货最多100张卡片',
      },
      '4）偽物・状態が著しく悪いカード・買取表に掲載のないカードは査定不可となります。': {
        'en': '4) Counterfeit or damaged cards are not accepted',
        'it': '4) Non si accettano carte contraffatte o danneggiate',
        'de': '4) Gefälschte oder beschädigte Karten werden nicht akzeptiert',
        'es': '4) No se aceptan tarjetas falsificadas o dañadas',
        'fr': '4) Les cartes contrefaites ou endommagées ne sont pas acceptées.',
        'ko': '4) 위조되거나 손상된 카드는 허용되지 않습니다.',
        'zh': '4) 不接受偽造或損壞的卡片',
        'zh-TW': '4）不接受伪造或损坏的卡片',
      },
      '5）返送をご希望の場合は、着払いにてご返送いたします。': {
        'en': '5) Return shipping is cash on delivery (COD)',
        'it': '5) La spedizione di reso è in contrassegno (COD)',
        'de': '5) Die Rücksendung erfolgt per Nachnahme (COD)',
        'es': '5) El envío de devolución es contra reembolso (COD)',
        'fr': '5) Le retour de l’expédition se fait en contre-remboursement (COD)',
        'ko': '5) 반품 배송비는 착불(COD)입니다',
        'zh': '5) 退貨運費採貨到付款（COD）',
        'zh-TW': '5）退货运费为货到付款（COD）',
      },
      '6）査定額は、到着時の価格となります。発送時にご確認いただいた価格と異なってしまう場合がございます。': {
        'en': '6) Prices are based on market value at arrival',
        'it': '6) I prezzi si basano sul valore di mercato al momento dell\'arrivo',
        'de': '6) Die Preise basieren auf dem Marktwert bei Ankunft.',
        'es': '6) Los precios se basan en el valor de mercado a la llegada.',
        'fr': '6) Les prix sont basés sur la valeur du marché à l’arrivée',
        'ko': '6) 가격은 도착 시점의 시장 가치를 기준으로 합니다.',
        'zh': '6) 價格以到貨時的市場價值為準',
        'zh-TW': '6）价格以到货时的市场价值为准',
      },
      '確認コードを入力してください': {
        'en': 'Please enter your verification code',
        'it': 'Inserisci il tuo codice di verifica',
        'de': 'Bitte geben Sie Ihren Bestätigungscode ein',
        'es': 'Por favor ingresa tu código de verificación',
        'fr': 'Veuillez entrer votre code de vérification',
        'ko': '확인 코드를 입력하세요.',
        'zh': '請輸入驗證碼。',
        'zh-TW': '请输入验证码。',
      },
      '発送依頼日': {
        'en': 'Request Date',
        'it': 'Data della richiesta',
        'de': 'Anfragedatum',
        'es': 'Fecha de solicitud',
        'fr': 'Date de la demande',
        'ko': '요청 날짜',
        'zh': '請求日期',
        'zh-TW': '请求日期',
      },
      '今月の課金額が {amount} 円未満のため、ご利用いただけません。': {
        'en': 'Unavailable: Monthly spend is below {amount} yen.',
        'it': 'Non disponibile: la spesa mensile è inferiore a {amount} yen.',
        'de': 'Nicht verfügbar: Die monatlichen Ausgaben liegen unter {amount} Yen.',
        'es': 'No disponible: El gasto mensual es inferior a {amount} yenes.',
        'fr': 'Indisponible : les dépenses mensuelles sont inférieures à {amount} yens.',
        'ko': '이용 불가: 월 지출이 {amount}엔 미만입니다.',
        'zh': '無法使用：每月支出低於 {amount} 日圓。',
        'zh-TW': '不可用：每月支出低于 {amount} 日元。',
      },
      'ユーザーエラー': {
        'en': 'User error',
        'it': 'Errore dell\'utente',
        'de': 'Benutzerfehler',
        'es': 'Error del usuario',
        'fr': 'Erreur de l\'utilisateur',
        'ko': '사용자 오류',
        'zh': '使用者錯誤',
        'zh-TW': '用户错误',
      },
      '該当する商品が存在しません。': {
        'en': 'No matching products were found.',
        'it': 'Non sono stati trovati prodotti corrispondenti.',
        'de': 'Es wurden keine passenden Produkte gefunden.',
        'es': 'No se encontraron productos coincidentes.',
        'fr': 'Aucun produit correspondant n\'a été trouvé.',
        'ko': '해당 상품이 존재하지 않습니다.',
        'zh': '未找到匹配產品。',
        'zh-TW': '未找到匹配产品。',
      },
      '対象地域ではありません。': {
        'en': 'This area is not covered.',
        'it': 'Quest\'area non è coperta.',
        'de': 'Dieser Bereich ist nicht abgedeckt.',
        'es': 'Esta zona no está cubierta.',
        'fr': 'Cette zone n\'est pas couverte.',
        'ko': '대상 지역이 아닙니다.',
        'zh': '該區域未覆蓋。',
        'zh-TW': '该区域未覆盖。',
      },
      'このガチャは、{rank}ランクの方はご購入できません。': {
        'en': 'This gacha cannot be purchased by those of {rank} rank.',
        'it': 'Questo gacha non può essere acquistato da coloro che hanno il rango {rank}.',
        'de': 'Dieses Gacha kann nicht von Personen mit dem Rang {rank} gekauft werden.',
        'es': 'Esta gacha no puede ser comprada por aquellos con rango {rank}.',
        'fr': 'Ce gacha ne peut pas être acheté par ceux de rang {rank}.',
        'ko': '이 가챠는 {rank} 랭크의 분은 구입할 수 없습니다.',
        'zh': '{rank} 等級的玩家無法購買此扭蛋。',
        'zh-TW': '{rank} 等级的玩家无法购买此扭蛋。',
      },
      'このガチャは総保有コインが{max_point_limit}コイン以上の場合は購入できません。\n※未選択のものも含みます。': {
        'en': 'This gacha cannot be purchased if the total coins you own are more than {max_point_limit}coins. \n*Includes unselected items.',
        'it': 'Questo gacha non può essere acquistato se il totale delle monete che possiedi è superiore a {max_point_limit} monete. \n*Include elementi non selezionati.',
        'de': 'Dieses Gacha kann nicht gekauft werden, wenn die Gesamtzahl der Münzen, die Sie besitzen, mehr als {max_point_limit} Münzen beträgt. \n*Enthält nicht ausgewählte Elemente.',
        'es': 'Esta gacha no se puede comprar si el total de monedas que posees supera las {max_point_limit}monedas. \n*Incluye elementos no seleccionados.',
        'fr': 'Ce gacha ne peut pas être acheté si le total de pièces que vous possédez est supérieur à {max_point_limit} pièces. \n*Inclut les éléments non sélectionnés.',
        'ko': '이 가챠는 총 보유 코인이 {max_point_limit}coins 이상인 경우는 구입할 수 없습니다.',
        'zh': '如果您擁有的金幣總數超過 {max_point_limit} 個金幣，則無法購買此扭蛋。 \n*包含未選擇的項目。',
        'zh-TW': '如果您拥有的金币总数超过 {max_point_limit} 个金币，则无法购买此扭蛋。 \n*包括未选择的项目。',
      },
      'お客様は本商品をご利用いただける条件を満たしていないため、ご利用いただけません。\n条件等の公開はいたしかねますこと、ご容赦くださいませ。': {
        'en': 'Not eligible',
        'it': 'Non idoneo',
        'de': 'Nicht berechtigt',
        'es': 'No elegible',
        'fr': 'Non admissible',
        'ko': '해당 없음',
        'zh': '不符合資格',
        'zh-TW': '不符合资格',
      },
      'このガチャは1度までです。': {
        'en': 'Limit: 1 per user',
        'it': 'Limite: 1 per utente',
        'de': 'Limit: 1 pro Nutzer',
        'es': 'Límite: 1 por usuario',
        'fr': 'Limite : 1 par utilisateur',
        'ko': '제한: 사용자당 1개',
        'zh': '每位使用者限 1 次',
        'zh-TW': '限制：每位用户限 1 个',
      },
      '{detetime}まで購入できません。': {
        'en': 'Available from {detetime}.',
        'it': 'Disponibile da {detetime}.',
        'de': 'Verfügbar ab {detetime}.',
        'es': 'Disponible a partir de {detetime}.',
        'fr': 'Disponible à partir de {detetime}.',
        'ko': '{detetime}부터 이용 가능합니다.',
        'zh': '可於 {detetime} 起使用。',
        'zh-TW': '可从 {detetime} 开始提供。',
      },
      '購入可能数をオーバーしています。': {
        'en': 'Purchase limit exceeded',
        'it': 'Limite di acquisto superato',
        'de': 'Kauflimit überschritten',
        'es': 'Límite de compra excedido',
        'fr': 'Limite d’achat dépassée',
        'ko': '구매 한도를 초과했습니다',
        'zh': '已超過購買上限',
        'zh-TW': '超出购买限制',
      },
      '入力してください': {
        'en': 'Please fill in this field',
        'it': 'Compila questo campo',
        'de': 'Bitte füllen Sie dieses Feld aus.',
        'es': 'Por favor, complete este campo',
        'fr': 'Veuillez remplir ce champ',
        'ko': '이 필드를 입력해 주세요',
        'zh': '請填寫此欄位',
        'zh-TW': '请填写此字段',
      },
      '形式が不正です': {
        'en': 'Please check the format',
        'it': 'Per favore, controlla il formato',
        'de': 'Bitte überprüfen Sie das Format',
        'es': 'Por favor, verifica el formato',
        'fr': 'Veuillez vérifier le format',
        'ko': '형식을 확인해 주세요',
        'zh': '請檢查格式',
        'zh-TW': '请检查格式',
      },
      '半角英数字で入力してください': {
        'en': 'Use letters and numbers only',
        'it': 'Usa solo lettere e numeri',
        'de': 'Nur Buchstaben und Zahlen verwenden',
        'es': 'Usa solo letras y números',
        'fr': 'Utilisez uniquement des lettres et des chiffres',
        'ko': '영문자와 숫자만 사용하세요',
        'zh': '僅限使用字母和數字',
        'zh-TW': '仅使用字母和数字',
      },
      '半角英数記号で入力してください': {
        'en': 'Use letters, numbers, and symbols only',
        'it': 'Usa solo lettere, numeri e simboli',
        'de': 'Verwenden Sie nur Buchstaben, Zahlen und Symbole.',
        'es': 'Usa solo letras, números y símbolos',
        'fr': 'Utilisez uniquement des lettres, des chiffres et des symboles',
        'ko': '문자, 숫자 및 기호만 사용하세요',
        'zh': '僅使用字母、數字和符號',
        'zh-TW': '仅使用字母、数字和符号',
      },
      '%d文字以内で入力してください': {
        'en': 'Enter up to %d characters',
        'it': 'Inserisci fino a %d caratteri',
        'de': 'Geben Sie bis zu %d Zeichen ein',
        'es': 'Introduzca hasta %d caracteres',
        'fr': 'Saisissez jusqu’à %d caractères',
        'ko': '최대 %d자까지 입력하세요',
        'zh': '最多可輸入 %d 個字元',
        'zh-TW': '最多可输入 %d 个字符',
      },
      '%d文字以上で入力してください': {
        'en': 'Minimum %d characters required',
        'it': 'Minimo %d caratteri richiesti',
        'de': 'Mindestens %d Zeichen erforderlich',
        'es': 'Se requieren al menos %d caracteres',
        'fr': '%d caractères minimum requis',
        'ko': '최소 %d자 이상 필요합니다',
        'zh': '至少需要 %d 個字元',
        'zh-TW': '至少需要 %d 个字符',
      },
      '既に使われています': {
        'en': 'Already in use',
        'it': 'Già in uso',
        'de': 'Es ist bereits im Einsatz.',
        'es': 'Ya está en uso.',
        'fr': 'Il est déjà utilisé.',
        'ko': '이미 사용 중',
        'zh': '它已經在使用了。',
        'zh-TW': '它已经在使用了。',
      },
      'カタカナで入力してください': {
        'en': 'Please enter in katakana.',
        'it': 'Inserisci il testo in katakana.',
        'de': 'Bitte in Katakana eingeben.',
        'es': 'Por favor, introduzca en katakana.',
        'fr': 'Veuillez saisir en katakana.',
        'ko': '카타카나로 입력해주세요',
        'zh': '請用片假名輸入。',
        'zh-TW': '请用片假名输入。',
      },
      'ひらがなで入力してください': {
        'en': 'Please enter in hiragana.',
        'it': 'Inserisci il testo in hiragana.',
        'de': 'Bitte geben Sie den Text in Hiragana ein.',
        'es': 'Por favor, escriba en hiragana.',
        'fr': 'Veuillez saisir en hiragana.',
        'ko': '히라가나로 입력하십시오.',
        'zh': '請用平假名輸入。',
        'zh-TW': '请用平假名输入。',
      },
      '%d以上で入力してください': {
        'en': 'Please enter a value of %d or greater.',
        'it': 'Inserisci un valore pari o superiore a %d.',
        'de': 'Bitte geben Sie einen Wert von %d oder größer ein.',
        'es': 'Introduzca un valor de %d o superior.',
        'fr': 'Veuillez saisir une valeur de %d ou plus.',
        'ko': '%d 이상으로 입력하세요.',
        'zh': '請輸入大於等於 %d 的值。',
        'zh-TW': '请输入大于等于 %d 的值。',
      },
      'コードが一致しません': {
        'en': 'Codes do not match',
        'it': 'I codici non corrispondono',
        'de': 'Codes stimmen nicht überein',
        'es': 'Los códigos no coinciden',
        'fr': 'Les codes ne correspondent pas',
        'ko': '코드가 일치하지 않습니다',
        'zh': '代碼不相符',
        'zh-TW': '代码不匹配',
      },
      '該当ユーザーなし': {
        'en': 'User not found',
        'it': 'Utente non trovato',
        'de': 'Benutzer nicht gefunden',
        'es': 'Usuario no encontrado',
        'fr': 'Utilisateur introuvable',
        'ko': '사용자를 찾을 수 없습니다',
        'zh': '找不到使用者',
        'zh-TW': '未找到用户',
      },
      'パスワードが一致しません': {
        'en': 'Passwords do not match.',
        'it': 'Le password non corrispondono.',
        'de': 'Die Passwörter stimmen nicht überein.',
        'es': 'Las contraseñas no coinciden.',
        'fr': 'Les mots de passe ne correspondent pas.',
        'ko': '비밀번호가 일치하지 않음',
        'zh': '密碼不符。',
        'zh-TW': '密码不匹配。',
      },
      '紹介コードが無効です': {
        'en': 'The referral code is invalid.',
        'it': 'Il codice di riferimento non è valido.',
        'de': 'Der Empfehlungscode ist ungültig.',
        'es': 'El código de referencia no es válido.',
        'fr': 'Le code de parrainage est invalide.',
        'ko': '추천 코드가 잘못되었습니다.',
        'zh': '推薦碼無效。',
        'zh-TW': '推荐码无效。',
      },
      '紹介コードを入力してください': {
        'en': 'Please enter the referral code.',
        'it': 'Inserisci il codice di riferimento.',
        'de': 'Bitte geben Sie den Empfehlungscode ein.',
        'es': 'Por favor, introduzca el código de referencia.',
        'fr': 'Veuillez saisir le code de parrainage.',
        'ko': '추천 코드를 입력하세요.',
        'zh': '請輸入推薦碼。',
        'zh-TW': '请输入推荐码。',
      },
      'パスワード確認用と一致しません': {
        'en': 'The password does not match the one used for confirmation.',
        'it': 'La password non corrisponde a quella utilizzata per la conferma.',
        'de': 'Das Passwort stimmt nicht mit dem zur Bestätigung verwendeten Passwort überein.',
        'es': 'La contraseña no coincide con la utilizada para la confirmación.',
        'fr': 'Le mot de passe ne correspond pas à celui utilisé pour la confirmation.',
        'ko': '비밀번호 확인과 일치하지 않음',
        'zh': '密碼與確認密碼不符。',
        'zh-TW': '密码与确认密码不符。',
      },
      'ユーザーが一致しません': {
        'en': 'User not found',
        'it': 'Utente non trovato',
        'de': 'Benutzer nicht gefunden',
        'es': 'Usuario no encontrado',
        'fr': 'Utilisateur introuvable',
        'ko': '사용자를 찾을 수 없습니다',
        'zh': '找不到使用者',
        'zh-TW': '未找到用户',
      },
      '支払い方法が一致しません': {
        'en': 'Payment methods do not match.',
        'it': 'I metodi di pagamento non corrispondono.',
        'de': 'Die Zahlungsmethoden stimmen nicht überein.',
        'es': 'Los métodos de pago no coinciden.',
        'fr': 'Les modes de paiement ne correspondent pas.',
        'ko': '결제 방법이 일치하지 않음',
        'zh': '付款方式不符。',
        'zh-TW': '付款方式不匹配。',
      },
      'この電話番号は既に登録されています': {
        'en': 'This phone number is already registered.',
        'it': 'Questo numero di telefono è già registrato.',
        'de': 'Diese Telefonnummer ist bereits registriert.',
        'es': 'Este número de teléfono ya está registrado.',
        'fr': 'Ce numéro de téléphone est déjà enregistré.',
        'ko': '이 전화번호는 이미 등록되어 있습니다.',
        'zh': '該電話號碼已註冊。',
        'zh-TW': '该电话号码已被注册。',
      },
      'この電話番号は利用できません。': {
        'en': 'Invalid phone number',
        'it': 'Numero di telefono non valido',
        'de': 'Ungültige Telefonnummer',
        'es': 'Número de teléfono no válido',
        'fr': 'Numéro de téléphone invalide',
        'ko': '잘못된 전화번호',
        'zh': '無效的電話號碼',
        'zh-TW': '无效的电话号码',
      },
      'コードが一致しませんでした': {
        'en': 'The codes did not match.',
        'it': 'I codici non corrispondevano.',
        'de': 'Die Codes stimmten nicht überein.',
        'es': 'Los códigos no coincidían.',
        'fr': 'Les codes ne correspondaient pas.',
        'ko': '코드가 일치하지 않습니다.',
        'zh': '代碼不匹配。',
        'zh-TW': '代码不匹配。',
      },
      '有効期限が切れています': {
        'en': 'The expiration date has passed.',
        'it': 'La data di scadenza è trascorsa.',
        'de': 'Das Ablaufdatum ist überschritten.',
        'es': 'La fecha de vencimiento ha pasado.',
        'fr': 'La date d\'expiration est dépassée.',
        'ko': '만료됨',
        'zh': '有效期限已過。',
        'zh-TW': '有效期已过。',
      },
      'コード認証に失敗しました': {
        'en': 'Verification failed',
        'it': 'Verifica non riuscita',
        'de': 'Verifizierung fehlgeschlagen',
        'es': 'Verificación fallida',
        'fr': 'Échec de la vérification',
        'ko': '인증에 실패했습니다',
        'zh': '驗證失敗',
        'zh-TW': '验证失败',
      },
      '不正なリクエストです': {
        'en': 'Invalid request. Please try again.',
        'it': 'Richiesta non valida. Per favore riprova.',
        'de': 'Ungültige Anfrage. Bitte versuchen Sie es erneut.',
        'es': 'Solicitud no válida. Por favor, inténtelo de nuevo.',
        'fr': 'Requête invalide. Veuillez réessayer.',
        'ko': '잘못된 요청입니다. 다시 시도해 주세요.',
        'zh': '無效的請求。請再試一次。',
        'zh-TW': '请求无效。请重试。',
      },
      'エラーが発生しました': {
        'en': 'Something went wrong. Please try again.',
        'it': 'Qualcosa è andato storto. Per favore, riprova.',
        'de': 'Etwas ist schiefgelaufen. Bitte versuchen Sie es erneut.',
        'es': 'Algo salió mal. Inténtalo de nuevo.',
        'fr': 'Une erreur s’est produite. Veuillez réessayer.',
        'ko': '문제가 발생했습니다. 다시 시도해 주세요.',
        'zh': '發生錯誤。請再試一次。',
        'zh-TW': '出了点问题。请再试一次。',
      },
      '既にランクを維持しています': {
        'en': 'Rank already maintained',
        'it': 'Posizione già mantenuta',
        'de': 'Rang bereits beibehalten',
        'es': 'Rango ya mantenido',
        'fr': 'Rang déjà maintenu',
        'ko': '순위는 이미 유지되었습니다',
        'zh': '排名已維持',
        'zh-TW': '排名已保持不变',
      },
      'ログインしてください。': {
        'en': 'Please log in.',
        'it': 'Effettua il login.',
        'de': 'Bitte melden Sie sich an.',
        'es': 'Por favor, inicie sesión.',
        'fr': 'Veuillez vous connecter.',
        'ko': '로그인하세요.',
        'zh': '請登入。',
        'zh-TW': '请登录。',
      },
      'クーポンコードが間違っています。\n正しいコードを入力してください。': {
        'en': 'The coupon code is incorrect. Please enter the correct code.',
        'it': 'Il codice coupon non è corretto. Inserisci il codice corretto.',
        'de': 'Der Gutscheincode ist ungültig. Bitte geben Sie den korrekten Code ein.',
        'es': 'El código del cupón es incorrecto. Por favor, introduzca el código correcto.',
        'fr': 'Le code promo est incorrect. Veuillez saisir le code correct.',
        'ko': '쿠폰 코드가 잘못되었습니다. \n올바른 코드를 입력하세요.',
        'zh': '優惠券代碼錯誤，請重新輸入正確的代碼。',
        'zh-TW': '优惠券代码错误，请重新输入正确的代码。',
      },
      'クーポンコードの期限が切れています。\n正しいコードを入力してください。': {
        'en': 'Your coupon code has expired. Please enter the correct code.',
        'it': 'Il tuo codice coupon è scaduto. Inserisci il codice corretto.',
        'de': 'Ihr Gutscheincode ist abgelaufen. Bitte geben Sie den korrekten Code ein.',
        'es': 'Tu código de cupón ha caducado. Introduce el código correcto.',
        'fr': 'Votre code promo a expiré. Veuillez saisir le code correct.',
        'ko': '쿠폰 코드가 만료되었습니다. \n올바른 코드를 입력하세요.',
        'zh': '您的優惠券代碼已過期。請重新輸入正確的代碼。',
        'zh-TW': '您的优惠券代码已过期。请重新输入正确的代码。',
      },
      'クーポンコードの利用条件が満たされていません。\n正しいコードを入力してください。': {
        'en': 'The coupon code redemption conditions have not been met. Please enter the correct code.',
        'it': 'Le condizioni per l\'utilizzo del codice coupon non sono state soddisfatte. Inserisci il codice corretto.',
        'de': 'Die Einlösebedingungen für den Gutscheincode wurden nicht erfüllt. Bitte geben Sie den korrekten Code ein.',
        'es': 'No se cumplen las condiciones para canjear el código del cupón. Introduzca el código correcto.',
        'fr': 'Les conditions d\'utilisation du code promo ne sont pas remplies. Veuillez saisir le code correct.',
        'ko': '쿠폰 코드 이용 약관이 충족되지 않았습니다. \n올바른 코드를 입력하세요.',
        'zh': '優惠券代碼兌換條件未滿足。請重新輸入正確的代碼。',
        'zh-TW': '优惠券代码兑换条件未满足。请重新输入正确的代码。',
      },
      'クーポンコードの利用回数が上限に達しています。\n新しいコードを入力してください。': {
        'en': 'The coupon code has reached its usage limit. Please enter a new code.',
        'it': 'Il codice coupon ha raggiunto il limite di utilizzi. Inserisci un nuovo codice.',
        'de': 'Der Gutscheincode ist nicht mehr einlösbar. Bitte geben Sie einen neuen Code ein.',
        'es': 'El código de cupón ha alcanzado su límite de uso. Por favor, introduzca un nuevo código.',
        'fr': 'Ce code promo a atteint sa limite d\'utilisation. Veuillez saisir un nouveau code.',
        'ko': '쿠폰 코드 이용 횟수가 상한에 도달했습니다. \n새 코드를 입력하세요.',
        'zh': '優惠碼已達到使用次數上限，請輸入新的優惠碼。',
        'zh-TW': '优惠码已达到使用次数上限，请输入新的优惠码。',
      },
      '既に使用済みのクーポンコードです。\n新しいコードを入力してください。': {
        'en': 'This coupon code has already been used. Please enter a new code.',
        'it': 'Questo codice sconto è già stato utilizzato. Inserisci un nuovo codice.',
        'de': 'Dieser Gutscheincode wurde bereits verwendet. Bitte geben Sie einen neuen Code ein.',
        'es': 'Este código de cupón ya ha sido utilizado. Por favor, introduzca un nuevo código.',
        'fr': 'Ce code promo a déjà été utilisé. Veuillez saisir un nouveau code.',
        'ko': '이미 사용한 쿠폰 코드입니다. \n새 코드를 입력하세요.',
        'zh': '此優惠碼已使用，請輸入新的優惠碼。',
        'zh-TW': '此优惠码已被使用，请输入新的优惠码。',
      },
      'コインプレゼントが見つかりません': {
        'en': 'Coin gift not found.',
        'it': 'Regalo in monete non trovato.',
        'de': 'Münzgeschenk nicht gefunden.',
        'es': 'No se encontró la moneda de regalo.',
        'fr': 'Pièce de monnaie introuvable.',
        'ko': '동전 선물을 찾을 수 없습니다.',
        'zh': '未找到硬幣禮物。',
        'zh-TW': '未找到硬币礼物。',
      },
      'コインプレゼントが適用されていません': {
        'en': 'The coin gift has not been applied.',
        'it': 'Il bonus in monete non è stato applicato.',
        'de': 'Die Münzspende wurde nicht eingelöst.',
        'es': 'El obsequio de monedas no se ha aplicado.',
        'fr': 'Le cadeau en pièces n\'a pas été appliqué.',
        'ko': '코인 선물이 적용되지 않음',
        'zh': '贈送的硬幣尚未發放。',
        'zh-TW': '赠送的硬币尚未发放。',
      },
      '該当するガチャが存在しません': {
        'en': 'No matching gacha exists.',
        'it': 'Non esiste un gacha corrispondente.',
        'de': 'Es existiert kein passendes Gacha-Cha.',
        'es': 'No existe ningún gacha que coincida.',
        'fr': 'Aucun gacha correspondant n\'existe.',
        'ko': '해당 가챠가 존재하지 않음',
        'zh': '沒有對應的扭蛋。',
        'zh-TW': '没有对应的扭蛋。',
      },
      '購入可能数をオーバーしています': {
        'en': 'Purchase limit exceeded',
        'it': 'Limite di acquisto superato',
        'de': 'Kauflimit überschritten',
        'es': 'Límite de compra excedido',
        'fr': 'Limite d\'achat dépassée',
        'ko': '구매 한도를 초과했습니다',
        'zh': '超過購買限制',
        'zh-TW': '购买数量超出限制',
      },
      '最大購入数を超えています': {
        'en': 'Maximum limit exceeded',
        'it': 'Limite massimo superato',
        'de': 'Maximales Limit überschritten',
        'es': 'Se excedió el límite máximo.',
        'fr': 'Limite maximale dépassée',
        'ko': '최대 한도를 초과했습니다',
        'zh': '超過最大限制',
        'zh-TW': '超出最大限制',
      },
      '購入データが見つかりませんでした': {
        'en': 'Purchase data not found.',
        'it': 'Dati di acquisto non trovati.',
        'de': 'Kaufdaten nicht gefunden.',
        'es': 'No se encontraron datos de compra.',
        'fr': 'Données d\'achat introuvables.',
        'ko': '구매 데이터를 찾을 수 없습니다.',
        'zh': '未找到購買資料。',
        'zh-TW': '未找到购买数据。',
      },
      '既に選択済みです': {
        'en': 'Already selected.',
        'it': 'Già selezionato.',
        'de': 'Bereits ausgewählt.',
        'es': 'Ya seleccionado.',
        'fr': 'Déjà sélectionné.',
        'ko': '이미 선택됨',
        'zh': '已選取。',
        'zh-TW': '已选中。',
      },
      '動画が見つかりません': {
        'en': 'No video found.',
        'it': 'Nessun video trovato.',
        'de': 'Kein Video gefunden.',
        'es': 'No se encontró ningún vídeo.',
        'fr': 'Aucune vidéo trouvée.',
        'ko': '동영상을 찾을 수 없음',
        'zh': '未找到影片。',
        'zh-TW': '未找到视频。',
      },
      '既に視聴済みです': {
        'en': 'Already watched',
        'it': 'Già visto',
        'de': 'Schon gesehen',
        'es': 'Ya visto',
        'fr': 'Déjà regardé',
        'ko': '이미 봤어요',
        'zh': '已經看過',
        'zh-TW': '已观看',
      },
      '販売者募集': {
        'en': 'Become a Seller',
        'it': 'Diventa un venditore',
        'de': 'Verkäufer werden',
        'es': 'Conviértete en vendedor',
        'fr': 'Devenir vendeur',
        'ko': '판매자가 되세요',
        'zh': '成為賣家',
        'zh-TW': '成为卖家',
      },
      '遊び方': {
        'en': 'How to play',
        'it': 'Come giocare',
        'de': 'Spielanleitung',
        'es': 'Cómo jugar',
        'fr': 'Comment jouer',
        'ko': '놀이 방법',
        'zh': '如何玩',
        'zh-TW': '如何玩',
      },
      '残数': {
        'en': 'Remaining:',
        'it': 'Rimanente:',
        'de': 'Verbleibend:',
        'es': 'Restante:',
        'fr': 'Restant :',
        'ko': '남은:',
        'zh': '剩餘：',
        'zh-TW': '剩余：',
      },
      'コインを': {
        'en': 'coin',
        'it': 'coniare',
        'de': 'Münze',
        'es': 'acuñar',
        'fr': 'pièce de monnaie',
        'ko': '동전',
        'zh': '硬幣',
        'zh-TW': '硬币',
      },
      '消費して': {
        'en': 'Consume',
        'it': 'Consumare',
        'de': 'Verbrauchen',
        'es': 'Consumir',
        'fr': 'Consommer',
        'ko': '소모하다',
        'zh': '消耗',
        'zh-TW': '消耗',
      },
      'Xmarketは近日公開致します': {
        'en': 'Xmarket will be launched soon.',
        'it': 'Xmarket verrà lanciato a breve.',
        'de': 'Xmarket wird in Kürze eingeführt.',
        'es': 'Xmarket se lanzará próximamente.',
        'fr': 'Xmarket sera bientôt lancé.',
        'ko': 'Xmarket은 곧 공개됩니다.',
        'zh': 'Xmarket即將上線。',
        'zh-TW': 'Xmarket即将上线。',
      },
      'お振込み': {
        'en': 'Bank transfer',
        'it': 'Bonifico bancario',
        'de': 'Banküberweisung',
        'es': 'Transferencia bancaria',
        'fr': 'Virement bancaire',
        'ko': '송금',
        'zh': '銀行轉帳',
        'zh-TW': '银行转账',
      },
      'コインで受け取り': {
        'en': 'Receive Coins',
        'it': 'Ricevi monete',
        'de': 'Münzen erhalten',
        'es': 'Recibir monedas',
        'fr': 'Recevoir des pièces',
        'ko': '코인 받기',
        'zh': '接收硬幣',
        'zh-TW': '接收金币',
      },
      '普通': {
        'en': 'Standard',
        'it': 'Standard',
        'de': 'Standard',
        'es': 'Estándar',
        'fr': 'Standard',
        'ko': '표준',
        'zh': '標準',
        'zh-TW': '标准',
      },
      'ホワイト': {
        'en': 'white',
        'it': 'bianco',
        'de': 'Weiß',
        'es': 'blanco',
        'fr': 'blanc',
        'ko': '화이트',
        'zh': '白色的',
        'zh-TW': '白色的',
      },
      'ブロンズ': {
        'en': 'bronze',
        'it': 'bronzo',
        'de': 'Bronze',
        'es': 'bronce',
        'fr': 'bronze',
        'ko': '청동',
        'zh': '青銅',
        'zh-TW': '青铜',
      },
      'シルバー': {
        'en': 'Silver',
        'it': 'Argento',
        'de': 'Silber',
        'es': 'Plata',
        'fr': 'Argent',
        'ko': '실버',
        'zh': '銀',
        'zh-TW': '银',
      },
      'ゴールド': {
        'en': 'gold',
        'it': 'oro',
        'de': 'Gold',
        'es': 'oro',
        'fr': 'or',
        'ko': '금',
        'zh': '金子',
        'zh-TW': '金子',
      },
      'レインボー': {
        'en': 'Rainbow',
        'it': 'Arcobaleno',
        'de': 'Regenbogen',
        'es': 'Arcoíris',
        'fr': 'Arc-en-ciel',
        'ko': '레인보우',
        'zh': '彩虹',
        'zh-TW': '彩虹',
      },
      'ブラック': {
        'en': 'black',
        'it': 'nero',
        'de': 'Schwarz',
        'es': 'negro',
        'fr': 'noir',
        'ko': '블랙',
        'zh': '黑色的',
        'zh-TW': '黑色的',
      },
      'まで': {
        'en': 'to',
        'it': 'A',
        'de': 'Zu',
        'es': 'a',
        'fr': 'à',
        'ko': '까지',
        'zh': '到',
        'zh-TW': '到',
      },
      '画像ファイルのみアップロードできます。': {
        'en': 'Only image files can be uploaded.',
        'it': 'È possibile caricare solo file immagine.',
        'de': 'Es können nur Bilddateien hochgeladen werden.',
        'es': 'Solo se pueden subir archivos de imagen.',
        'fr': 'Seuls les fichiers image peuvent être téléchargés.',
        'ko': '이미지 파일만 업로드할 수 있습니다.',
        'zh': '僅支援上傳圖片檔案。',
        'zh-TW': '仅支持上传图片文件。',
      },
      '動画視聴': {
        'en': 'Watch Videos',
        'it': 'Guarda i video',
        'de': 'Videos ansehen',
        'es': 'Ver videos',
        'fr': 'Regarder des vidéos',
        'ko': '동영상 보기',
        'zh': '觀看影片',
        'zh-TW': '观看视频',
      },
      'コイン還元': {
        'en': 'Coin Return',
        'it': 'Restituzione monete',
        'de': 'Münzrückgabe',
        'es': 'Devolución de monedas',
        'fr': 'Retour de monnaie',
        'ko': '동전 반환',
        'zh': '退幣',
        'zh-TW': '退币',
      },
      '購入': {
        'en': 'Open',
        'it': 'Apri',
        'de': 'Öffnen',
        'es': 'Abrir',
        'fr': 'Ouvrir',
        'ko': '열기',
        'zh': '開啟',
        'zh-TW': '打开',
      },
      '未選択': {
        'en': 'Unclaimed',
        'it': 'Non reclamato',
        'de': 'Nicht beansprucht',
        'es': 'No reclamado',
        'fr': 'Non réclamé',
        'ko': '미수령',
        'zh': '無人認領',
        'zh-TW': '无人认领',
      },
      '発送なし': {
        'en': 'No shipping',
        'it': 'Nessuna spedizione',
        'de': 'Kein Versand',
        'es': 'No se realizan envíos',
        'fr': 'Pas d\'expédition',
        'ko': '배송 없음',
        'zh': '不出貨',
        'zh-TW': '不发货',
      },
      '発送済み': {
        'en': 'Shipped',
        'it': 'Spedito',
        'de': 'Versand',
        'es': 'Enviado',
        'fr': 'Expédié',
        'ko': '배송됨',
        'zh': '已出貨',
        'zh-TW': '已发货',
      },
      '※発送先のご住所は初めて発送依頼いただく際にご登録いただきます': {
        'en': '*Your shipping address will be registered when you make your first shipping request.',
        'it': '*Il tuo indirizzo di spedizione verrà registrato al momento della prima richiesta di spedizione.',
        'de': '*Ihre Lieferadresse wird bei Ihrer ersten Lieferanfrage registriert.',
        'es': '*Tu dirección de envío quedará registrada cuando realices tu primera solicitud de envío.',
        'fr': '*Votre adresse de livraison sera enregistrée lors de votre première demande d\'expédition.',
        'ko': '※발송처의 주소는 처음으로 발송 의뢰할 때에 등록해 주십니다',
        'zh': '*您的收貨地址將在您首次提交出貨請求時登記。',
        'zh-TW': '*您的收货地址将在您首次提交发货请求时登记。',
      },
      '%d日': {
        'en': '%d days',
        'it': '%d giorni',
        'de': '%d Tage',
        'es': '%d días',
        'fr': '%d jours',
        'ko': '%d일',
        'zh': '%d 天',
        'zh-TW': '%d 天',
      },
      'まで販売': {
        'en': 'Sales until',
        'it': 'Saldi fino a',
        'de': 'Verkäufe bis',
        'es': 'Ventas hasta',
        'fr': 'Ventes jusqu\'à',
        'ko': '까지 판매',
        'zh': '銷售至',
        'zh-TW': '销售至',
      },
      '{year}/{month}/{day} まで販売': {
        'en': 'Available until {month}/{day}/{year} JST',
        'it': 'Disponibile fino al {day}/{month}/{year} JST',
        'de': 'Erhältlich bis {day}/{month}/{year} JST',
        'es': 'Disponible hasta {day}/{month}/{year} JST',
        'fr': 'Disponible jusqu\'au {day}/{month}/{year} JST',
        'ko': '{year}/{month}/{day} 까지 이용 가능 JST',
        'zh': '有效期至 {year}/{month}/{day} JST',
        'zh-TW': '可使用至 {year}/{month}/{day} JST',
      },
      '個人情報を変更希望の際は、チャットにてお問い合わせください': {
        'en': 'If you wish to change your personal information, please contact us via chat.',
        'it': 'Se desideri modificare i tuoi dati personali, contattaci tramite chat.',
        'de': 'Wenn Sie Ihre persönlichen Daten ändern möchten, kontaktieren Sie uns bitte per Chat.',
        'es': 'Si desea cambiar su información personal, contáctenos a través del chat.',
        'fr': 'Si vous souhaitez modifier vos informations personnelles, veuillez nous contacter par chat.',
        'ko': '개인 정보를 변경하고 싶을 때는 채팅으로 문의하십시오.',
        'zh': '如果您想更改您的個人訊息，請透過聊天與我們聯繫。',
        'zh-TW': '如果您想更改您的个人信息，请通过聊天联系我们。',
      },
      '詳細へ': {
        'en': 'Detail',
        'it': 'dettaglio',
        'de': 'Detail',
        'es': 'detalle',
        'fr': 'détail',
        'ko': '상세',
        'zh': '細節',
        'zh-TW': '细节',
      },
      '%d回限定': {
        'en': '%d per user',
        'it': '%d per utente',
        'de': '%d pro Benutzer',
        'es': '%d por usuario',
        'fr': '%d par utilisateur',
        'ko': '사용자당 %d',
        'zh': '每位使用者 %d',
        'zh-TW': '每位用户 %d',
      },
      '株式会社ゼロプレイス': {
        'en': 'Xero Place Co., Ltd.',
        'it': 'Xero Place Co., Ltd.',
        'de': 'Xero Place Co., Ltd.',
        'es': 'Compañía Xero Place, Ltd.',
        'fr': 'Xero Place Co., Ltd.',
        'ko': '주식회사 제로 플레이스',
        'zh': '零點有限公司',
        'zh-TW': '零点有限公司',
      },
      'Xero Place Co., Ltd.': {
        'en': 'Xero Place Co., Ltd.',
        'it': 'Xero Place Co., Ltd.',
        'de': 'Xero Place Co., Ltd.',
        'es': 'Compañía Xero Place, Ltd.',
        'fr': 'Xero Place Co., Ltd.',
        'ko': 'Xero Place Co., Ltd.',
        'zh': 'Xero Place有限公司',
        'zh-TW': 'Xero Place有限公司',
      },
      '〒330-0854': {
        'en': '〒330-0854',
        'it': '〒330-0854',
        'de': '〒330-0854',
        'es': '〒330-0854',
        'fr': '〒330-0854',
        'ko': '〒330-0854',
        'zh': '〒330-0854',
        'zh-TW': '〒330-0854',
      },
      '埼玉県さいたま市大宮区桜木町1丁目195‑1': {
        'en': '1-195-1 Sakuragicho, Omiya Ward, Saitama City, Saitama Prefecture',
        'it': '1-195-1 Sakuragicho, Omiya Ward, Saitama City, Saitama Prefecture',
        'de': '1-195-1 Sakuragicho, Omiya-ku, Saitama-Stadt, Präfektur Saitama',
        'es': '1-195-1 Sakuragicho, Distrito de Omiya, Ciudad de Saitama, Prefectura de Saitama',
        'fr': '1-195-1 Sakuragicho, arrondissement d\'Omiya, ville de Saitama, préfecture de Saitama',
        'ko': '사이타마현 사이타마시 오미야구 사쿠라기초 1가 195-1',
        'zh': '埼玉縣埼玉市大宮區櫻木町1-195-1',
        'zh-TW': '埼玉县埼玉市大宫区樱木町1-195-1',
      },
      '大宮ソラミチKOZ4階': {
        'en': 'Omiya Soramichi KOZ 4th floor Xero Place Co., Ltd. Purchase Reception',
        'it': 'Omiya Soramichi KOZ 4° piano Xero Place Co., Ltd. Ricevimento acquisti',
        'de': 'Omiya Soramichi KOZ 4. Stock Xero Place Co., Ltd. Einkaufsannahme',
        'es': 'Recepción de compra de Omiya Soramichi KOZ, 4.º piso, Xero Place Co., Ltd.',
        'fr': 'Omiya Soramichi KOZ 4e étage Xero Place Co., Ltd. Réception des achats',
        'ko': '오미야 소라미치 KOS 4층 주식회사 제로 플레이스 매입 접수 담당 앞',
        'zh': '大宮空道 KOZ 4樓 Xero Place Co., Ltd. 採購接待處',
        'zh-TW': '大宫空道 KOZ 4楼 Zero Place Co., Ltd. 采购接待处',
      },
      '大宮ソラミチKOZ4階　株式会社ゼロプレイス　買取受付担当宛': {
        'en': 'TEL : +81 50-1724-5360',
        'it': 'TEL : +81 50-1724-5360',
        'de': 'TEL : +81 50-1724-5360',
        'es': 'TELÉFONO: +81 50-1724-5360',
        'fr': 'TÉL  : +81 50-1724-5360',
        'ko': 'TEL  : +81 50-1724-5360',
        'zh': '電話：+81 50-1724-5360',
        'zh-TW': '电话：+81 50-1724-5360',
      },
      'TEL：050-1724-5360': {
        'en': 'TEL : +81 50-1724-5360',
        'it': 'TEL : +81 50-1724-5360',
        'de': 'TEL : +81 50-1724-5360',
        'es': 'TELÉFONO: +81 50-1724-5360',
        'fr': 'TÉL  : +81 50-1724-5360',
        'ko': 'TEL  : +81 50-1724-5360',
        'zh': '電話：+81 50-1724-5360',
        'zh-TW': '电话：+81 50-1724-5360',
      },
      '{year}/{month}/{day} 以降の登録': {
        'en': 'Registration after {month}/{day}/{year}',
        'it': 'Registrazione dopo {day}/{month}/{year}',
        'de': 'Registrierung nach {day}/{month}/{year}',
        'es': 'Registro después de {day}/{month}/{year}',
        'fr': 'Inscription après {day}/{month}/{year}',
        'ko': '{year}/{month}/{day} 이후 등록',
        'zh': '{year}/{month}/{day}後註冊',
        'zh-TW': '{year}/{month}/{day}后注册',
      },
      '{year}/{month}/{day} 以前の登録': {
        'en': 'Registrations before {month}/{day}/{year}',
        'it': 'Registrazioni prima di {day}/{month}/{year}',
        'de': 'Anmeldungen vor {day}/{month}/{year}',
        'es': 'Inscripciones antes de {day}/{month}/{year}',
        'fr': 'Inscriptions avant {day}/{month}/{year}',
        'ko': '{year}/{month}/{day} 이전 등록',
        'zh': '{year}/{month}/{day}之前註冊',
        'zh-TW': '{year}/{month}/{day}之前注册',
      },
      '今月{amount}コイン以上決済された方限定': {
        'en': 'This month\'s {amount} spenders',
        'it': 'Chi ha speso {amount} di questo mese',
        'de': 'Die {amount}-Ausgaben dieses Monats',
        'es': 'Quienes gastaron {amount} este mes',
        'fr': 'Les {amount} dépenses de ce mois-ci',
        'ko': '이번 달 {amount}Coins 이상 결제된 분 한정',
        'zh': '僅限本月支付超過 {amount}Coins 的用戶',
        'zh-TW': '仅限本月已充值{amount}枚金币或以上的用户。',
      },
      '所持{amount}コイン以下の方限定': {
        'en': '{amount} Coins or less',
        'it': ' {amount} monete o meno',
        'de': '{amount} Münzen oder weniger',
        'es': ' {amount} monedas o menos',
        'fr': '{amount} pièces ou moins',
        'ko': '소지 {amount}Coins 이하의 분 한정',
        'zh': '僅限擁有 {amount} 金幣或更少的人',
        'zh-TW': '仅限拥有{amount}枚硬币或更少硬币的用户。',
      },
      '1日%d回限定': {
        'en': 'Daily limit: %d per user',
        'it': 'Limitato a %d volte al giorno',
        'de': 'Beschränkt auf %d Mal pro Tag',
        'es': 'Limitado a %d veces al día.',
        'fr': 'Limité à %d fois par jour',
        'ko': '1일 %d회 한정',
        'zh': '每天限用 %d 次',
        'zh-TW': '每天限用 %d 次',
      },
      '言語': {
        'en': 'Language',
        'it': 'Lingua',
        'de': 'Sprache',
        'es': 'Idioma',
        'fr': 'Langue',
        'ko': '언어',
        'zh': '語言',
        'zh-TW': '语言',
      },
      '言語を選択してください': {
        'en': 'Please select a language.',
        'it': 'Seleziona una lingua.',
        'de': 'Bitte wählen Sie eine Sprache.',
        'es': 'Por favor, seleccione un idioma.',
        'fr': 'Veuillez sélectionner une langue.',
        'ko': '언어를 선택하세요',
        'zh': '請選擇一種語言。',
        'zh-TW': '请选择一种语言。',
      },
      '未選択一覧': {
        'en': 'Unclaimed Items',
        'it': 'Oggetti non riscossi',
        'de': 'Nicht abgeholte Artikel',
        'es': 'Artículos no reclamados',
        'fr': 'Articles non réclamés',
        'ko': '미수령 물품',
        'zh': '未領取物品',
        'zh-TW': '无人认领的物品',
      },
      '¥': {
        'en': '¥',
        'it': '¥',
        'de': '¥',
        'es': '¥',
        'fr': '¥',
        'ko': '¥',
        'zh': '¥',
        'zh-TW': '¥',
      },
      'システムエラーが発生しました。': {
        'en': 'Something went wrong. Please try again.',
        'it': 'Qualcosa è andato storto. Per favore, riprova.',
        'de': 'Etwas ist schiefgelaufen. Bitte versuchen Sie es erneut.',
        'es': 'Algo salió mal. Por favor, inténtalo de nuevo.',
        'fr': 'Une erreur s’est produite. Veuillez réessayer.',
        'ko': '문제가 발생했습니다. 다시 시도해 주세요.',
        'zh': '發生錯誤。請再試一次。',
        'zh-TW': '出了点问题。请再试一次。',
      },
      '発送済み一覧': {
        'en': 'Shipped Items List',
        'it': 'Elenco degli articoli spediti',
        'de': 'Liste der versendeten Artikel',
        'es': 'Lista de artículos enviados',
        'fr': 'Liste des articles expédiés',
        'ko': '배송된 목록',
        'zh': '已出貨物品清單',
        'zh-TW': '已发货物品清单',
      },
      '選択する': {
        'en': 'Select',
        'it': 'Selezionare',
        'de': 'Wählen',
        'es': 'Seleccionar',
        'fr': 'Sélectionner',
        'ko': '선택',
        'zh': '選擇',
        'zh-TW': '选择',
      },
      '1タップで「発送依頼」': {
        'en': 'What do you want to do?',
        'it': 'Che cosa vuoi fare?',
        'de': 'Was möchtest du tun?',
        'es': '¿Qué quieres hacer?',
        'fr': 'Que veux-tu faire ?',
        'ko': '무엇을 하고 싶으신가요?',
        'zh': '你想做什麼？',
        'zh-TW': '你想做什么？',
      },
      '2タップで「X marketで販売」（近日公開）となります。': {
        'en': '',
        'it': '',
        'de': '',
        'es': '',
        'fr': '',
        'ko': '',
        'zh': '',
        'zh-TW': '',
      },
      '本商品の内容は全て非公開となります。': {
        'en': 'The contents of this gtcha are all secret.',
        'it': 'Il contenuto di questo gtcha è tutto segreto.',
        'de': 'Der Inhalt dieses gtcha ist streng geheim.',
        'es': 'Innehållet i denna gtcha är hemligt.',
        'fr': 'Le contenu de ce gtcha est entièrement secret.',
        'ko': '이 gtcha의 내용은 모두 비밀입니다.',
        'zh': '此 gtcha 的內容都是秘密。',
        'zh-TW': '此验证码的内容都是秘密。',
      },
      '視聴上限人数を超えました': {
        'en': 'The maximum number of viewers has been exceeded',
        'it': 'È stato superato il numero massimo di spettatori',
        'de': 'Die maximale Zuschauerzahl wurde überschritten',
        'es': 'Se ha superado el número máximo de espectadores.',
        'fr': 'Le nombre maximum de spectateurs a été dépassé',
        'ko': '시청 상한 인원을 초과했습니다.',
        'zh': '已超過最大觀看人數',
        'zh-TW': '已超过最大观看人数',
      },
      '詳細はこちら': {
        'en': 'Detail',
        'it': 'dettaglio',
        'de': 'Detail',
        'es': 'detalle',
        'fr': 'détail',
        'ko': '상세',
        'zh': '細節',
        'zh-TW': '细节',
      },
      '買取コイン': {
        'en': 'Sell (to us)',
        'it': 'Vendi (a noi)',
        'de': 'An uns verkaufen',
        'es': 'Véndenos',
        'fr': 'Vendez-nous',
        'ko': '판매하기',
        'zh': '賣給我們',
        'zh-TW': '卖给我们',
      },
      'コインへ還元': {
        'en': 'Convert to coins',
        'it': 'Converti in monete',
        'de': 'In Münzen umwandeln',
        'es': 'Convertir a monedas',
        'fr': 'Convertir en pièces',
        'ko': '코인으로 변환',
        'zh': '轉換為金幣',
        'zh-TW': '换成硬币',
      },
      '買取ボーナス': {
        'en': 'Bonus to sell to us',
        'it': 'Bonus da vendere a noi',
        'de': 'Bonus für den Verkauf an uns',
        'es': 'Bono por vendernos',
        'fr': 'Bonus à nous vendre',
        'ko': '우리에게 판매하는 보너스',
        'zh': '賣給我們的獎金',
        'zh-TW': '卖给我们的奖金',
      },
      'ログイン状態を保持する': {
        'en': 'Stay logged in',
        'it': 'Rimani connesso',
        'de': 'Bleiben Sie eingeloggt',
        'es': 'Manténgase conectado',
        'fr': 'Restez connecté',
        'ko': '로그인 상태 유지',
        'zh': '保持登入狀態',
        'zh-TW': '保持登录状态',
      },
      'パスワードをお忘れですか？': {
        'en': 'Forgot your password?',
        'it': 'Hai dimenticato la password?',
        'de': 'Passwort vergessen?',
        'es': '¿Olvidaste tu contraseña?',
        'fr': 'Vous avez oublié votre mot de passe ?',
        'ko': '비밀번호를 잊으셨습니까?',
        'zh': '忘記密碼了嗎？',
        'zh-TW': '忘记密码了吗？',
      },
      '姓': {
        'en': 'First Name',
        'it': 'Nome',
        'de': 'Vorname',
        'es': 'Nombre',
        'fr': 'Prénom',
        'ko': '이름',
        'zh': '名字',
        'zh-TW': '名字',
      },
      'ミドルネーム': {
        'en': 'Middle Name',
        'it': 'Secondo nome',
        'de': 'Zweiter Vorname',
        'es': 'Segundo nombre',
        'fr': 'Deuxième prénom',
        'ko': '중간 이름',
        'zh': '中間名',
        'zh-TW': '中间名',
      },
      '名': {
        'en': 'Last Name',
        'it': 'Cognome',
        'de': 'Nachname',
        'es': 'Apellido',
        'fr': 'Nom de famille',
        'ko': '성',
        'zh': '姓氏',
        'zh-TW': '姓',
      },
      'パスワード確認': {
        'en': 'Confirm password',
        'it': 'Conferma password',
        'de': 'Passwort bestätigen',
        'es': 'Confirmar Contraseña',
        'fr': 'Confirmez le mot de passe',
        'ko': '비밀번호 확인',
        'zh': '確認密碼',
        'zh-TW': '确认密码',
      },
      '友達紹介コードを持っている': {
        'en': 'I have a referral code',
        'it': 'Ho un codice di invito amico',
        'de': 'Ich habe einen Freundesempfehlungscode.',
        'es': 'Tengo un código de referencia de un amigo.',
        'fr': 'J\'ai un code de parrainage d\'ami',
        'ko': '친구 소개 코드를 가지고',
        'zh': '我有一個朋友推薦碼',
        'zh-TW': '我有一个朋友推荐码',
      },
      '遊戯王': {
        'en': 'Yu-Gi-Oh!',
        'it': 'Yu-Gi-Oh!',
        'de': 'Yu-Gi-Oh!',
        'es': 'Yu-Gi-Oh!',
        'fr': 'Yu-Gi-Oh!',
        'ko': 'Yu-Gi-Oh!',
        'zh': 'Yu-Gi-Oh!',
        'zh-TW': 'Yu-Gi-Oh!',
      },
      'ヴァイスシュバルツ': {
        'en': 'Weiss Schwarz',
        'it': 'Weiss Schwarz',
        'de': 'Weiss Schwarz',
        'es': 'Weiss Schwarz',
        'fr': 'Weiss Schwarz',
        'ko': 'Weiss Schwarz',
        'zh': 'Weiss Schwarz',
        'zh-TW': 'Weiss Schwarz',
      },
      'ワンピース': {
        'en': 'One Piece',
        'it': 'One Piece',
        'de': 'One Piece',
        'es': 'One Piece',
        'fr': 'One Piece',
        'ko': '원피스',
        'zh': '航海王',
        'zh-TW': '航海王',
      },
      'ポケモン': {
        'en': 'Pokémon',
        'it': 'Pokémon',
        'de': 'Pokémon',
        'es': 'Pokémon',
        'fr': 'Pokémon',
        'ko': 'Pokémon',
        'zh': 'Pokémon',
        'zh-TW': 'Pokémon',
      },
      '※現金+査定額の1%分のコイン': {
        'en': '*Cash + 1% of the appraised value in coins',
        'it': '*Contanti + l\'1% del valore stimato in monete',
        'de': '*Bargeld + 1 % des Schätzwertes in Münzen',
        'es': '*Efectivo + 1% del valor tasado en monedas',
        'fr': 'Espèces + 1 % de la valeur estimée en pièces',
        'ko': '※현금+사정액의 1%분의 코인',
        'zh': '*現金 + 評估價值的 1%（以硬幣形式支付）',
        'zh-TW': '*现金 + 评估价值的 1%（以硬币形式支付）',
      },
      '※査定額の110%分のコイン': {
        'en': '*Coins equivalent to 110% of the appraised value',
        'it': '*Monete equivalenti al 110% del valore stimato',
        'de': '*Münzen im Wert von 110 % des Schätzwertes',
        'es': '*Monedas equivalentes al 110% del valor tasado',
        'fr': '*Pièces équivalentes à 110 % de la valeur estimée',
        'ko': '※사정액의 110%분의 코인',
        'zh': '*相當於評估價值110%的硬幣',
        'zh-TW': '*相当于评估价值110%的硬币',
      },
      'パスワード': {
        'en': 'password',
        'it': 'password',
        'de': 'Passwort',
        'es': 'contraseña',
        'fr': 'mot de passe',
        'ko': '비밀번호',
        'zh': '密碼',
        'zh-TW': '密码',
      },
      '現在のランクは「{rank}」です。': {
        'en': 'Current rank is "{rank}".',
        'it': 'Il rango attuale è "{rank}".',
        'de': 'Der aktuelle Rang ist „{rank}“.',
        'es': 'La clasificación actual es "{rank}".',
        'fr': 'Le classement actuel est "{rank}".',
        'ko': '현재 순위는 \'{rank}\'입니다.',
        'zh': '目前排名是“{rank}”。',
        'zh-TW': '当前排名是“{rank}”。',
      },
      'コインを使用しない場合、来月は「{rank}」ランクになります。': {
        'en': 'If you do not use Coin, you will be ranked as "White" next month.',
        'it': 'Se non usi le tue monete, sarai classificato "bianco" il mese prossimo.',
        'de': 'Wenn Sie Ihre Münzen nicht verwenden, werden Sie nächsten Monat als „weiß“ eingestuft.',
        'es': 'Si no usas tus monedas, serás clasificado como "blanco" el próximo mes.',
        'fr': 'Si vous n\'utilisez pas vos pièces, vous serez classé « blanc » le mois prochain.',
        'ko': '코인을 사용하지 않으면 다음 달은 "화이트"랭크가됩니다.',
        'zh': '如果你不使用你的硬幣，你將在下個月被評為「白」。',
        'zh-TW': '如果你不使用你的硬币，你将在下个月被评为“白”。',
      },
      '来月、「{rank}」からスタートするには {amount} コインが必要です。': {
        'en': 'You will need {amount} Coins to start at "{rank}" next month.',
        'it': 'Avrai bisogno di {importo} monete per iniziare da "{rank}" il mese prossimo.',
        'de': 'Sie benötigen {amount} Münzen, um nächsten Monat bei „{rank}“ zu beginnen.',
        'es': 'Necesitará {amount} monedas para comenzar en "{rank}" el próximo mes.',
        'fr': 'Vous aurez besoin de {amount} Coins pour commencer à "{rank}" le mois prochain.',
        'ko': '다음 달 "{rank}"에서 시작하려면 {amount} Coins가 필요합니다.',
        'zh': '您將需要 {amount} 金幣才能在下個月達到「{rank}」。',
        'zh-TW': '您将需要 {amount} 金币才能在下个月达到“{rank}”。',
      },
      'すでにランク維持を完了しています。': {
        'en': 'You have already completed rank maintenance.',
        'it': 'Hai già completato il mantenimento del grado.',
        'de': 'Sie haben die Rangerhaltung bereits abgeschlossen.',
        'es': 'Ya has completado el mantenimiento de rango.',
        'fr': 'Vous avez déjà terminé le maintien du rang.',
        'ko': '이미 순위 유지를 완료했습니다.',
        'zh': '您已經完成了等級維護。',
        'zh-TW': '您已经完成了等级维护。',
      },
      '未選択のお品物は24時間でコインへ自動変換されます': {
        'en': 'Unclaimed items will be converted to coins after 24 hours',
        'it': 'Gli oggetti non riscossi saranno convertiti in monete dopo 24 ore',
        'de': 'Nicht beanspruchte Gegenstände werden nach 24 Stunden in Münzen umgewandelt',
        'es': 'Los artículos no reclamados se convertirán en monedas después de 24 horas',
        'fr': 'Les objets non réclamés seront convertis en pièces après 24 heures.',
        'ko': '수령하지 않은 아이템은 24시간 후 코인으로 전환됩니다.',
        'zh': '未領取的物品將在 24 小時後轉換為硬幣',
        'zh-TW': '未领取的物品将在24小时后转换为金币',
      },
      'ランク維持してよろしいですか': {
        'en': 'Is it alright to maintain my current rank?',
        'it': 'Posso mantenere il mio grado attuale?',
        'de': 'Ist es in Ordnung, meinen aktuellen Rang beizubehalten?',
        'es': '¿Puedo mantener mi rango actual?',
        'fr': 'Est-ce que je peux conserver mon grade actuel ?',
        'ko': '순위를 유지하시겠습니까?',
        'zh': '我可以維持目前的軍階嗎？',
        'zh-TW': '我可以维持目前的军衔吗？',
      },
      'ランク維持確認': {
        'en': 'Rank maintenance confirmation',
        'it': 'Conferma del mantenimento del grado',
        'de': 'Bestätigung der Rangbeibehaltung',
        'es': 'confirmación de mantenimiento de rango',
        'fr': 'confirmation de maintien de grade',
        'ko': '랭크 유지 확인',
        'zh': '等級維持確認',
        'zh-TW': '等级维持确认',
      },
      '支払う': {
        'en': 'pay',
        'it': 'paga',
        'de': 'zahlen',
        'es': 'pagar',
        'fr': 'payer',
        'ko': '지불하다',
        'zh': '支付',
        'zh-TW': '支付',
      },
      'ランク維持': {
        'en': 'Keep your rank',
        'it': 'Mantieni il tuo grado',
        'de': 'Behalte deinen Rang',
        'es': 'Mantén tu rango',
        'fr': 'Gardez votre rang',
        'ko': '직위를 유지하세요',
        'zh': '保持你的階級',
        'zh-TW': '保持你的排名',
      },
      'ランク維持が完了しました': {
        'en': 'Rank kept is complete',
        'it': 'Il rango mantenuto è completo',
        'de': 'Rang beibehalten ist abgeschlossen',
        'es': 'Rango mantenido está completo',
        'fr': 'Classement conservé est complet',
        'ko': '랭크 유지가 완료되었습니다',
        'zh': '保留階級已完成',
        'zh-TW': '保级已完成',
      },
      '{num}枚セット': {
        'en': '{num} pieces set',
        'it': '{num} pezzi impostati',
        'de': '{num} Teilesatz',
        'es': 'conjunto de {num} piezas',
        'fr': 'Ensemble de {num} pièces',
        'ko': '{num}매 세트',
        'zh': '{num} 件套裝',
        'zh-TW': '{num} 件套装',
      },
      '州': {
        'en': 'state',
        'it': 'stato',
        'de': 'Zustand',
        'es': 'estado',
        'fr': 'État',
        'ko': '주',
        'zh': '狀態',
        'zh-TW': '状态',
      },
      'この販売者のガチャ一覧': {
        'en': 'This seller\'s gacha list',
        'it': 'Lista gacha di questo venditore',
        'de': 'Gacha-Liste dieses Verkäufers',
        'es': 'Lista de gacha de este vendedor',
        'fr': 'Liste gacha de ce vendeur',
        'ko': '이 판매자의 뽑기 목록',
        'zh': '該賣家的扭蛋列表',
        'zh-TW': '该卖家的扭蛋列表',
      },
      'まだ販売されている商品がありません': {
        'en': 'There are no products currently available for sale.',
        'it': 'Al momento non sono disponibili prodotti in vendita.',
        'de': 'Es sind derzeit keine Produkte zum Verkauf verfügbar.',
        'es': 'Actualmente no hay productos disponibles para la venta.',
        'fr': 'Aucun produit n\'est actuellement disponible à la vente.',
        'ko': '아직 판매되는 상품이 없습니다.',
        'zh': '目前沒有可供出售的產品。',
        'zh-TW': '目前没有可供出售的产品。',
      },
      '入力情報を確認': {
        'en': 'Confirm input information',
        'it': 'Conferma le informazioni inserite',
        'de': 'Eingabeinformationen bestätigen',
        'es': 'Confirme la información ingresada',
        'fr': 'Confirmer les informations saisies',
        'ko': '입력 정보 확인',
        'zh': '確認輸入訊息',
        'zh-TW': '确认输入信息',
      },
      '送信': {
        'en': 'send',
        'it': 'Inviare',
        'de': 'schicken',
        'es': 'enviar',
        'fr': 'envoyer',
        'ko': '전송',
        'zh': '傳送',
        'zh-TW': '发送',
      },
      '販売者一覧': {
        'en': 'List of sellers',
        'it': 'Elenco dei venditori',
        'de': 'Liste der Verkäufer',
        'es': 'Lista de vendedores',
        'fr': 'Liste des vendeurs',
        'ko': '판매자 목록',
        'zh': '賣家列表',
        'zh-TW': '卖家列表',
      },
      'ホビー系': {
        'en': 'Hobby-related',
        'it': 'Legato agli hobby',
        'de': 'Hobbybezogen',
        'es': 'Relacionado con pasatiempos',
        'fr': 'lié aux loisirs',
        'ko': '취미계',
        'zh': '與嗜好相關的',
        'zh-TW': '与爱好相关的',
      },
      'アイドル': {
        'en': 'idol',
        'it': 'idolo',
        'de': 'Idol',
        'es': 'ídolo',
        'fr': 'idole',
        'ko': '아이돌',
        'zh': '偶像',
        'zh-TW': '偶像',
      },
      'お酒': {
        'en': 'alcohol',
        'it': 'alcol',
        'de': 'Alkohol',
        'es': 'alcohol',
        'fr': 'alcool',
        'ko': '술',
        'zh': '酒精',
        'zh-TW': '酒精',
      },
      '電子機器': {
        'en': 'electronic equipment',
        'it': 'apparecchiature elettroniche',
        'de': 'elektronische Geräte',
        'es': 'equipos electrónicos',
        'fr': 'équipement électronique',
        'ko': '전자기기',
        'zh': '電子設備',
        'zh-TW': '电子设备',
      },
      '釣り': {
        'en': 'fishing',
        'it': 'pesca',
        'de': 'Angeln',
        'es': 'pesca',
        'fr': 'pêche',
        'ko': '낚시',
        'zh': '釣魚',
        'zh-TW': '钓鱼',
      },
      '宝石': {
        'en': 'jewelry ',
        'it': 'gioielli',
        'de': 'Schmuck',
        'es': 'joyas ',
        'fr': 'bijoux ',
        'ko': '보석',
        'zh': '珠寶',
        'zh-TW': '珠宝 ',
      },
      '食べ物': {
        'en': 'food',
        'it': 'cibo',
        'de': 'Essen',
        'es': 'alimento',
        'fr': 'nourriture',
        'ko': '음식',
        'zh': '食物',
        'zh-TW': '食物',
      },
      'ご当地': {
        'en': 'Local',
        'it': 'Locale',
        'de': 'Lokal',
        'es': 'Local',
        'fr': 'Locale',
        'ko': '현지',
        'zh': '當地的',
        'zh-TW': '当地的',
      },
      'アニメ': {
        'en': 'anime',
        'it': 'canzoni',
        'de': 'Anime',
        'es': 'anime',
        'fr': 'anime',
        'ko': '애니메이션',
        'zh': '日本卡通',
        'zh-TW': '日本动画片',
      },
      'スニーカー': {
        'en': 'sneakers',
        'it': 'scarpe da ginnastica',
        'de': 'Turnschuhe',
        'es': 'zapatillas',
        'fr': 'baskets',
        'ko': '운동화',
        'zh': '運動鞋',
        'zh-TW': '运动鞋',
      },
      'ブランド': {
        'en': 'brand',
        'it': 'marca',
        'de': 'Marke',
        'es': 'marca',
        'fr': 'marque',
        'ko': '브랜드',
        'zh': '品牌',
        'zh-TW': '品牌',
      },
      'パスワード入力': {
        'en': 'Enter password',
        'it': 'Inserisci la password',
        'de': 'Passwort eingeben',
        'es': 'Introduzca la contraseña',
        'fr': 'Saisissez le mot de passe',
        'ko': '비밀번호 입력',
        'zh': '輸入密碼',
        'zh-TW': '输入密码',
      },
      'パスワードは必須です。': {
        'en': 'A password is required.',
        'it': 'È necessaria una password.',
        'de': 'Ein Passwort ist erforderlich.',
        'es': 'Se requiere una contraseña.',
        'fr': 'Un mot de passe est requis.',
        'ko': '암호는 필수입니다.',
        'zh': '需要密碼。',
        'zh-TW': '需要密码。',
      },
      '商品が見つかりません。': {
        'en': 'The product could not be found.',
        'it': 'Prodotto non trovato.',
        'de': 'Das Produkt konnte nicht gefunden werden.',
        'es': 'No se pudo encontrar el producto.',
        'fr': 'Le produit est introuvable.',
        'ko': '상품을 찾을 수 없습니다.',
        'zh': '找不到該產品。',
        'zh-TW': '找不到该产品。',
      },
      'ログインが必要です。': {
        'en': 'Login is required.',
        'it': 'È necessario effettuare l\'accesso.',
        'de': 'Anmeldung erforderlich.',
        'es': 'Es necesario iniciar sesión.',
        'fr': 'Connexion requise.',
        'ko': '로그인이 필요합니다.',
        'zh': '需要登入。',
        'zh-TW': '需要登录。',
      },
      'パスワードが一致しません。': {
        'en': 'Passwords do not match.',
        'it': 'Le password non corrispondono.',
        'de': 'Die Passwörter stimmen nicht überein.',
        'es': 'Las contraseñas no coinciden.',
        'fr': 'Les mots de passe ne correspondent pas.',
        'ko': '비밀번호가 일치하지 않습니다.',
        'zh': '密碼不符。',
        'zh-TW': '密码不匹配。',
      },
      'パスワードログを保存しました。': {
        'en': 'The password log has been saved.',
        'it': 'Il registro delle password è stato salvato.',
        'de': 'Das Passwortprotokoll wurde gespeichert.',
        'es': 'El registro de contraseñas se ha guardado.',
        'fr': 'Le journal des mots de passe a été enregistré.',
        'ko': '비밀번호 로그를 저장했습니다.',
        'zh': '密碼日誌已儲存。',
        'zh-TW': '密码日志已保存。',
      },
      '株式会社A': {
        'en': 'Company A',
        'it': 'Azienda A',
        'de': 'Firma A',
        'es': 'Compañía A',
        'fr': 'Société A',
        'ko': '주식회사 A',
        'zh': 'A公司',
        'zh-TW': 'A公司',
      },
      'Xmarket出品リスト': {
        'en': 'My Xmarket Sales List',
        'it': 'La mia lista di vendite Xmarket',
        'de': 'Meine Xmarket-Verkaufsliste',
        'es': 'Min Xmarket Försäljningslista',
        'fr': 'Ma liste de ventes Xmarket',
        'ko': '내 Xmarket 판매 목록',
        'zh': '我的 Xmarket 銷售清單',
        'zh-TW': '我的Xmarket销售清单',
      },
      '販売する': {
        'en': 'To sell',
        'it': 'Vendere',
        'de': 'Verkaufen',
        'es': 'Sälja',
        'fr': 'Vendre',
        'ko': '판매하다',
        'zh': '出售',
        'zh-TW': '出售',
      },
      '販売価格を入力してください': {
        'en': 'Selling Price',
        'it': 'Prezzo di vendita',
        'de': 'Verkaufspreis',
        'es': 'Försäljningspris',
        'fr': 'Prix de vente',
        'ko': '판매 가격',
        'zh': '售價',
        'zh-TW': '售价',
      },
      'オークションとしてこの価格からマーケットに出品': {
        'en': 'This price will be used to put the item up for auction on the market.',
        'it': 'Questo prezzo verrà utilizzato per mettere l\'oggetto all\'asta sul mercato.',
        'de': 'Dieser Preis dient als Grundlage für die Versteigerung des Artikels auf dem Markt.',
        'es': 'Este precio se utilizará para subastar el artículo en el mercado.',
        'fr': 'Ce prix servira à mettre l\'article aux enchères sur le marché.',
        'ko': '경매로 이 가격에서 시장에 출품',
        'zh': '這個價格將用於將該物品放到市場上拍賣。',
        'zh-TW': '这个价格将用于将该物品放到市场上拍卖。',
      },
      '%d秒': {
        'en': '%d seconds',
        'it': '%d secondi',
        'de': '%d Sekunden',
        'es': '%d segundos',
        'fr': '%d secondes',
        'ko': '%d초',
        'zh': '%d 秒',
        'zh-TW': '%d 秒',
      },
      '%d分': {
        'en': '%d minutes',
        'it': '%d minuti',
        'de': '%d Minuten',
        'es': '%d minutos',
        'fr': '%d minutes',
        'ko': '%d분',
        'zh': '%d 分鐘',
        'zh-TW': '%d 分钟',
      },
      '%d時間': {
        'en': '%d hours',
        'it': '%d ore',
        'de': '%d Stunden',
        'es': '%d horas',
        'fr': '%d heures',
        'ko': '%d시간',
        'zh': '%d 小時',
        'zh-TW': '%d 小时',
      },
      '金額は{min}円以上になるように設定してください': {
        'en': 'Please set the amount to be at least {min} yen.',
        'it': 'Si prega di impostare l\'importo ad almeno {min} yen.',
        'de': 'Bitte geben Sie einen Betrag von mindestens {min} Yen an.',
        'es': 'Por favor, establezca la cantidad en al menos {min} yenes.',
        'fr': 'Veuillez fixer le montant à au moins {min} yens.',
        'ko': '금액은 {min}엔 이상이 되도록 설정하세요.',
        'zh': '請將金額設定為至少 {min} 日圓。',
        'zh-TW': '请将金额设置为至少 {min} 日元。',
      },
      '小計': {
        'en': 'subtotal',
        'it': 'subtotale',
        'de': 'Zwischensumme',
        'es': 'total parcial',
        'fr': 'total',
        'ko': '소계',
        'zh': '小計',
        'zh-TW': '小计',
      },
      '送料': {
        'en': 'postage',
        'it': 'affrancatura',
        'de': 'Porto',
        'es': 'franqueo',
        'fr': 'affranchissement',
        'ko': '우송료',
        'zh': '郵資',
        'zh-TW': '邮资',
      },
      '合計': {
        'en': 'total',
        'it': 'totale',
        'de': 'gesamt',
        'es': 'total',
        'fr': 'total',
        'ko': '합계',
        'zh': '全部的',
        'zh-TW': '全部的',
      },
      'カート': {
        'en': 'cart',
        'it': 'carrello',
        'de': 'Warenkorb',
        'es': 'carro',
        'fr': 'chariot',
        'ko': '장바구니',
        'zh': '大車',
        'zh-TW': '大车',
      },
      '数量': {
        'en': 'quantity',
        'it': 'quantità',
        'de': 'Menge',
        'es': 'cantidad',
        'fr': 'quantité',
        'ko': '수량',
        'zh': '數量',
        'zh-TW': '数量',
      },
      'カート商品が見つかりません': {
        'en': 'No items found in your cart.',
        'it': 'Nessun articolo trovato nel carrello.',
        'de': 'In Ihrem Warenkorb wurden keine Artikel gefunden.',
        'es': 'No se encontraron artículos en su carrito.',
        'fr': 'Aucun article trouvé dans votre panier.',
        'ko': '장바구니 상품을 찾을 수 없음',
        'zh': '您的購物車中沒有找到商品。',
        'zh-TW': '您的购物车中没有找到商品。',
      },
      '新たにカードを登録する': {
        'en': 'Register a new card',
        'it': 'Registra una nuova carta',
        'de': 'Neue Karte registrieren',
        'es': 'Registra una nueva tarjeta',
        'fr': 'Enregistrer une nouvelle carte',
        'ko': '새 카드 등록',
        'zh': '註冊新卡',
        'zh-TW': '注册新卡',
      },
      'カード情報の保存に失敗しました。(既に登録されているなど)': {
        'en': 'Failed to save card information. (e.g., already registered)',
        'it': 'Impossibile salvare i dati della carta. (ad esempio, carta già registrata)',
        'de': 'Die Karteninformationen konnten nicht gespeichert werden. (z. B. bereits registriert)',
        'es': 'No se pudo guardar la información de la tarjeta. (p. ej., ya está registrada)',
        'fr': 'Impossible d\'enregistrer les informations de la carte. (Par exemple, déjà enregistrée)',
        'ko': '카드 정보를 저장하지 못했습니다. (이미 등록된 등)',
        'zh': '保存卡片資訊失敗。 （例如，已註冊）',
        'zh-TW': '保存卡片信息失败。（例如，已注册）',
      },
      'カード情報の削除に失敗しました。': {
        'en': 'Card information deletion failed.',
        'it': 'L\'eliminazione delle informazioni della carta non è riuscita.',
        'de': 'Das Löschen der Karteninformationen ist fehlgeschlagen.',
        'es': 'No se pudo eliminar la información de la tarjeta.',
        'fr': 'La suppression des informations de la carte a échoué.',
        'ko': '카드 정보를 삭제하지 못했습니다.',
        'zh': '卡片資訊刪除失敗。',
        'zh-TW': '卡片信息删除失败。',
      },
      'このカード情報を保存する': {
        'en': 'Save this card information',
        'it': 'Salva le informazioni di questa carta',
        'de': 'Diese Karteninformationen speichern',
        'es': 'Guarda esta información de la tarjeta',
        'fr': 'Conservez les informations de cette carte',
        'ko': '이 카드 정보 저장',
        'zh': '儲存此卡片訊息',
        'zh-TW': '保存此卡片信息',
      },
      '出金申請': {
        'en': 'Withdrawal application',
        'it': 'Domanda di recesso',
        'de': 'Antrag auf Rücknahme',
        'es': 'Solicitud de desistimiento',
        'fr': 'Demande de retrait',
        'ko': '출금 신청',
        'zh': '提款申請',
        'zh-TW': '提款申请',
      },
      '出金可能額': {
        'en': 'Amount that can be withdrawn',
        'it': 'Importo prelevabile',
        'de': 'Abhebbarer Betrag',
        'es': 'Cantidad que se puede retirar',
        'fr': 'Montant pouvant être retiré',
        'ko': '출금 가능액',
        'zh': '可提取金額',
        'zh-TW': '可提取金额',
      },
      '振込金額': {
        'en': 'Transfer amount',
        'it': 'Importo del trasferimento',
        'de': 'Überweisungsbetrag',
        'es': 'Importe de la transferencia',
        'fr': 'Montant du transfert',
        'ko': '송금 금액',
        'zh': '轉帳金額',
        'zh-TW': '转账金额',
      },
      '振込方法': {
        'en': 'Bank transfer method',
        'it': 'Metodo di bonifico bancario',
        'de': 'Banküberweisungsmethode',
        'es': 'Método de transferencia bancaria',
        'fr': 'méthode de virement bancaire',
        'ko': '송금 방법',
        'zh': '銀行轉帳方式',
        'zh-TW': '银行转账方式',
      },
      '振込額3万円未満は350円の振込手数料がかかります。': {
        'en': 'The receiving fee will be deducted from the sending amount.',
        'it': 'Die Empfangsgebühr wird vom Sendebetrag abgezogen.',
        'de': 'La tarifa de recepción se deducirá del monto de envío.',
        'es': 'Les frais de réception seront déduits du montant de l\'envoi.',
        'fr': '수수료는 송금액보다 공제됩니다.',
        'ko': '接收費用將從發送金額中扣除。',
        'zh': '接收费用将从发送金额中扣除。',
        'zh-TW': '接收费用将从发送金额中扣除。',
      },
      '振込申請日の5営業日後に送金させていただきます。': {
        'en': 'We will transfer the funds five business days after the date of your transfer request.',
        'it': 'Il trasferimento dei fondi avverrà entro cinque giorni lavorativi dalla data della richiesta di bonifico.',
        'de': 'Wir werden die Gelder fünf Werktage nach Eingang Ihres Überweisungsauftrags überweisen.',
        'es': 'Realizaremos la transferencia de fondos cinco días hábiles después de la fecha de su solicitud de transferencia.',
        'fr': 'Nous effectuerons le virement dans les cinq jours ouvrables suivant la date de votre demande de virement.',
        'ko': '송금 신청일의 5 영업일 후에 송금하겠습니다.',
        'zh': '我們將在您提出轉帳請求後的五個工作天內轉帳。',
        'zh-TW': '我们将在您提出转账请求后的五个工作日内转账。',
      },
      '申請する': {
        'en': 'Apply',
        'it': 'Fare domanda a',
        'de': 'Anwenden',
        'es': 'Aplicar',
        'fr': 'Appliquer',
        'ko': '신청하다',
        'zh': '申請',
        'zh-TW': '申请',
      },
      '出金申請履歴': {
        'en': 'Withdrawal request history',
        'it': 'Cronologia delle richieste di prelievo',
        'de': 'Auszahlungsanfragehistorie',
        'es': 'Historial de solicitudes de retiro',
        'fr': 'Historique des demandes de retrait',
        'ko': '출금 신청 이력',
        'zh': '提款申請歷史記錄',
        'zh-TW': '提款申请历史记录',
      },
      '申請日': {
        'en': 'Date',
        'it': 'Data',
        'de': 'Datum',
        'es': 'Datum',
        'fr': 'Date',
        'ko': '날짜',
        'zh': '日期',
        'zh-TW': '日期',
      },
      '振込日': {
        'en': 'Transfer date',
        'it': 'Data di trasferimento',
        'de': 'Übertragungsdatum',
        'es': 'Fecha de transferencia',
        'fr': 'Date de transfert',
        'ko': '송금일',
        'zh': '轉會日期',
        'zh-TW': '转会日期',
      },
      '未振込': {
        'en': 'Unpaid',
        'it': 'Non pagato',
        'de': 'Unbezahlt',
        'es': 'No pagado',
        'fr': 'Non rémunéré',
        'ko': '미송금',
        'zh': '未付',
        'zh-TW': '未付',
      },
      '振込済': {
        'en': 'Payment made',
        'it': 'Pagamento effettuato',
        'de': 'Zahlung erfolgt',
        'es': 'Pago realizado',
        'fr': 'Paiement effectué',
        'ko': '송금',
        'zh': '已付款',
        'zh-TW': '已付款',
      },
      '口座番号': {
        'en': 'account number',
        'it': 'numero di conto',
        'de': 'Kontonummer',
        'es': 'número de cuenta',
        'fr': 'numéro de compte',
        'ko': '계좌 번호',
        'zh': '帳號',
        'zh-TW': '帐号',
      },
      '販売価格を決める': {
        'en': 'To sell',
        'it': 'Vendere',
        'de': 'Verkaufen',
        'es': 'Att sälja',
        'fr': 'Vendre',
        'ko': '판매하다',
        'zh': '出售',
        'zh-TW': '出售',
      },
      '未出品': {
        'en': 'Waiting for sale',
        'it': 'In attesa di vendita',
        'de': 'Warten auf den Verkauf',
        'es': 'Väntar på rea',
        'fr': 'En attente de vente',
        'ko': '세일 기다리는 중',
        'zh': '等待出售',
        'zh-TW': '等待出售',
      },
      '出品待ち/出品中': {
        'en': 'Now on sale',
        'it': 'Ora in vendita',
        'de': 'Jetzt im Angebot',
        'es': 'Nu till salu',
        'fr': 'En vente maintenant',
        'ko': '지금 판매 중',
        'zh': '現正特價',
        'zh-TW': '现正出售',
      },
      '完売': {
        'en': 'Sold out',
        'it': 'Esaurito',
        'de': 'Ausverkauft',
        'es': 'Agotado',
        'fr': 'épuisé',
        'ko': '매진',
        'zh': '售罄',
        'zh-TW': '售罄',
      },
      '全タイトル': {
        'en': 'All Titles',
        'it': 'Tutti i titoli',
        'de': 'Alle Titel',
        'es': 'Todos los títulos',
        'fr': 'Tous les titres',
        'ko': '모든 타이틀',
        'zh': '所有標題',
        'zh-TW': '所有标题',
      },
      '詳細検索': {
        'en': 'Advanced Search',
        'it': 'Ricerca avanzata',
        'de': 'Erweiterte Suche',
        'es': 'Búsqueda avanzada',
        'fr': 'Recherche avancée',
        'ko': '고급 검색',
        'zh': '進階搜尋',
        'zh-TW': '高级搜索',
      },
      '傷あり品を除く': {
        'en': 'Excluding items with damage.',
        'it': 'Sono esclusi gli articoli danneggiati.',
        'de': 'Ausgenommen sind beschädigte Gegenstände.',
        'es': 'Excluyendo artículos dañados.',
        'fr': 'À l\'exception des articles endommagés.',
        'ko': '긁힌 물건을 제외하다',
        'zh': '不包括有損壞的物品。',
        'zh-TW': '不包括有损坏的物品。',
      },
      '傷あり品のみ表示': {
        'en': 'Display only damaged items',
        'it': 'Nur beschädigte Artikel anzeigen',
        'de': 'Mostrar solo artículos dañados',
        'es': 'Afficher uniquement les articles endommagés',
        'fr': '데미지품만 표시',
        'ko': '僅顯示損壞的物品',
        'zh': '仅显示损坏的物品',
        'zh-TW': '仅显示损坏的物品',
      },
      '表示順': {
        'en': 'Display order',
        'it': 'Ordine di visualizzazione',
        'de': 'Anzeigereihenfolge',
        'es': 'Mostrar orden',
        'fr': 'Afficher l\'ordre',
        'ko': '표시 순서',
        'zh': '顯示順序',
        'zh-TW': '显示顺序',
      },
      'キーワード検索': {
        'en': 'Keyword search',
        'it': 'Ricerca per parole chiave',
        'de': 'Stichwortsuche',
        'es': 'Búsqueda por palabras clave',
        'fr': 'Recherche par mots clés',
        'ko': '키워드 검색',
        'zh': '關鍵字搜尋',
        'zh-TW': '关键词搜索',
      },
      '価格が高い順': {
        'en': 'Sort by price (highest first)',
        'it': 'Ordina per prezzo (dal più alto al più basso)',
        'de': 'Nach Preis sortieren (höchster Preis zuerst)',
        'es': 'Ordenar por precio (del más alto al más bajo)',
        'fr': 'Trier par prix (du plus élevé au plus bas)',
        'ko': '가격이 높은 순서',
        'zh': '依價格排序（價格最高排在最前面）',
        'zh-TW': '按价格排序（价格最高排在最前面）',
      },
      '価格が安い順': {
        'en': 'Sort by price (lowest first)',
        'it': 'Ordina per prezzo (dal più basso al più alto)',
        'de': 'Nach Preis sortieren (niedrigster Preis zuerst)',
        'es': 'Ordenar por precio (del más bajo al más alto)',
        'fr': 'Trier par prix (du plus bas au plus bas)',
        'ko': '가격이 싼 순서',
        'zh': '依價格排序（價格最低排在最前面）',
        'zh-TW': '按价格排序（价格最低排在最前面）',
      },
      'クリア': {
        'en': 'Clear',
        'it': 'Chiaro',
        'de': 'Klar',
        'es': 'Claro',
        'fr': 'Clair',
        'ko': '클리어',
        'zh': '清除',
        'zh-TW': '清除',
      },
      '検索': {
        'en': 'Search',
        'it': 'cerca',
        'de': 'suchen',
        'es': 'buscar',
        'fr': 'recherche',
        'ko': '검색',
        'zh': '搜尋',
        'zh-TW': '搜索',
      },
      '販売中のみ表示': {
        'en': 'Only items currently for sale will be displayed.',
        'it': 'Verranno visualizzati solo gli articoli attualmente in vendita.',
        'de': 'Es werden nur Artikel angezeigt, die aktuell zum Verkauf stehen.',
        'es': 'Solo se mostrarán los artículos que estén actualmente a la venta.',
        'fr': 'Seuls les articles actuellement en vente seront affichés.',
        'ko': '판매 중에만 표시',
        'zh': '僅顯示目前在售商品。',
        'zh-TW': '仅显示当前在售商品。',
      },
      'カートへ': {
        'en': 'Buy',
        'it': 'Compra',
        'de': 'Kaufen',
        'es': 'Köp',
        'fr': 'Acheter',
        'ko': '구매',
        'zh': '購買',
        'zh-TW': '购买',
      },
      '終了': {
        'en': 'end',
        'it': 'FINE',
        'de': 'Ende',
        'es': 'fin',
        'fr': 'fin',
        'ko': '종료',
        'zh': '結尾',
        'zh-TW': '结尾',
      },
      '現在': {
        'en': 'the current',
        'it': 'il corrente',
        'de': 'die jetzige',
        'es': 'la corriente',
        'fr': 'le courant',
        'ko': '현재',
        'zh': '目前',
        'zh-TW': '当前',
      },
      '銀行振込': {
        'en': 'Bank transfer',
        'it': 'Bonifico bancario',
        'de': 'Banküberweisung',
        'es': 'Transferencia bancaria',
        'fr': 'Virement bancaire',
        'ko': '은행 송금',
        'zh': '銀行轉帳',
        'zh-TW': '银行转账',
      },
      '申請中': {
        'en': 'Currently applying',
        'it': 'Attualmente in fase di candidatura',
        'de': 'Ich bewerbe mich derzeit.',
        'es': 'Actualmente estoy solicitando',
        'fr': 'Candidature en cours',
        'ko': '신청 중',
        'zh': '目前正在申請',
        'zh-TW': '目前正在申请',
      },
      '保存する': {
        'en': 'Save',
        'it': 'Salva',
        'de': 'Speichern',
        'es': 'Ahorrar',
        'fr': 'Sauvegarder',
        'ko': '저장하다',
        'zh': '節省',
        'zh-TW': '节省',
      },
      'スピード入金を利用する(翌営業日の送金)': {
        'en': 'Use the expedited deposit service (transfer on the next business day)',
        'it': 'Utilizza il servizio di deposito rapido (trasferimento entro il giorno lavorativo successivo).',
        'de': 'Nutzen Sie den Express-Einzahlungsservice (Überweisung am nächsten Werktag).',
        'es': 'Utilice el servicio de depósito exprés (transferencia al siguiente día hábil).',
        'fr': 'Utilisez le service de dépôt express (virement le jour ouvrable suivant).',
        'ko': '스피드 입금을 이용한다(다음 영업일의 송금)',
        'zh': '使用加急存款服務（下一個工作日到帳）',
        'zh-TW': '使用加急存款服务（下一个工作日到账）',
      },
      '振込先情報': {
        'en': 'Bank transfer information',
        'it': 'Informazioni sul bonifico bancario',
        'de': 'Informationen zur Banküberweisung',
        'es': 'Información sobre transferencias bancarias',
        'fr': 'Informations sur les virements bancaires',
        'ko': '송금처 정보',
        'zh': '銀行轉帳資訊',
        'zh-TW': '银行转账信息',
      },
      '削除': {
        'en': 'delete',
        'it': 'eliminare',
        'de': 'löschen',
        'es': 'borrar',
        'fr': 'supprimer',
        'ko': '삭제',
        'zh': '刪除',
        'zh-TW': '删除',
      },
      '申請振込金額': {
        'en': 'Requested Amount',
        'it': 'Importo Richiesto',
        'de': 'Angeforderter Betrag',
        'es': 'Begärd belopp',
        'fr': 'Montant demandé',
        'ko': '요청 금액',
        'zh': '申請金額',
        'zh-TW': '申请金额',
      },
      '申請確認': {
        'en': 'Application confirmation',
        'it': 'Conferma dell\'applicazione',
        'de': 'Antragsbestätigung',
        'es': 'Confirmación de la solicitud',
        'fr': 'Confirmation de la demande',
        'ko': '신청 확인',
        'zh': '申請確認',
        'zh-TW': '申请确认',
      },
      '振込手数料': {
        'en': 'Bank transfer fee',
        'it': 'commissione per bonifico bancario',
        'de': 'Banküberweisungsgebühr',
        'es': 'comisión por transferencia bancaria',
        'fr': 'Frais de virement bancaire',
        'ko': '송금 수수료',
        'zh': '銀行轉帳手續費',
        'zh-TW': '银行转账手续费',
      },
      'ホビー': {
        'en': 'Hobby',
        'it': 'Hobby',
        'de': 'Hobby',
        'es': 'Pasatiempo',
        'fr': 'Passe-temps',
        'ko': '취미',
        'zh': '嗜好',
        'zh-TW': '爱好',
      },
      '選択してください': {
        'en': 'please select',
        'it': 'seleziona',
        'de': 'Bitte auswählen',
        'es': 'Por favor, seleccione',
        'fr': 'Veuillez sélectionner',
        'ko': '선택해주세요',
        'zh': '請選擇',
        'zh-TW': '请选择',
      },
      'Xmarketのご利用ありがとうございました': {
        'en': 'Thank you for using Xmarket.',
        'it': 'Grazie per aver utilizzato Xmarket.',
        'de': 'Vielen Dank, dass Sie Xmarket nutzen.',
        'es': 'Gracias por usar Xmarket.',
        'fr': 'Merci d\'avoir utilisé Xmarket.',
        'ko': 'Xmarket를 이용해 주셔서 감사합니다.',
        'zh': '感謝您使用Xmarket。',
        'zh-TW': '感谢您使用Xmarket。',
      },
      '購入完了': {
        'en': 'Purchase complete',
        'it': 'Acquisto completato',
        'de': 'Kauf abgeschlossen',
        'es': 'Compra completa',
        'fr': 'Achat complet',
        'ko': '구매 완료',
        'zh': '購買完成',
        'zh-TW': '购买完成',
      },
      '入金済み': {
        'en': 'Payment completed',
        'it': 'Pagamento completato',
        'de': 'Zahlung abgeschlossen',
        'es': 'Betalning slutförd',
        'fr': 'Paiement effectué',
        'ko': '결제 완료',
        'zh': '付款完成',
        'zh-TW': '付款完成',
      },
      'XMarket': {
        'en': 'XMarket',
        'it': 'XMarket',
        'de': 'XMarket',
        'es': 'Mercado X',
        'fr': 'XMarket',
        'ko': 'XMarket',
        'zh': 'XMarket',
        'zh-TW': 'XMarket',
      },
      '申請履歴はありません': {
        'en': 'No application history exists.',
        'it': 'Non esiste alcuna cronologia delle applicazioni.',
        'de': 'Es ist keine Bewerbungshistorie vorhanden.',
        'es': 'No existe historial de solicitudes.',
        'fr': 'Aucun historique de candidature n\'existe.',
        'ko': '신청 내역 없음',
        'zh': '沒有申請記錄。',
        'zh-TW': '没有申请记录。',
      },
      '未入金': {
        'en': 'Unpaid',
        'it': 'Non pagato',
        'de': 'Unbezahlt',
        'es': 'No pagado',
        'fr': 'Non rémunéré',
        'ko': '미입금',
        'zh': '未付',
        'zh-TW': '未付',
      },
      '{min}円以上の価格で出品できます。当該ガチャの販売終了後に出品されます。': {
        'en': 'Items can be sold at a price of {min} yen or more.',
        'it': 'Gli articoli possono essere venduti a un prezzo di {min} yen o più.',
        'de': 'Artikel können zu einem Preis von {min} Yen oder mehr verkauft werden.',
        'es': 'Varor kan säljas till ett pris av {min} yen eller mer.',
        'fr': 'Les articles peuvent être vendus à un prix de {min} yens ou plus.',
        'ko': '품목은 {min} 엔 이상으로 판매할 수 있습니다.',
        'zh': '商品可以以 {min} 日圓或以上的價格出售。',
        'zh-TW': '商品可以以 {min} 日元或以上的价格出售。',
      },
      'パラメータが不足しています': {
        'en': 'The parameter is missing.',
        'it': 'Il parametro è mancante.',
        'de': 'Der Parameter fehlt.',
        'es': 'Falta el parámetro.',
        'fr': 'Le paramètre est manquant.',
        'ko': '매개변수가 부족함',
        'zh': '缺少參數。',
        'zh-TW': '缺少参数。',
      },
      '出品対象外品': {
        'en': 'Cannot be sold to Xmarket',
        'it': 'Non può essere venduto a Xmarket',
        'de': 'Kann nicht an Xmarket verkauft werden.',
        'es': 'No se puede vender a Xmarket',
        'fr': 'Ne peut être vendu à Xmarket',
        'ko': 'Xmarket에 판매 불가',
        'zh': '不得出售給 Xmarket',
        'zh-TW': '不得出售给 Xmarket',
      },
      '購入手続きへ': {
        'en': 'To checkout',
        'it': 'Per il checkout',
        'de': 'Zur Kasse gehen',
        'es': 'To checkout',
        'fr': 'Passer à la caisse',
        'ko': '체크아웃하기',
        'zh': '結帳',
        'zh-TW': '结账',
      },
      '振込金額は351円以上で入力してください。': {
        'en': 'Please enter a transfer amount of 351 yen or more.',
        'it': 'Inserisci un importo di trasferimento pari o superiore a 351 yen.',
        'de': 'Bitte geben Sie einen Überweisungsbetrag von mindestens 351 Yen ein.',
        'es': 'Introduzca un importe de transferencia de 351 yenes o más.',
        'fr': 'Veuillez saisir un montant de transfert de 351 yens ou plus.',
        'ko': '송금 금액은 351엔 이상으로 입력해 주세요.',
        'zh': '請輸入351日圓或以上的轉帳金額。',
        'zh-TW': '请输入351日元或以上的转账金额。',
      },
      '振込金額は10,000円以上で入力してください。': {
        'en': 'Please enter a transfer amount of 10,000 yen or more.',
        'it': 'Inserisci un importo di trasferimento pari o superiore a 10.000 yen.',
        'de': 'Bitte geben Sie einen Überweisungsbetrag von mindestens 10.000 Yen ein.',
        'es': 'Introduzca un importe de transferencia de 10.000 yenes o más.',
        'fr': 'Veuillez saisir un montant de transfert de 10 000 yens ou plus.',
        'ko': '송금 금액은 10,000엔 이상으로 입력해 주세요.',
        'zh': '請輸入10000日圓或以上的轉帳金額。',
        'zh-TW': '请输入10000日元或以上的转账金额。',
      },
      '振込金額が出金可能額を超えています。': {
        'en': 'The transfer amount exceeds the available withdrawal limit.',
        'it': 'L\'importo del trasferimento supera il limite di prelievo disponibile.',
        'de': 'Der Überweisungsbetrag übersteigt das verfügbare Auszahlungslimit.',
        'es': 'El importe de la transferencia supera el límite de retirada disponible.',
        'fr': 'Le montant du transfert dépasse la limite de retrait disponible.',
        'ko': '송금 금액이 출금 가능 금액을 초과합니다.',
        'zh': '轉帳金額超過了可用提款限額。',
        'zh-TW': '转账金额超过了可用提款限额。',
      },
      '〒330-0854 埼玉県さいたま市大宮区桜木町1丁目195‑1 大宮ソラミチKOZ4階': {
        'en': '4th Floor, Omiya Soramichi KOZ, 1-195-1 Sakuragi-cho, Omiya-ku, Saitama City, Saitama Prefecture 330-0854',
        'it': '4th Floor, Omiya Soramichi KOZ, 1-195-1 Sakuragi-cho, Omiya-ku, Saitama City, Prefettura di Saitama 330-0854',
        'de': '4. Stock, Omiya Soramichi KOZ, 1-195-1 Sakuragi-cho, Omiya-ku, Stadt Saitama, Präfektur Saitama 330-0854',
        'es': '4.° piso, Omiya Soramichi KOZ, 1-195-1 Sakuragi-cho, Omiya-ku, ciudad de Saitama, prefectura de Saitama 330-0854',
        'fr': '4e étage, Omiya Soramichi KOZ, 1-195-1 Sakuragi-cho, Omiya-ku, ville de Saitama, préfecture de Saitama 330-0854',
        'ko': '〒330-0854 사이타마현 사이타마시 오미야구 사쿠라기초 1가 195-1 오미야 소라미치 KOS4층',
        'zh': '郵編：330-0854 埼玉縣埼玉市大宮區櫻木町 1-195-1 大宮空道 KOZ 4 樓',
        'zh-TW': '邮编：330-0854 埼玉县埼玉市大宫区樱木町 1-195-1 大宫空道 KOZ 4 楼',
      },
      '発送先': {
        'en': 'Shipping address',
        'it': 'Indirizzo di spedizione',
        'de': 'Lieferadresse',
        'es': 'Dirección de envío',
        'fr': 'Adresse de livraison',
        'ko': '배송지',
        'zh': '收件地址',
        'zh-TW': '收件地址',
      },
      '査定額': {
        'en': 'Amount Received',
        'it': 'Importo ricevuto',
        'de': 'Erhaltener Betrag',
        'es': 'Cantidad recibida',
        'fr': 'Montant reçu',
        'ko': '수령 금액',
        'zh': '已收金額',
        'zh-TW': '收到金额',
      },
      '受付番号': {
        'en': 'Request ID',
        'it': 'ID richiesta',
        'de': 'Anfrage-ID',
        'es': 'ID de solicitud',
        'fr': 'ID de requête',
        'ko': '요청 ID',
        'zh': '請求編號',
        'zh-TW': '请求 ID',
      },
      '査定枚数': {
        'en': 'Number of items to be appraised',
        'it': 'Numero di articoli da valutare',
        'de': 'Anzahl der zu bewertenden Gegenstände',
        'es': 'Número de artículos a tasar',
        'fr': 'Nombre d\'articles à évaluer',
        'ko': '평가 매수',
        'zh': '待評估物品數量',
        'zh-TW': '待评估物品数量',
      },
      '減額枚数': {
        'en': 'Number of reduced items',
        'it': 'Numero di articoli scontati',
        'de': 'Anzahl der reduzierten Artikel',
        'es': 'Número de artículos rebajados',
        'fr': 'Nombre d\'articles en promotion',
        'ko': '감액 매수',
        'zh': '減少的商品數量',
        'zh-TW': '减少的商品数量',
      },
      '返送枚数': {
        'en': 'Number of items to return',
        'it': 'Numero di articoli da restituire',
        'de': 'Anzahl der zurückzusendenden Artikel',
        'es': 'Número de artículos a devolver',
        'fr': 'Nombre d\'articles à retourner',
        'ko': '반송 매수',
        'zh': '退貨商品數量',
        'zh-TW': '退货商品数量',
      },
      '振込': {
        'en': 'Bank Transfer',
        'it': 'Bonifico bancario',
        'de': 'Banküberweisung',
        'es': 'Transferencia bancaria',
        'fr': 'Virement bancaire',
        'ko': '은행 송금',
        'zh': '銀行轉帳',
        'zh-TW': '银行转账',
      },
      '【特価品】': {
        'en': '[Damaged item]',
        'it': '[Oggetto danneggiato]',
        'de': '[Beschädigter Artikel]',
        'es': '[Artículo dañado]',
        'fr': '[Article endommagé]',
        'ko': '【상처 있어 품】',
        'zh': '[物品損壞]',
        'zh-TW': '[物品损坏]',
      },
      '【取り下げ】': {
        'en': '[Withdrawal]',
        'it': '[Ritiro]',
        'de': '[Rückzug]',
        'es': '[Retiro]',
        'fr': '[Retrait]',
        'ko': '【취하】',
        'zh': '【提款】',
        'zh-TW': '【提款】',
      },
      '買取申込(会員様限定)': {
        'en': 'Sell Now (for members only)',
        'it': 'Vendi ora (solo per i membri)',
        'de': 'Jetzt verkaufen (nur für Mitglieder)',
        'es': 'Vender ahora (solo para miembros)',
        'fr': 'Vendre maintenant (réservé aux membres)',
        'ko': '지금 판매하기(회원 전용)',
        'zh': '立即出售（僅限會員）',
        'zh-TW': '立即出售（仅限会员）',
      },
      '未出品の状態で24時間に販売価格を設定されていなければ、自動でコインへ還元されます。': {
        'en': 'If a selling price is not set within 24 hours, it will automatically be converted to coins.',
        'it': 'Se l\'articolo non è in elenco e non viene impostato un prezzo di vendita entro 24 ore, verrà automaticamente convertito in monete.',
        'de': 'Wenn der Artikel nicht gelistet ist und innerhalb von 24 Stunden kein Verkaufspreis festgelegt wird, wird er automatisch in Münzen umgewandelt.',
        'es': 'Si el artículo no está listado y no se establece ningún precio de venta dentro de las 24 horas, se convertirá automáticamente en monedas.',
        'fr': 'Si l\'article n\'est pas répertorié et qu\'aucun prix de vente n\'est fixé dans les 24 heures, il sera automatiquement converti en pièces.',
        'ko': '미출품 상태에서 24시간에 판매가격이 설정되어 있지 않으면 자동으로 코인으로 환원됩니다.',
        'zh': '如果該物品未上架且在 24 小時內未設定售價，則將自動轉換為金幣。',
        'zh-TW': '如果该物品未上架且在 24 小时内未设定售价，则将自动转换为金币。',
      },
      'マーケットへ出品して2週間経過して売れなかった場合は、自動でコインへ還元されます。': {
        'en': 'If an item is listed on the marketplace and does not sell within two weeks, the remaining amount will be automatically converted into coins.',
        'it': 'Se un oggetto viene messo in vendita sul marketplace e non viene venduto entro due settimane, l\'importo rimanente verrà automaticamente convertito in monete.',
        'de': 'Wird ein Artikel auf dem Marktplatz angeboten und verkauft er sich nicht innerhalb von zwei Wochen, wird der Restbetrag automatisch in Münzen umgewandelt.',
        'es': 'Si un artículo se publica en el mercado y no se vende en dos semanas, el importe restante se convertirá automáticamente en monedas.',
        'fr': 'Si un article est mis en vente sur la plateforme et ne se vend pas dans un délai de deux semaines, le montant restant sera automatiquement converti en pièces.',
        'ko': '마켓에 출품해 2주간 경과해 팔리지 않았던 경우는, 자동으로 코인에 환원됩니다.',
        'zh': '如果一件商品在市場上架兩週內沒有售出，剩餘金額將自動轉換為金幣。',
        'zh-TW': '如果一件商品在市场上架两周内没有售出，剩余金额将自动转换为金币。',
      },
      '出品開始後2週間以内なら、「コインへ還元」「発送依頼」を自由に変更できます。': {
        'en': 'Within two weeks of listing your item, you can freely change between "Convert to Coins" and "Request Shipping."',
        'it': 'Entro due settimane dalla pubblicazione dell\'articolo, puoi liberamente passare dall\'opzione "Converti in monete" all\'opzione "Richiedi spedizione".',
        'de': 'Innerhalb von zwei Wochen nach dem Einstellen Ihres Artikels können Sie jederzeit zwischen „In Münzen umwandeln“ und „Versand anfordern“ wechseln.',
        'es': 'En un plazo de dos semanas desde la publicación del artículo, puede cambiar libremente entre "Convertir a monedas" y "Solicitar envío".',
        'fr': 'Dans les deux semaines suivant la mise en vente de votre article, vous pouvez librement choisir entre « Convertir en pièces » et « Demander l\'expédition ».',
        'ko': '출품 개시 후 2주일 이내라면, 「코인에 환원」 「발송 의뢰」를 자유롭게 변경할 수 있습니다.',
        'zh': '在商品上架後的兩週內，您可以隨時在「兌換成硬幣」和「請求運送」之間進行更改。',
        'zh-TW': '在商品上架后的两周内，您可以随时在“兑换成硬币”和“请求运送”之间进行更改。',
      },
      '販売手数料として10%を頂戴いたします。': {
        'en': 'A 10% sales commission and PayPal transfer fees will apply.',
        'it': 'Si applicheranno una commissione di vendita del 10% e le spese di trasferimento PayPal.',
        'de': 'Eine Verkaufsprovision von 10 % und PayPal-Überweisungsgebühren fallen an.',
        'es': 'En provision på 10 % och PayPal-överföringsavgifter tillkommer.',
        'fr': 'Une commission de vente de 10 % et des frais de transfert PayPal s\'appliqueront.',
        'ko': '10% 판매 수수료와 PayPal 송금 수수료가 적용됩니다.',
        'zh': '將收取10%的銷售佣金和PayPal轉帳費用。',
        'zh-TW': '销售佣金为10%，并适用PayPal转账费用。',
      },
      '売上金についてはこちらをご確認ください。': {
        'en': 'Please check here for details on sales proceeds.',
        'it': 'Per i dettagli relativi al ricavato delle vendite, consultare questa pagina.',
        'de': 'Bitte prüfen Sie hier die Einzelheiten zum Verkaufserlös.',
        'es': 'Consulte aquí para obtener detalles sobre los ingresos de las ventas.',
        'fr': 'Veuillez consulter cette page pour plus de détails sur le produit des ventes.',
        'ko': '매출금에 대해서는 이쪽을 확인해 주세요.',
        'zh': '請點擊此處查看銷售收益詳情。',
        'zh-TW': '请点击此处查看销售收益详情。',
      },
      '2タップで「X marketで販売」となります。': {
        'en': 'Two taps will put it on "X market for sale".',
        'it': 'Due tocchi lo metteranno in vendita sul mercato X.',
        'de': 'Mit zwei Klicks wird es auf dem „Markt X zum Verkauf“ angeboten.',
        'es': 'Dos toques lo pondrán en "Mercado X en venta".',
        'fr': 'Deux clics suffisent pour le mettre en vente sur le marché X.',
        'ko': '2 탭으로 「X market에서 판매」가 됩니다.',
        'zh': '輕點兩下即可將其放到「X市場出售」。',
        'zh-TW': '轻点两下即可将其放到“X市场出售”。',
      },
      'コインに還元する': {
        'en': 'Convert to coins',
        'it': 'Converti in monete',
        'de': 'In Münzen umwandeln',
        'es': 'Convertir a monedas',
        'fr': 'Convertir en pièces',
        'ko': '코인으로 변환',
        'zh': '兌換成硬幣',
        'zh-TW': '兑换为硬币',
      },
      '発送する': {
        'en': 'Ship to me',
        'it': 'Spediscimelo',
        'de': 'Schick es mir',
        'es': 'Envíamelo',
        'fr': 'Expédiez-moi',
        'ko': '저에게 배송하세요',
        'zh': '寄給我',
        'zh-TW': '寄给我',
      },
      'このカードをコインに還元しますか？': {
        'en': 'Do you want to convert this card into coins?',
        'it': 'Desideri convertire questa carta in monete?',
        'de': 'Möchtest du diese Karte in Münzen umtauschen?',
        'es': '¿Deseas convertir esta tarjeta en monedas?',
        'fr': 'Souhaitez-vous convertir cette carte en pièces ?',
        'ko': '이 카드를 동전으로 환원하시겠습니까?',
        'zh': '您想把這張卡兌換成金幣嗎？',
        'zh-TW': '您想把这张卡兑换成金币吗？',
      },
      '(※実行後の変更はできません)': {
        'en': '(※Changes cannot be made after execution)',
        'it': '(※Non è possibile apportare modifiche dopo l\'esecuzione)',
        'de': '(※Nach der Ausführung können keine Änderungen mehr vorgenommen werden)',
        'es': '(※No se pueden realizar cambios después de la ejecución)',
        'fr': '(※Aucune modification ne peut être apportée après l\'exécution)',
        'ko': '(※실행 후의 변경은 할 수 없습니다)',
        'zh': '（※執行後無法更改）',
        'zh-TW': '（※执行后无法更改）',
      },
      'このカードを発送しますか？': {
        'en': 'Should I ship this card?',
        'it': 'Devo spedire questa cartolina?',
        'de': 'Soll ich diese Karte verschicken?',
        'es': '¿Debo enviar esta tarjeta?',
        'fr': 'Dois-je expédier cette carte ?',
        'ko': '이 카드를 발송하시겠습니까?',
        'zh': '我該寄出這張卡片嗎？',
        'zh-TW': '我应该寄出这张卡片吗？',
      },
      '当該ガチャの販売終了後に自動で出品されます': {
        'en': 'This item will be automatically listed for sale after the sale of the gacha ends.',
        'it': 'Questo oggetto verrà automaticamente messo in vendita al termine della vendita del gacha.',
        'de': 'Dieser Artikel wird nach Ende des Gacha-Verkaufs automatisch zum Verkauf angeboten.',
        'es': 'Este artículo se pondrá a la venta automáticamente una vez finalizada la venta del gacha.',
        'fr': 'Cet article sera automatiquement mis en vente une fois la vente du gacha terminée.',
        'ko': '해당 뽑기의 판매 종료 후 자동으로 출품됩니다',
        'zh': '扭蛋活動結束後，該物品將自動上架出售。',
        'zh-TW': '扭蛋活动结束后，该物品将自动上架出售。',
      },
      'マーケット購入': {
        'en': 'Market purchase',
        'it': 'Acquisto sul mercato',
        'de': 'Marktkauf',
        'es': 'Compra en el mercado',
        'fr': 'Achat au marché',
        'ko': '마켓 구매',
        'zh': '市場購買',
        'zh-TW': '市场购买',
      },
      'フィギュア': {
        'en': 'Figure',
        'it': 'Figura',
        'de': 'Figur',
        'es': 'Cifra',
        'fr': 'Chiffre',
        'ko': '피규어',
        'zh': '數位',
        'zh-TW': '数字',
      },
      '{min}円以上の価格で出品できます': {
        'en': 'You can sell it for more than {min} yen',
        'it': 'Sie können es für mehr als {min} Yen verkaufen',
        'de': 'Puedes venderlo por más de {min} yenes',
        'es': 'Vous pouvez le vendre pour plus de {min} yens',
        'fr': '{min}엔 이상의 가격으로 판매 가능',
        'ko': '您可以以高於{min}日圓的價格出售它',
        'zh': '您可以以高于{min}日元的价格出售它',
        'zh-TW': '您可以以高于{min}日元的价格出售它',
      },
      'カートに追加しました': {
        'en': 'Added to cart',
        'it': 'Aggiunto al carrello',
        'de': 'Dem Warenkorb hinzugefügt',
        'es': 'Añadido al carrito',
        'fr': 'Ajouté au panier',
        'ko': '장바구니에 추가됨',
        'zh': '加入購物車',
        'zh-TW': '加入购物车',
      },
      'マーケット購入品': {
        'en': 'Market purchases',
        'it': 'Acquisti di mercato',
        'de': 'Marktkäufe',
        'es': 'Compras en el mercado',
        'fr': 'Achats sur le marché',
        'ko': '마켓 구매품',
        'zh': '市場購買',
        'zh-TW': '市场购买',
      },
      '該当するカード履歴が見つかりません': {
        'en': 'No matching card history was found.',
        'it': 'Non è stata trovata alcuna corrispondenza nella cronologia della carta.',
        'de': 'Es wurde keine passende Kartenhistorie gefunden.',
        'es': 'No se encontró ningún historial de tarjeta coincidente.',
        'fr': 'Aucun historique de carte correspondant n\'a été trouvé.',
        'ko': '해당 카드 기록을 찾을 수 없습니다.',
        'zh': '未找到符合的信用卡歷史記錄。',
        'zh-TW': '未找到匹配的信用卡历史记录。',
      },
      'このカードの所有者ではありません': {
        'en': 'I am not the owner of this card.',
        'it': 'Non sono il proprietario di questa carta.',
        'de': 'Ich bin nicht der Besitzer dieser Karte.',
        'es': 'No soy el propietario de esta tarjeta.',
        'fr': 'Je ne suis pas le propriétaire de cette carte.',
        'ko': '이 카드의 소유자가 아닙니다.',
        'zh': '我不是這張卡的持有者。',
        'zh-TW': '我不是这张卡的持有者。',
      },
      'このカードは既に取引が完了しています': {
        'en': 'This card has already been traded.',
        'it': 'Questa carta è già stata scambiata.',
        'de': 'Diese Karte wurde bereits getauscht.',
        'es': 'Esta carta ya ha sido intercambiada.',
        'fr': 'Cette carte a déjà été échangée.',
        'ko': '이 카드는 이미 거래가 완료되었습니다.',
        'zh': '這張卡已經交易過了。',
        'zh-TW': '这张卡已经交易过了。',
      },
      '出品できないカードです': {
        'en': 'This card cannot be listed for sale.',
        'it': 'Questa carta non può essere messa in vendita.',
        'de': 'Diese Karte darf nicht zum Verkauf angeboten werden.',
        'es': 'Esta tarjeta no puede ponerse a la venta.',
        'fr': 'Cette carte ne peut être mise en vente.',
        'ko': '전시 할 수없는 카드입니다.',
        'zh': '此卡不能上架出售。',
        'zh-TW': '此卡不能上架出售。',
      },
      '既に出品されています': {
        'en': 'Already listed',
        'it': 'È già stato messo in vendita.',
        'de': 'Es steht bereits zum Verkauf.',
        'es': 'Ya está puesto a la venta.',
        'fr': 'Il a déjà été mis en vente.',
        'ko': '이미 출품되었습니다.',
        'zh': '它已經掛牌出售了。',
        'zh-TW': '它已经挂牌出售了。',
      },
      '既にカートに追加されています': {
        'en': 'It has already been added to your cart.',
        'it': 'È già stato aggiunto al carrello.',
        'de': 'Es wurde bereits Ihrem Warenkorb hinzugefügt.',
        'es': 'Ya se ha añadido a tu carrito.',
        'fr': 'Il a déjà été ajouté à votre panier.',
        'ko': '이미 장바구니에 추가되었습니다.',
        'zh': '它已加入您的購物車。',
        'zh-TW': '它已加入您的购物车。',
      },
      '自分の出品はカートに追加できません': {
        'en': 'I cannot add my own listings to my cart.',
        'it': 'Non riesco ad aggiungere i miei articoli al carrello.',
        'de': 'Ich kann meine eigenen Artikel nicht in meinen Warenkorb legen.',
        'es': 'No puedo añadir mis propios artículos al carrito.',
        'fr': 'Je ne peux pas ajouter mes propres annonces à mon panier.',
        'ko': '자신의 전시는 장바구니에 추가할 수 없습니다.',
        'zh': '我無法將自己的商品加入購物車。',
        'zh-TW': '我无法将自己的商品添加到购物车。',
      },
      '出品が見つかりません': {
        'en': 'No listings found.',
        'it': 'Nessun risultato trovato.',
        'de': 'Keine Einträge gefunden.',
        'es': 'No se encontraron resultados.',
        'fr': 'Aucune annonce trouvée.',
        'ko': '출품을 찾을 수 없음',
        'zh': '未找到任何房源。',
        'zh-TW': '未找到任何房源。',
      },
      'システムエラーが発生しました': {
        'en': 'A system error occurred.',
        'it': 'Si è verificato un errore di sistema.',
        'de': 'Es ist ein Systemfehler aufgetreten.',
        'es': 'Se ha producido un error del sistema.',
        'fr': 'Une erreur système s\'est produite.',
        'ko': '시스템 오류가 발생했습니다.',
        'zh': '系統發生錯誤。',
        'zh-TW': '系统发生错误。',
      },
      '既に購入済みです': {
        'en': 'I have already purchased it.',
        'it': 'L\'ho già acquistato.',
        'de': 'Ich habe es bereits gekauft.',
        'es': 'Ya lo he comprado.',
        'fr': 'Je l\'ai déjà acheté.',
        'ko': '이미 구입했습니다.',
        'zh': '我已經買好了。',
        'zh-TW': '我已经买好了。',
      },
      '既に他の人に購入されました': {
        'en': 'It has already been purchased by someone else.',
        'it': 'È già stato acquistato da qualcun altro.',
        'de': 'Es wurde bereits von jemand anderem gekauft.',
        'es': 'Ya lo ha comprado otra persona.',
        'fr': 'Il a déjà été acheté par quelqu\'un d\'autre.',
        'ko': '이미 다른 사람들에게 구입했습니다.',
        'zh': '它已經被別人買走了。',
        'zh-TW': '它已经被别人买走了。',
      },
      '自分の出品は購入できません': {
        'en': 'You cannot purchase my own listings.',
        'it': 'Non è possibile acquistare i miei articoli in vendita.',
        'de': 'Meine eigenen Angebote können Sie nicht kaufen.',
        'es': 'No puedes comprar mis propios anuncios.',
        'fr': 'Vous ne pouvez pas acheter mes propres annonces.',
        'ko': '자신의 출품은 구입할 수 없습니다.',
        'zh': '你不能購買我自己發布的商品。',
        'zh-TW': '你不能购买我自己发布的商品。',
      },
      'オークション商品は個別に購入してください': {
        'en': 'Please purchase auction items individually.',
        'it': 'Si prega di acquistare gli articoli all\'asta singolarmente.',
        'de': 'Bitte kaufen Sie die Auktionsartikel einzeln.',
        'es': 'Por favor, compre los artículos de la subasta individualmente.',
        'fr': 'Veuillez acheter les articles mis aux enchères individuellement.',
        'ko': '경매 상품은 개별적으로 구입해 주세요',
        'zh': '請單獨購買拍賣品。',
        'zh-TW': '请单独购买拍卖品。',
      },
      '商品価格が変更されました': {
        'en': 'Product price has been changed.',
        'it': 'Il prezzo del prodotto è stato modificato.',
        'de': 'Der Produktpreis wurde geändert.',
        'es': 'El precio del producto ha cambiado.',
        'fr': 'Le prix du produit a été modifié.',
        'ko': '상품 가격이 변경되었습니다.',
        'zh': '產品價格已更改。',
        'zh-TW': '产品价格已更改。',
      },
      '商品が見つかりません': {
        'en': 'Product not found.',
        'it': 'Prodotto non trovato.',
        'de': 'Produkt nicht gefunden.',
        'es': 'Producto no encontrado.',
        'fr': 'Produit introuvable.',
        'ko': '상품을 찾을 수 없음',
        'zh': '未找到產品。',
        'zh-TW': '未找到产品。',
      },
      'サポートされていない決済方法です': {
        'en': 'This payment method is not supported.',
        'it': 'Questo metodo di pagamento non è supportato.',
        'de': 'Diese Zahlungsmethode wird nicht unterstützt.',
        'es': 'Este método de pago no es compatible.',
        'fr': 'Ce mode de paiement n\'est pas pris en charge.',
        'ko': '지원되지 않는 결제 방법입니다.',
        'zh': '此付款方式不受支援。',
        'zh-TW': '此付款方式不受支持。',
      },
      '決済処理でエラーが発生しました': {
        'en': 'An error occurred during payment processing.',
        'it': 'Si è verificato un errore durante l\'elaborazione del pagamento.',
        'de': 'Bei der Zahlungsabwicklung ist ein Fehler aufgetreten.',
        'es': 'Se produjo un error durante el procesamiento del pago.',
        'fr': 'Une erreur s\'est produite lors du traitement du paiement.',
        'ko': '결제 처리 중 오류가 발생했습니다.',
        'zh': '支付處理過程中發生錯誤。',
        'zh-TW': '支付处理过程中发生错误。',
      },
      '購入完了処理に失敗しました': {
        'en': 'Purchase completion failed.',
        'it': 'Acquisto non completato.',
        'de': 'Kaufabwicklung fehlgeschlagen.',
        'es': 'La compra no se completó correctamente.',
        'fr': 'L\'achat a échoué.',
        'ko': '구매 완료 처리에 실패했습니다.',
        'zh': '購買交易失敗。',
        'zh-TW': '购买交易失败。',
      },
      '一部の商品が購入できませんでした': {
        'en': 'Some items could not be purchased.',
        'it': 'Alcuni articoli non potevano essere acquistati.',
        'de': 'Einige Artikel konnten nicht gekauft werden.',
        'es': 'Algunos artículos no pudieron comprarse.',
        'fr': 'Certains articles n\'ont pas pu être achetés.',
        'ko': '일부 상품을 구입할 수 없습니다.',
        'zh': '部分商品無法購買。',
        'zh-TW': '部分商品无法购买。',
      },
      'カートに商品がありません': {
        'en': 'There are no items in your cart.',
        'it': 'Non ci sono articoli nel carrello.',
        'de': 'Ihr Warenkorb ist leer.',
        'es': 'No hay artículos en tu carrito.',
        'fr': 'Votre panier est vide.',
        'ko': '장바구니에 상품이 없습니다.',
        'zh': '您的購物車中沒有商品。',
        'zh-TW': '您的购物车中没有商品。',
      },
      '購入情報が見つかりません': {
        'en': 'Purchase information not found.',
        'it': 'Informazioni sull\'acquisto non trovate.',
        'de': 'Kaufinformationen nicht gefunden.',
        'es': 'No se encontró información de compra.',
        'fr': 'Informations d\'achat introuvables.',
        'ko': '구매 정보를 찾을 수 없음',
        'zh': '未找到購買資訊。',
        'zh-TW': '未找到购买信息。',
      },
      '購入が完了しました': {
        'en': 'Purchase complete.',
        'it': 'Acquisto completato.',
        'de': 'Kauf abgeschlossen.',
        'es': 'Compra completada.',
        'fr': 'Achat terminé.',
        'ko': '구매가 완료되었습니다.',
        'zh': '購買完成。',
        'zh-TW': '购买完成。',
      },
      '購入処理でエラーが発生しました': {
        'en': 'An error occurred during the purchase process.',
        'it': 'Si è verificato un errore durante il processo di acquisto.',
        'de': 'Während des Kaufvorgangs ist ein Fehler aufgetreten.',
        'es': 'Se produjo un error durante el proceso de compra.',
        'fr': 'Une erreur s\'est produite lors du processus d\'achat.',
        'ko': '구매 처리 중 오류가 발생했습니다.',
        'zh': '購買過程中出現錯誤。',
        'zh-TW': '购买过程中出现错误。',
      },
      '入金情報が見つかりません': {
        'en': 'Payment information not found.',
        'it': 'Informazioni di pagamento non trovate.',
        'de': 'Zahlungsinformationen nicht gefunden.',
        'es': 'Información de pago no encontrada.',
        'fr': 'Informations de paiement introuvables.',
        'ko': '입금 정보를 찾을 수 없음',
        'zh': '未找到支付資訊。',
        'zh-TW': '未找到支付信息。',
      },
      '振込金額は手数料を差し引いた金額が1円以上になるように指定してください': {
        'en': 'Please specify a transfer amount such that the amount after deducting the transfer fee is 1 yen or more.',
        'it': 'Si prega di specificare un importo per il trasferimento tale che, al netto delle commissioni, l\'importo totale sia pari o superiore a 1 yen.',
        'de': 'Bitte geben Sie einen Überweisungsbetrag an, sodass der Betrag nach Abzug der Überweisungsgebühr mindestens 1 Yen beträgt.',
        'es': 'Por favor, especifique un importe de transferencia tal que, tras deducir la comisión, el importe resultante sea de 1 yen o más.',
        'fr': 'Veuillez indiquer un montant de transfert tel que le montant après déduction des frais de transfert soit de 1 yen ou plus.',
        'ko': '송금 금액은 수수료를 뺀 금액이 1 엔 이상이되도록 지정하십시오',
        'zh': '請指定轉帳金額，使扣除手續費後的金額為1日圓或以上。',
        'zh-TW': '请指定转账金额，使扣除手续费后的金额为1日元或以上。',
      },
      '不正な振込タイプです': {
        'en': 'This is an invalid transfer type.',
        'it': 'Questo è un tipo di trasferimento non valido.',
        'de': 'Dies ist ein ungültiger Übertragungstyp.',
        'es': 'Este es un tipo de transferencia no válido.',
        'fr': 'Il s\'agit d\'un type de transfert invalide.',
        'ko': '부정한 송금 타입입니다',
        'zh': '這是無效的轉帳類型。',
        'zh-TW': '这是无效的转账类型。',
      },
      '出金可能額を超えています': {
        'en': 'You have exceeded your withdrawal limit.',
        'it': 'Hai superato il limite di prelievo.',
        'de': 'Sie haben Ihr Auszahlungslimit überschritten.',
        'es': 'Has superado tu límite de retiro.',
        'fr': 'Vous avez dépassé votre limite de retrait.',
        'ko': '출금 가능 금액을 초과했습니다.',
        'zh': '您已超出提款限額。',
        'zh-TW': '您已超出提款限额。',
      },
      '銀行口座情報が不足しています': {
        'en': 'Bank account information is missing.',
        'it': 'Mancano le informazioni sul conto bancario.',
        'de': 'Die Bankkontoinformationen fehlen.',
        'es': 'Falta la información de la cuenta bancaria.',
        'fr': 'Les informations relatives au compte bancaire sont manquantes.',
        'ko': '은행 계좌 정보가 부족합니다.',
        'zh': '銀行帳戶資料缺失。',
        'zh-TW': '银行账户信息缺失。',
      },
      'PayPalメールアドレスが不足しています': {
        'en': 'We are missing PayPal email addresses.',
        'it': 'Ci mancano gli indirizzi email di PayPal.',
        'de': 'Uns fehlen PayPal-E-Mail-Adressen.',
        'es': 'Nos faltan direcciones de correo electrónico de PayPal.',
        'fr': 'Il nous manque des adresses e-mail PayPal.',
        'ko': 'PayPal 이메일 주소가 부족합니다.',
        'zh': '我們缺少PayPal郵箱地址。',
        'zh-TW': '我们缺少PayPal邮箱地址。',
      },
      '不正な入金情報の種別です': {
        'en': 'This is the type of fraudulent deposit information.',
        'it': 'Questo è il tipo di informazione fraudolenta relativa al deposito.',
        'de': 'Dies sind betrügerische Einzahlungsinformationen.',
        'es': 'Este es el tipo de información de depósito fraudulenta.',
        'fr': 'Voici le type d\'informations frauduleuses concernant les dépôts.',
        'ko': '부정한 입금 정보의 종류입니다.',
        'zh': '這是典型的詐欺性存款資訊。',
        'zh-TW': '这是典型的欺诈性存款信息。',
      },
      'マーケットIDまたはユーザー履歴カードIDが必要です': {
        'en': 'A Market ID or User History Card ID is required.',
        'it': 'È richiesto un ID di mercato o un ID della scheda cronologia utente.',
        'de': 'Eine Markt-ID oder eine Benutzerhistorien-Karten-ID ist erforderlich.',
        'es': 'Se requiere un ID de mercado o un ID de tarjeta de historial de usuario.',
        'fr': 'Un identifiant de marché ou un identifiant de carte d\'historique utilisateur est requis.',
        'ko': '마켓 ID 또는 사용자 기록 카드 ID 필요',
        'zh': '需要提供市場 ID 或用戶歷史卡 ID。',
        'zh-TW': '需要提供市场 ID 或用户历史卡 ID。',
      },
      '該当するマーケット出品が見つかりません': {
        'en': 'No matching market listings were found.',
        'it': 'Non sono stati trovati annunci di mercato corrispondenti.',
        'de': 'Es wurden keine passenden Markteinträge gefunden.',
        'es': 'No se encontraron resultados de mercado coincidentes.',
        'fr': 'Aucune annonce correspondante n\'a été trouvée.',
        'ko': '해당 시장 출품을 찾을 수 없습니다.',
        'zh': '未找到符合的市場清單。',
        'zh-TW': '未找到匹配的市场列表。',
      },
      'ログインが必要です': {
        'en': 'Login is required.',
        'it': 'È necessario effettuare l\'accesso.',
        'de': 'Anmeldung erforderlich.',
        'es': 'Es necesario iniciar sesión.',
        'fr': 'Connexion requise.',
        'ko': '로그인 필요',
        'zh': '需要登入。',
        'zh-TW': '需要登录。',
      },
      'PayPalの手数料に準ずる': {
        'en': 'In accordance with PayPal terms',
        'it': 'Le commissioni sono soggette ai termini e alle condizioni di PayPal.',
        'de': 'Es fallen Gebühren gemäß den Allgemeinen Geschäftsbedingungen von PayPal an.',
        'es': 'Las comisiones están sujetas a los términos y condiciones de PayPal.',
        'fr': 'Les frais sont soumis aux conditions générales de PayPal.',
        'ko': 'PayPal 수수료에 부합',
        'zh': '費用受PayPal條款和條件的約束。',
        'zh-TW': '费用受PayPal条款和条件的约束。',
      },
      'PayPalの手数料が差し引かれた後の金額': {
        'en': 'Amount after PayPal fees have been deducted',
        'it': 'L\'importo al netto delle commissioni di PayPal.',
        'de': 'Der Betrag nach Abzug der PayPal-Gebühren.',
        'es': 'El importe después de deducir las comisiones de PayPal.',
        'fr': 'Le montant après déduction des frais PayPal.',
        'ko': 'PayPal 수수료가 공제된 후 금액',
        'zh': '扣除PayPal手續費後的金額。',
        'zh-TW': '扣除PayPal手续费后的金额。',
      },
      'PayPalメールアドレス': {
        'en': 'PayPal email address',
        'it': 'Indirizzo email di PayPal',
        'de': 'PayPal-E-Mail-Adresse',
        'es': 'Dirección de correo electrónico de PayPal',
        'fr': 'Adresse e-mail PayPal',
        'ko': 'PayPal 이메일 주소',
        'zh': 'PayPal 電子郵件地址',
        'zh-TW': 'PayPal 电子邮件地址',
      },
      'このカードを削除しますか？': {
        'en': 'Do you want to remove this card?',
        'it': 'Vuoi rimuovere questa scheda?',
        'de': 'Möchten Sie diese Karte entfernen?',
        'es': '¿Desea eliminar esta tarjeta?',
        'fr': 'Voulez-vous retirer cette carte ?',
        'ko': '이 카드를 삭제하시겠습니까?',
        'zh': '您要移除這張卡嗎？',
        'zh-TW': '您要移除这张卡吗？',
      },
      '販売手数料として10%を頂戴いたします': {
        'en': 'We will charge a 10% sales commission.',
        'it': 'Applicheremo una commissione di vendita del 10%.',
        'de': 'Wir berechnen eine Verkaufsprovision von 10%.',
        'es': 'Cobraremos una comisión de venta del 10%.',
        'fr': 'Nous prélèverons une commission de 10 % sur les ventes.',
        'ko': '판매 수수료로서 10%를 받습니다',
        'zh': '我們將收取10%的銷售佣金。',
        'zh-TW': '我们将收取10%的销售佣金。',
      },
      '未発送': {
        'en': 'Not yet shipped',
        'it': 'Non ancora spedito',
        'de': 'Noch nicht versendet',
        'es': 'Aún no se ha enviado',
        'fr': 'Pas encore expédié',
        'ko': '미발송',
        'zh': '尚未出貨',
        'zh-TW': '尚未发货',
      },
      '出品額': {
        'en': 'Sales amount',
        'it': 'Importo delle vendite',
        'de': 'Verkaufsbetrag',
        'es': 'Försäljningsbelopp',
        'fr': 'Montant des ventes',
        'ko': '매출액',
        'zh': '銷售額',
        'zh-TW': '销售额',
      },
      '入金額': {
        'en': 'Received amount',
        'it': 'Importo ricevuto',
        'de': 'Erhaltener Betrag',
        'es': 'Mottagen summa',
        'fr': 'Montant reçu',
        'ko': '수령 금액',
        'zh': '收到金額',
        'zh-TW': '收到金额',
      },
      'ポイント購入履歴': {
        'en': 'Points Purchase History',
        'it': 'Cronologia degli acquisti di punti',
        'de': 'Punktekaufhistorie',
        'es': 'Historial de compra de puntos',
        'fr': 'Historique d\'achat de points',
        'ko': '포인트 구매 내역',
        'zh': '積分購買歷史記錄',
        'zh-TW': '积分购买历史记录',
      },
      '所持{amount}ポイント以下の方限定': {
        'en': 'Limited to those with {amount} points or less',
        'it': 'Riservato a coloro che hanno {amount} punti o meno',
        'de': 'Beschränkt auf Teilnehmer mit {amount} Punkten oder weniger',
        'es': 'Limitado a aquellos con {cantidad} puntos o menos',
        'fr': 'Réservé aux personnes ayant {amount} points ou moins',
        'ko': '소지 {amount}포인트 이하의 분 한정',
        'zh': '僅限積分低於 {amount} 分的用戶',
        'zh-TW': '仅限积分低于 {amount} 分的用户',
      },
      '今月{amount}ポイント以上決済された方限定': {
        'en': 'Limited to customers who have spent more than {amount} points this month.',
        'it': 'Offerta riservata ai clienti che hanno speso più di {amount} punti questo mese.',
        'de': 'Beschränkt auf Kunden, die in diesem Monat mehr als {amount} Punkte eingelöst haben.',
        'es': 'Limitado a clientes que hayan gastado más de {cantidad} puntos este mes.',
        'fr': 'Offre limitée aux clients ayant dépensé plus de {amount} points ce mois-ci.',
        'ko': '이번 달 {amount}포인트 이상 결제된 분 한정',
        'zh': '僅限本月消費超過{amount}積分的顧客。',
        'zh-TW': '仅限本月消费超过{amount}积分的顾客。',
      },
      '所持ポイント': {
        'en': 'Points',
        'it': 'Punti',
        'de': 'Punkte',
        'es': 'Agujas',
        'fr': 'Points',
        'ko': '소지 포인트',
        'zh': '積分',
        'zh-TW': '积分',
      },
      'ポイントを使用しない場合、来月は「{rank}」ランクになります。': {
        'en': 'If you do not use your points, your rank will be "{rank}" next month.',
        'it': 'Se non utilizzi i tuoi punti, il tuo rango sarà "{rank}" il mese prossimo.',
        'de': 'Wenn Sie Ihre Punkte nicht einlösen, wird Ihr Rang im nächsten Monat "{rank}" lauten.',
        'es': 'Si no utilizas tus puntos, tu rango será "{rank}" el próximo mes.',
        'fr': 'Si vous n\'utilisez pas vos points, votre rang sera « {rank} » le mois prochain.',
        'ko': '포인트를 사용하지 않으면 다음 달은 \'{rank}\' 순위가 됩니다.',
        'zh': '如果您不使用積分，下個月您的排名將為「{rank}」。',
        'zh-TW': '如果您不使用积分，下个月您的排名将为“{rank}”。',
      },
      '来月、「{rank}」からスタートするには {amount} ポイントが必要です。': {
        'en': 'To start at "{rank}" next month, you will need {amount} points.',
        'it': 'Per iniziare al rango "{rank}" il mese prossimo, avrai bisogno di {amount} punti.',
        'de': 'Um nächsten Monat auf Rang "{rank}" zu starten, benötigen Sie {amount} Punkte.',
        'es': 'Para comenzar en "{rank}" el próximo mes, necesitarás {amount} puntos.',
        'fr': 'Pour commencer au "{rank}" le mois prochain, vous aurez besoin de {amount} points.',
        'ko': '다음 달 "{rank}"에서 시작하려면 {amount} 포인트가 필요합니다.',
        'zh': '下個月要達到「{rank}」級別，您需要{amount}點數。',
        'zh-TW': '下个月要达到“{rank}”级别，您需要{amount}点数。',
      },
      'ポイントが不足しています': {
        'en': 'You do not have enough points.',
        'it': 'Non hai abbastanza punti.',
        'de': 'Du hast nicht genügend Punkte.',
        'es': 'No tienes suficientes puntos.',
        'fr': 'Vous n\'avez pas assez de points.',
        'ko': '포인트가 부족함',
        'zh': '您的積分不足。',
        'zh-TW': '您的积分不足。',
      },
      'ポイントのみ': {
        'en': 'Points only',
        'it': 'Solo punti',
        'de': 'Nur Punkte',
        'es': 'Solo puntos',
        'fr': 'Points seulement',
        'ko': '포인트만',
        'zh': '僅積分',
        'zh-TW': '仅积分',
      },
      'あなたも友達も 500ポイントがもらえる': {
        'en': 'You and your friend will both receive 500 points.',
        'it': 'Tu e il tuo amico riceverete entrambi 500 punti.',
        'de': 'Du und dein Freund erhaltet beide 500 Punkte.',
        'es': 'Tú y tu amigo recibiréis 500 puntos cada uno.',
        'fr': 'Vous et votre ami recevrez chacun 500 points.',
        'ko': '당신도 친구도 500포인트를 받을 수 있다',
        'zh': '你和你的朋友都將獲得500點。',
        'zh-TW': '你和你的朋友都将获得500积分。',
      },
      'ポイントの購入': {
        'en': 'Purchase of points',
        'it': 'Acquisto di punti',
        'de': 'Kauf von Punkten',
        'es': 'Compra de puntos',
        'fr': 'Achat de points',
        'ko': '포인트 구매',
        'zh': '購買積分',
        'zh-TW': '购买积分',
      },
      'ポイントへの還元数': {
        'en': 'Number of points redeemed',
        'it': 'Numero di punti riscattati',
        'de': 'Anzahl der eingelösten Punkte',
        'es': 'Número de puntos canjeados',
        'fr': 'Nombre de points échangés',
        'ko': '포인트로의 환원수',
        'zh': '已兌換積分數量',
        'zh-TW': '已兑换积分数量',
      },
      'ポイントへの合計還元数': {
        'en': 'Total number of points redeemed',
        'it': 'Numero totale di punti riscattati',
        'de': 'Gesamtzahl der eingelösten Punkte',
        'es': 'Número total de puntos canjeados',
        'fr': 'Nombre total de points échangés',
        'ko': '포인트에 대한 총 환원 수',
        'zh': '已兌換積分總數',
        'zh-TW': '已兑换积分总数',
      },
      'ポイント数': {
        'en': 'Points',
        'it': 'Punti',
        'de': 'Punkte',
        'es': 'Agujas',
        'fr': 'Points',
        'ko': '포인트 수',
        'zh': '積分',
        'zh-TW': '积分',
      },
      '引換履歴&ポイント履歴': {
        'en': 'Redemption History & Points History',
        'it': 'Cronologia dei riscatti e cronologia dei punti',
        'de': 'Einlösungshistorie & Punktehistorie',
        'es': 'Historial de canje e historial de puntos',
        'fr': 'Historique des échanges et historique des points',
        'ko': '교환 이력 & 포인트 이력',
        'zh': '兌換歷史與積分歷史',
        'zh-TW': '兑换历史和积分历史',
      },
      '引換・付与ポイント': {
        'en': 'Redemption/Points Awarded',
        'it': 'Riscatto/Punti assegnati',
        'de': 'Einlösung/Punktevergabe',
        'es': 'Canje/Puntos otorgados',
        'fr': 'Échange/Points attribués',
        'ko': '교환·부여 포인트',
        'zh': '兌換/獎勵積分',
        'zh-TW': '兑换/奖励积分',
      },
      '引換履歴&ポイント履歴がありません。': {
        'en': 'There is no redemption history or points history.',
        'it': 'Non è disponibile alcuna cronologia di riscatti o di punti.',
        'de': 'Es gibt keine Einlösungshistorie oder Punktehistorie.',
        'es': 'No hay historial de canje ni historial de puntos.',
        'fr': 'Il n\'y a pas d\'historique des échanges ni d\'historique des points.',
        'ko': '교환 이력 & 포인트 이력이 없습니다.',
        'zh': '沒有兌換記錄或積分記錄。',
        'zh-TW': '没有兑换记录或积分记录。',
      },
      'ポイント購入完了': {
        'en': 'Points purchase complete',
        'it': 'Acquisto punti completato',
        'de': 'Punktekauf abgeschlossen',
        'es': 'Compra de puntos completada',
        'fr': 'Achat de points terminé',
        'ko': '포인트 구매 완료',
        'zh': '積分購買完成',
        'zh-TW': '积分购买完成',
      },
      'ポイントのご購入ありがとうございました。': {
        'en': 'Thank you for purchasing points.',
        'it': 'Grazie per aver acquistato punti.',
        'de': 'Vielen Dank für den Kauf von Punkten.',
        'es': 'Gracias por comprar puntos.',
        'fr': 'Merci d\'avoir acheté des points.',
        'ko': '포인트를 구입해 주셔서 감사합니다.',
        'zh': '感謝您購買積分。',
        'zh-TW': '感谢您购买积分。',
      },
      'ポイント購入': {
        'en': 'Purchase points',
        'it': 'Punti di acquisto',
        'de': 'Kaufstellen',
        'es': 'Puntos de compra',
        'fr': 'Points d\'achat',
        'ko': '포인트 구매',
        'zh': '購買點數',
        'zh-TW': '购买点数',
      },
      '購入ポイント': {
        'en': 'Purchase points',
        'it': 'Punti di acquisto',
        'de': 'Kaufstellen',
        'es': 'Puntos de compra',
        'fr': 'Points d\'achat',
        'ko': '구매 포인트',
        'zh': '購買點數',
        'zh-TW': '购买点数',
      },
      'ポイントを': {
        'en': 'Points',
        'it': 'Punti',
        'de': 'Punkte',
        'es': 'Agujas',
        'fr': 'Points',
        'ko': '포인트를',
        'zh': '積分',
        'zh-TW': '积分',
      },
      '未選択のお品物は24時間でポイントへ自動変換されます': {
        'en': 'Unselected items will be automatically converted to points within 24 hours.',
        'it': 'Gli articoli non selezionati verranno convertiti automaticamente in punti entro 24 ore.',
        'de': 'Nicht ausgewählte Artikel werden innerhalb von 24 Stunden automatisch in Punkte umgewandelt.',
        'es': 'Los artículos no seleccionados se convertirán automáticamente en puntos en un plazo de 24 horas.',
        'fr': 'Les articles non sélectionnés seront automatiquement convertis en points sous 24 heures.',
        'ko': '선택되지 않은 제품은 24시간 내에 포인트로 자동 변환됩니다.',
        'zh': '未選擇的商品將在24小時內自動轉換為積分。',
        'zh-TW': '未选择的商品将在24小时内自动转换为积分。',
      },
      '発送は還元ポイントの合計が1000P以上からとなります。': {
        'en': 'Shipping will only be available for orders with a total of 1000 points or more.',
        'it': 'La spedizione sarà disponibile solo per ordini con un totale di 1000 punti o più.',
        'de': 'Der Versand ist nur für Bestellungen mit einem Gesamtwert von 1000 Punkten oder mehr möglich.',
        'es': 'El envío solo estará disponible para pedidos con un total de 1000 puntos o más.',
        'fr': 'La livraison ne sera disponible que pour les commandes d\'un montant total de 1000 points ou plus.',
        'ko': '발송은 환원 포인트의 합계가 1000 P이상이 됩니다.',
        'zh': '只有累計積分達到1000分或以上的訂單才能享有包郵服務。',
        'zh-TW': '只有累计积分达到1000分或以上的订单才能享受包邮服务。',
      },
      '還元ポイント（発送待ち商品）の合計が1000P未満の場合は、1000Pを超えてからの発送となります。': {
        'en': 'If the total points earned (for items awaiting shipment) are less than 1000 points, shipment will only be made after the total points exceed 1000 points.',
        'it': 'Se il totale dei punti accumulati (per gli articoli in attesa di spedizione) è inferiore a 1000 punti, la spedizione avverrà solo dopo che il totale dei punti avrà superato i 1000 punti.',
        'de': 'Wenn die Gesamtpunktzahl (für Artikel, die noch auf den Versand warten) unter 1000 Punkten liegt, erfolgt der Versand erst, wenn die Gesamtpunktzahl 1000 Punkte übersteigt.',
        'es': 'Si el total de puntos obtenidos (por los artículos pendientes de envío) es inferior a 1000 puntos, el envío solo se realizará una vez que el total de puntos supere los 1000 puntos.',
        'fr': 'Si le total des points accumulés (pour les articles en attente d\'expédition) est inférieur à 1000 points, l\'expédition ne sera effectuée qu\'une fois le total des points supérieur à 1000 points.',
        'ko': '환원 포인트(발송 대기 상품)의 합계가 1000 P미만의 경우는, 1000 P를 넘고 나서의 발송이 됩니다.',
        'zh': '如果（待出貨商品的）總積分少於 1000 分，則只有在總積分超過 1000 分後才會出貨。',
        'zh-TW': '如果（待发货商品的）总积分少于 1000 分，则只有在总积分超过 1000 分后才会发货。',
      },
      '株式会社はっち': {
        'en': 'Hatch Co., Ltd.',
        'it': 'Hatch Co., Ltd.',
        'de': 'Hatch Co., Ltd.',
        'es': 'Compañía Hatch, Ltd.',
        'fr': 'Hatch Co., Ltd.',
        'ko': '주식회사 하치',
        'zh': '哈奇有限公司',
        'zh-TW': '哈奇有限公司',
      },
      '大阪府大阪市平野区長吉出戸七丁目3-39': {
        'en': '3-39, Nagayoshideto 7-chome, Hirano-ku, Osaka City, Osaka Prefecture',
        'it': '3-39, Nagayoshideto 7-chome, Hirano-ku, Città di Osaka, Prefettura di Osaka',
        'de': '3-39, Nagayoshideto 7-chome, Hirano-ku, Stadt Osaka, Präfektur Osaka',
        'es': '3-39, Nagayoshideto 7-chome, Hirano-ku, ciudad de Osaka, prefectura de Osaka',
        'fr': '3-39, Nagayoshideto 7-chome, Hirano-ku, ville d\'Osaka, préfecture d\'Osaka',
        'ko': '오사카부 오사카시 히라노구 나가요시 데이치 나나초메 3-39',
        'zh': '大阪府大阪市平野區長吉出戶7丁目3-39',
        'zh-TW': '大阪府大阪市平野区长吉出户7丁目3-39',
      },
      '〒547-0011': {
        'en': '547-0011',
        'it': '547-0011',
        'de': '547-0011',
        'es': '547-0011',
        'fr': '547-0011',
        'ko': '〒547-0011',
        'zh': '547-0011',
        'zh-TW': '547-0011',
      },
      'TEL：06-6643-9996': {
        'en': 'TEL: 06-6643-9996',
        'it': 'TEL: 06-6643-9996',
        'de': 'TEL: 06-6643-9996',
        'es': 'TEL: 06-6643-9996',
        'fr': 'TÉL. : 06-6643-9996',
        'ko': 'TEL:06-6643-9996',
        'zh': '電話：06-6643-9996',
        'zh-TW': '电话：06-6643-9996',
      },
      'ドラゴンボール': {
        'en': 'Dragon Ball',
        'it': 'Dragon Ball',
        'de': 'Dragon Ball',
        'es': 'Dragon Ball',
        'fr': 'Dragon Ball',
        'ko': '드래곤볼',
        'zh': '七龍珠',
        'zh-TW': '龙珠',
      },
      'デュエルマスターズ': {
        'en': 'Duel Masters',
        'it': 'Maestri del Duello',
        'de': 'Duellmeister',
        'es': 'Maestros del Duelo',
        'fr': 'Maîtres du duel',
        'ko': '듀얼 마스터스',
        'zh': '決鬥大師',
        'zh-TW': '决斗大师',
      },
      'アーセナルベース': {
        'en': 'Arsenal base',
        'it': 'Base dell\'Arsenale',
        'de': 'Arsenalbasis',
        'es': 'Base del Arsenal',
        'fr': 'Base d\'Arsenal',
        'ko': '아스날 베이스',
        'zh': '阿森納基地',
        'zh-TW': '阿森纳基地',
      },
      'ホロライブ': {
        'en': 'Hololive',
        'it': 'Hololive',
        'de': 'Hololive',
        'es': 'Hololive',
        'fr': 'Hololive',
        'ko': '홀로 라이브',
        'zh': 'Hololive',
        'zh-TW': 'Hololive',
      },
      '八塚 健': {
        'en': 'Ken Yatsuzuka',
        'it': 'Ken Yatsuzuka',
        'de': 'Ken Yatsuzuka',
        'es': 'Ken Yatsuzuka',
        'fr': 'Ken Yatsuzuka',
        'ko': '하치즈카 켄',
        'zh': '八塚健',
        'zh-TW': '八冢健',
      },
      'デジタルコンテンツ': {
        'en': 'Digital content',
        'it': 'Contenuti digitali',
        'de': 'Digitale Inhalte',
        'es': 'Contenido digital',
        'fr': 'contenu numérique',
        'ko': '디지털 콘텐츠',
        'zh': '數位內容',
        'zh-TW': '数字内容',
      },
      '今月{remaining}コイン購入が必要': {
        'en': '{remaining} coins needed this month',
        'it': '{remaining} monete necessarie questo mese',
        'de': '{remaining} Coins benötigt diesen Monat',
        'es': 'Se necesitan {remaining} monedas este mes',
        'fr': '{remaining} pièces nécessaires ce mois-ci',
        'ko': '이번 달에 코인 {remaining} 개 필요',
        'zh': '本月需要 {remaining} 枚硬幣',
        'zh-TW': '本月需要 {remaining} 枚硬币',
      },
      '購入可能': {
        'en': 'Available for purchase',
        'it': 'Disponibile per l\'acquisto',
        'de': 'Zum Kauf erhältlich',
        'es': 'Disponible para la compra',
        'fr': 'Disponible à l\'achat',
        'ko': '구매 가능',
        'zh': '可供購買',
        'zh-TW': '可供购买',
      },
      'ダイヤバンク': {
        'en': 'Diamond Bank',
        'it': 'Banca dei Diamanti',
        'de': 'Diamantenbank',
        'es': 'Banco de Diamantes',
        'fr': 'Banque de diamants',
        'ko': '다이아 뱅크',
        'zh': '鑽石銀行',
        'zh-TW': '钻石银行',
      },
      '紹介ボーナス': {
        'en': 'Referral Bonus',
        'it': 'Bonus di segnalazione',
        'de': 'Empfehlungsbonus',
        'es': 'Bonificación por recomendación',
        'fr': 'Bonus de parrainage',
        'ko': '소개 보너스',
        'zh': '推薦獎金',
        'zh-TW': '推荐奖金',
      },
      '紹介ボーナスコイン': {
        'en': 'Referral bonus coins',
        'it': 'Monete bonus per la segnalazione',
        'de': 'Empfehlungsbonusmünzen',
        'es': 'monedas de bonificación por referidos',
        'fr': 'Pièces bonus de parrainage',
        'ko': '소개 보너스 동전',
        'zh': '推薦獎勵金幣',
        'zh-TW': '推荐奖励金币',
      },
      '支払方法': {
        'en': 'payment method',
        'it': 'metodo di pagamento',
        'de': 'Zahlungsmethode',
        'es': 'método de pago',
        'fr': 'mode de paiement',
        'ko': '지불 방법',
        'zh': '付款方式',
        'zh-TW': '付款方式',
      },
      '支払方法変更': {
        'en': 'Change payment method',
        'it': 'Modifica il metodo di pagamento',
        'de': 'Zahlungsmethode ändern',
        'es': 'Cambiar método de pago',
        'fr': 'Changer le mode de paiement',
        'ko': '지불 방법 변경',
        'zh': '更改付款方式',
        'zh-TW': '更改付款方式',
      },
      '{min}円以上の価格で出品できます。': {
        'en': 'It can be sold at a price of {min} yen or more.',
        'it': 'Può essere venduto a un prezzo di {min} yen o più.',
        'de': 'Es kann zu einem Preis von {min} Yen oder mehr verkauft werden.',
        'es': 'Det kan säljas för ett pris av {min} yen eller mer.',
        'fr': 'Il peut être vendu à un prix de {min} yens ou plus.',
        'ko': '{min} 엔 이상에 판매할 수 있습니다.',
        'zh': 'Può essere venduto a un prezzo di {min} 日元 o più。',
        'zh-TW': 'Può essere venduto a un prezzo di {min} 日元 o più。',
      },
      '販売価格を更新する': {
        'en': 'Update the selling price',
        'it': 'Aggiorna il prezzo di vendita',
        'de': 'Aktualisieren Sie den Verkaufspreis',
        'es': 'Actualizar el precio de venta',
        'fr': 'Mettre à jour le prix de vente',
        'ko': '판매 가격 업데이트',
        'zh': '更新售價',
        'zh-TW': '更新售价',
      },
      '価格を変更する': {
        'en': 'Change price',
        'it': 'Modifica il prezzo',
        'de': 'Preis ändern',
        'es': 'Cambiar precio',
        'fr': 'Changer le prix',
        'ko': '가격 변경',
        'zh': '更改價格',
        'zh-TW': '更改价格',
      },
      'PSAのみ表示': {
        'en': 'Show PSA Graded only',
        'it': 'Mostra solo PSA Graded',
        'de': 'Nur PSA-bewertete anzeigen',
        'es': 'Mostrar solo artículos calificados por PSA',
        'fr': 'Afficher uniquement les cartes gradées PSA',
        'ko': 'PSA 등급품만 표시',
        'zh': '只顯示 PSA 評級項目',
        'zh-TW': '仅显示 PSA 评级的项目',
      },
      'PSAを非表示': {
        'en': 'Hide PSA Graded',
        'it': 'Nascondi PSA Graded',
        'de': 'PSA-Bewertete ausblenden',
        'es': 'Ocultar PSA calificado',
        'fr': 'Masquer PSA Graded',
        'ko': 'PSA 감정품 숨기기',
        'zh': '隱藏 PSA 評級',
        'zh-TW': '隐藏 PSA 评级',
      },
      'ボーナス': {
        'en': 'bonus',
        'it': 'bonus',
        'de': 'Bonus',
        'es': 'prima',
        'fr': 'prime',
        'ko': '보너스',
        'zh': '獎金',
        'zh-TW': '奖金',
      },
      '埼玉県さいたま市大宮区桜木町1丁目195‑1 大宮ソラミチKOZ4階': {
        'en': '4th Floor, Omiya Soramichi KOZ, 1-195-1 Sakuragi-cho, Omiya-ku, Saitama City, Saitama Prefecture',
        'it': '4° piano, Omiya Soramichi KOZ, 1-195-1 Sakuragi-cho, Omiya-ku, città di Saitama, prefettura di Saitama',
        'de': '4. Stock, Omiya Soramichi KOZ, 1-195-1 Sakuragi-cho, Omiya-ku, Stadt Saitama, Präfektur Saitama',
        'es': '4.° piso, Omiya Soramichi KOZ, 1-195-1 Sakuragi-cho, Omiya-ku, ciudad de Saitama, prefectura de Saitama',
        'fr': '4e étage, Omiya Soramichi KOZ, 1-195-1 Sakuragi-cho, Omiya-ku, ville de Saitama, préfecture de Saitama',
        'ko': '사이타마현 사이타마시 오미야구 사쿠라기초 1가 195-1 오미야 소라미치 KOS 4층',
        'zh': '埼玉縣埼玉市大宮區櫻木町1-195-1 大宮空道KOZ 4樓',
        'zh-TW': '埼玉县埼玉市大宫区樱木町1-195-1 大宫空道KOZ 4楼',
      },
      '弊社へ査定依頼品の発送(発払い)': {
        'en': 'Send your cards',
        'it': 'Manda le tue carte',
        'de': 'Senden Sie Ihre Karten',
        'es': 'Envía tus cartas',
        'fr': 'Envoyez vos cartes',
        'ko': '카드를 보내세요',
        'zh': '寄出你的卡片',
        'zh-TW': '寄出你的卡片',
      },
      ' & 買取申込フォームの送信': {
        'en': '',
        'it': '',
        'de': '',
        'es': '',
        'fr': '',
        'ko': '',
        'zh': '',
        'zh-TW': '',
      },
      'メールにて査定結果の送信': {
        'en': 'Get your quote',
        'it': 'Ottieni il tuo preventivo',
        'de': 'Holen Sie sich Ihr Angebot',
        'es': 'Obtén tu presupuesto',
        'fr': 'Obtenez votre devis',
        'ko': '견적을 받아보세요',
        'zh': '取得您的報價',
        'zh-TW': '获取您的报价',
      },
      '(到着後2営業日以内)': {
        'en': '',
        'it': '',
        'de': '',
        'es': '',
        'fr': '',
        'ko': '',
        'zh': '',
        'zh-TW': '',
      },
      'お振込': {
        'en': 'Get paid',
        'it': 'Essere pagato',
        'de': 'Bezahlt werden',
        'es': 'Recibe pago',
        'fr': 'Être payé',
        'ko': '급여를 받다',
        'zh': '領取報酬',
        'zh-TW': '获得报酬',
      },
      '(査定結果へのご同意後2営業日以内)': {
        'en': '',
        'it': '',
        'de': '',
        'es': '',
        'fr': '',
        'ko': '',
        'zh': '',
        'zh-TW': '',
      },
      '査定額の受け取り方法': {
        'en': 'How would you like to get paid?',
        'it': 'Come vorresti essere pagato?',
        'de': 'Wie möchten Sie bezahlt werden?',
        'es': '¿Cómo te gustaría recibir el pago?',
        'fr': 'Comment souhaitez-vous être payé ?',
        'ko': '어떻게 지급받고 싶으신가요?',
        'zh': '您想如何收款？',
        'zh-TW': '您想如何收款？',
      },
      '内訳': {
        'en': '',
        'it': '',
        'de': '',
        'es': '',
        'fr': '',
        'ko': '',
        'zh': '',
        'zh-TW': '',
      },
      '現金+ボーナスコイン1%': {
        'en': 'Cash + 1% bonus in coins',
        'it': 'Contanti + bonus dell\'1% in monete',
        'de': 'Bargeld + 1 % Bonus in Coins',
        'es': 'Efectivo + 1% de bonificación en monedas',
        'fr': 'Cash + 1 % de bonus en pièces',
        'ko': '현금 + 코인 1% 보너스',
        'zh': '現金 + 1% 金幣回饋',
        'zh-TW': '现金 + 1% 硬币奖励',
      },
      'マイナンバーカードの場合は表面のみ': {
        'en': '',
        'it': '',
        'de': '',
        'es': '',
        'fr': '',
        'ko': '',
        'zh': '',
        'zh-TW': '',
      },
      '表面': {
        'en': 'Front side',
        'it': 'Lato anteriore',
        'de': 'Vorderseite',
        'es': 'Lado frontal',
        'fr': 'Face avant',
        'ko': '앞면',
        'zh': '正面',
        'zh-TW': '正面',
      },
      '裏面': {
        'en': 'Back side',
        'it': 'Lato posteriore',
        'de': 'Rückseite',
        'es': 'Parte trasera',
        'fr': 'Arrière',
        'ko': '뒷면',
        'zh': '背面',
        'zh-TW': '背面',
      },
      ' 申し込みへ ': {
        'en': 'Submit Request',
        'it': 'Invia richiesta',
        'de': 'Anfrage senden',
        'es': 'Enviar solicitud',
        'fr': 'Soumettre la demande',
        'ko': '요청 제출',
        'zh': '提交請求',
        'zh-TW': '提交请求',
      },
      'VTuber': {
        'en': 'VTuber',
        'it': 'VTuber',
        'de': 'VTuber',
        'es': 'VTuber',
        'fr': 'VTuber',
        'ko': 'VTuber',
        'zh': '虛擬主播',
        'zh-TW': '虚拟主播',
      },
      '俳優': {
        'en': 'actor',
        'it': 'attore',
        'de': 'Schauspieler',
        'es': 'actor',
        'fr': 'acteur',
        'ko': '배우',
        'zh': '演員',
        'zh-TW': '演员',
      },
      'グッズ': {
        'en': 'merchandise',
        'it': 'merce',
        'de': 'Waren',
        'es': 'mercancías',
        'fr': 'marchandises',
        'ko': '상품',
        'zh': '商品',
        'zh-TW': '商品',
      },
      'スポーツ': {
        'en': 'Sports',
        'it': 'Sport',
        'de': 'Sport',
        'es': 'Deportes',
        'fr': 'Sportif',
        'ko': '스포츠',
        'zh': '運動的',
        'zh-TW': '运动的',
      },
      '1タップで「ダウンロード」': {
        'en': 'Download with one tap',
        'it': 'Scarica con un solo tocco',
        'de': 'Mit einem Fingertipp herunterladen',
        'es': 'Descarga con un solo toque',
        'fr': 'Télécharger en un clic',
        'ko': '1 탭으로 "다운로드"',
        'zh': '一鍵下載',
        'zh-TW': '一键下载',
      },
      'ダウンロード': {
        'en': 'download',
        'it': 'scaricamento',
        'de': 'herunterladen',
        'es': 'descargar',
        'fr': 'télécharger',
        'ko': '다운로드',
        'zh': '下載',
        'zh-TW': '下载',
      },
      'ダウンロードのみ': {
        'en': 'Download only',
        'it': 'Solo download',
        'de': 'Nur herunterladen',
        'es': 'Solo descarga',
        'fr': 'Téléchargement uniquement',
        'ko': '다운로드만',
        'zh': '僅下載',
        'zh-TW': '仅下载',
      },
      'ダウンロード済み': {
        'en': 'Downloaded',
        'it': 'Scaricato',
        'de': 'Heruntergeladen',
        'es': 'Descargado',
        'fr': 'Téléchargé',
        'ko': '다운로드됨',
        'zh': '下載',
        'zh-TW': '下载',
      },
      'ダウンロード済み一覧': {
        'en': 'Downloaded items list',
        'it': 'Elenco degli elementi scaricati',
        'de': 'Liste der heruntergeladenen Elemente',
        'es': 'Lista de elementos descargados',
        'fr': 'Liste des éléments téléchargés',
        'ko': '다운로드된 목록',
        'zh': '下載項目列表',
        'zh-TW': '下载项目列表',
      },
      '表示': {
        'en': 'display',
        'it': 'display',
        'de': 'Anzeige',
        'es': 'mostrar',
        'fr': 'afficher',
        'ko': '표시',
        'zh': '展示',
        'zh-TW': '展示',
      },
      '景品を確認する': {
        'en': 'Check your prize',
        'it': 'Controlla il tuo premio',
        'de': 'Überprüfen Sie Ihren Gewinn',
        'es': 'Comprueba tu premio',
        'fr': 'Vérifiez votre prix',
        'ko': '경품 확인',
        'zh': '查看您的獎品',
        'zh-TW': '查看您的奖品',
      },
      '販売商品': {
        'en': 'Products for sale',
        'it': 'Prodotti in vendita',
        'de': 'Produkte zum Verkauf',
        'es': 'Productos en venta',
        'fr': 'Produits à vendre',
        'ko': '판매 상품',
        'zh': '待售產品',
        'zh-TW': '待售产品',
      },
      'あとで決める': {
        'en': 'Decide later',
        'it': 'Decidi più tardi',
        'de': 'Später entscheiden',
        'es': 'Decídelo después',
        'fr': 'Décider plus tard',
        'ko': '나중에 결정하기',
        'zh': '之後再決定',
        'zh-TW': '以后再决定',
      },
      'ウルトラマン': {
        'en': 'Ultraman',
        'it': 'Ultraman',
        'de': 'Ultraman',
        'es': 'Ultraman',
        'fr': 'Ultraman',
        'ko': '울트라맨',
        'zh': '奧特曼',
        'zh-TW': '奥特曼',
      },
      'Googleアカウント or AppleIDで登録': {
        'en': 'Register with your Google account or Apple ID',
        'it': 'Registrati con il tuo account Google o ID Apple',
        'de': 'Registrieren Sie sich mit Ihrem Google-Konto oder Ihrer Apple-ID.',
        'es': 'Regístrate con tu cuenta de Google o tu ID de Apple.',
        'fr': 'Inscrivez-vous avec votre compte Google ou votre identifiant Apple.',
        'ko': 'Google 계정 또는 AppleID로 등록',
        'zh': '使用您的 Google 帳戶或 Apple ID 註冊',
        'zh-TW': '使用您的 Google 帐户或 Apple ID 注册',
      },
      'メールアドレスで登録': {
        'en': 'Register with your email address',
        'it': 'Registrati con il tuo indirizzo email',
        'de': 'Registrieren Sie sich mit Ihrer E-Mail-Adresse',
        'es': 'Regístrate con tu dirección de correo electrónico.',
        'fr': 'Inscrivez-vous avec votre adresse e-mail',
        'ko': '이메일 주소로 등록',
        'zh': '使用您的電子郵件地址註冊',
        'zh-TW': '使用您的电子邮件地址注册',
      },
      'Googleアカウント or AppleIDでログイン': {
        'en': 'Log in with your Google account or Apple ID',
        'it': 'Accedi con il tuo account Google o con il tuo ID Apple',
        'de': 'Melde dich mit deinem Google-Konto oder deiner Apple-ID an.',
        'es': 'Inicia sesión con tu cuenta de Google o tu ID de Apple.',
        'fr': 'Connectez-vous avec votre compte Google ou votre identifiant Apple.',
        'ko': 'Google 계정 또는 AppleID로 로그인',
        'zh': '使用您的 Google 帳戶或 Apple ID 登入',
        'zh-TW': '使用您的 Google 帐户或 Apple ID 登录',
      },
      'メールアドレスでログイン': {
        'en': 'Log in with your email address',
        'it': 'Accedi con il tuo indirizzo email',
        'de': 'Melden Sie sich mit Ihrer E-Mail-Adresse an',
        'es': 'Inicia sesión con tu dirección de correo electrónico.',
        'fr': 'Connectez-vous avec votre adresse e-mail',
        'ko': '이메일 주소로 로그인',
        'zh': '使用您的電子郵件地址登入',
        'zh-TW': '使用您的电子邮件地址登录',
      },
      'アカウントをお持ちでない方は': {
        'en': 'If you do not have an account,',
        'it': 'Se non hai un account,',
        'de': 'Falls Sie kein Konto haben,',
        'es': 'Si no tienes una cuenta,',
        'fr': 'Si vous n\'avez pas de compte,',
        'ko': '계정이 없다면',
        'zh': '如果您沒有帳戶，',
        'zh-TW': '如果您没有账户，',
      },
      'アカウントをお持ちの方は': {
        'en': 'If you have an account,',
        'it': 'Se hai un account,',
        'de': 'Wenn Sie ein Konto haben,',
        'es': 'Si tienes una cuenta,',
        'fr': 'Si vous avez un compte,',
        'ko': '계정을 가지고 계신 분은',
        'zh': '如果您有帳戶，',
        'zh-TW': '如果您有账户，',
      },
      '購入履歴': {
        'en': 'Purchase history',
        'it': 'Cronologia acquisti',
        'de': 'Kaufhistorie',
        'es': 'Historial de compras',
        'fr': 'Historique des achats',
        'ko': '구매 내역',
        'zh': '購買歷史',
        'zh-TW': '购买历史',
      },
      'このサイトについて': {
        'en': 'About this site',
        'it': 'Informazioni su questo sito',
        'de': 'Über diese Website',
        'es': 'Acerca de este sitio',
        'fr': 'À propos de ce site',
        'ko': '이 사이트 정보',
        'zh': '關於本網站',
        'zh-TW': '关于本网站',
      },
      '様々なアイテムをガチャでゲット！': {
        'en': 'Get various items through gacha!',
        'it': 'Ottieni vari oggetti tramite il gacha!',
        'de': 'Erhalte verschiedene Gegenstände durch Gacha-Systeme!',
        'es': '¡Consigue varios artículos a través del gacha!',
        'fr': 'Obtenez divers objets grâce au gacha !',
        'ko': '다양한 아이템을 뽑기로 획득!',
        'zh': '透過扭蛋獲得各種物品！',
        'zh-TW': '通过扭蛋获得各种物品！',
      },
      'まずは会員登録！': {
        'en': 'First, register as a member!',
        'it': 'Innanzitutto, registrati come membro!',
        'de': 'Registrieren Sie sich zunächst als Mitglied!',
        'es': 'Primero, ¡regístrate como miembro!',
        'fr': 'Commencez par vous inscrire comme membre !',
        'ko': '우선 회원 등록!',
        'zh': '首先，註冊成為會員！',
        'zh-TW': '首先，注册成为会员！',
      },
      'コインを購入！': {
        'en': 'I bought coins!',
        'it': 'Ho comprato delle monete!',
        'de': 'Ich habe Münzen gekauft!',
        'es': '¡Compré monedas!',
        'fr': 'J\'ai acheté des pièces !',
        'ko': '동전을 구입!',
        'zh': '我買了金幣！',
        'zh-TW': '我买了金币！',
      },
      'ガチャを回す！': {
        'en': 'Spin the gacha!',
        'it': 'Gira la ruota della fortuna!',
        'de': 'Dreh am Gacha-Automaten!',
        'es': '¡Gira la gacha!',
        'fr': 'Faites tourner le gacha !',
        'ko': '뽑기를 돌려!',
        'zh': '轉動扭蛋！',
        'zh-TW': '转动扭蛋！',
      },
      '受け取り！': {
        'en': 'Received!',
        'it': 'Ricevuto!',
        'de': 'Erhalten!',
        'es': '¡Recibió!',
        'fr': 'Reçu!',
        'ko': '수령!',
        'zh': '已收到！',
        'zh-TW': '已收到！',
      },
      '次回以降表示しない': {
        'en': 'Do not show this again next time.',
        'it': 'Non mostrare più questo messaggio la prossima volta.',
        'de': 'Zeig das beim nächsten Mal nicht mehr.',
        'es': 'No vuelvas a mostrar esto la próxima vez.',
        'fr': 'Ne plus afficher ceci la prochaine fois.',
        'ko': '다음 번부터 표시하지 않음',
        'zh': '下次不要再顯示此內容。',
        'zh-TW': '下次不要再显示此内容。',
      },
      'SMS認証完了後、マイページに表示される「紹介コード」をご友人に会員登録時に入力してもらってください。\nそのご友人が「SMS認証」と「コイン購入」で、あなたとご友人の双方にコインが入ります。\n※双方が貰えるコイン数はこちらからご確認ください。': {
        'en': 'After SMS verification, your friend enters your referral code during signup.\nOnce they purchase coins, both of you receive rewards.',
        'it': 'Dopo la verifica tramite SMS, il tuo amico inserisce il tuo codice referral durante la registrazione.\nUna volta acquistate le monete, entrambi ricevete delle ricompense.',
        'de': 'Nach der SMS-Verifizierung gibt dein Freund bei der Registrierung deinen Empfehlungscode ein.\nSobald er Münzen kauft, erhaltet ihr beide Belohnungen.',
        'es': 'Después de la verificación por SMS, tu amigo ingresa tu código de referido durante el registro.\nUna vez que compre monedas, ambos reciben recompensas.',
        'fr': 'Après la vérification par SMS, votre ami saisit votre code de parrainage lors de l’inscription.\nUne fois qu’il achète des pièces, vous recevez tous les deux des récompenses.',
        'ko': 'SMS 인증 후, 친구가 회원가입 중에 회원님의 추천 코드를 입력합니다.\n친구가 코인을 구매하면 두 분 모두 보상을 받습니다.',
        'zh': '完成簡訊驗證後，您的朋友在註冊時輸入您的推薦碼。\n當對方購買金幣後，您們雙方都會獲得獎勵。',
        'zh-TW': '短信验证后，您的朋友在注册时输入您的推荐码。\n一旦他们购买金币，您和您的朋友都将获得奖励。',
      },
      'シルバー会員以上の方はマイページの専用ボタンでコインを消費することにより、1つ下のランクから翌月はスタートすることが可能です。\n※ブロンズランクは3ヶ月間ブロンズが維持されます。\n詳細はこちらからご確認ください。': {
        'en': 'Silver and above can maintain rank by spending coins on My Page.\nBronze is maintained for up to 3 months.',
        'it': 'Argento e superiori possono mantenere il proprio grado spendendo monete su La Mia Pagina.\nIl Bronzo viene mantenuto per un massimo di 3 mesi.',
        'de': 'Silber und höher können ihren Rang beibehalten, indem sie auf Meine Seite Münzen ausgeben.\nBronze wird bis zu 3 Monate lang beibehalten.',
        'es': 'Plata y superior pueden mantener el rango gastando monedas en Mi página.\nEl bronce se mantiene hasta por 3 meses.',
        'fr': 'Les rangs Argent et supérieurs peuvent être conservés en dépensant des pièces sur Ma page.\nLe rang Bronze est conservé pendant 3 mois maximum.',
        'ko': '실버 이상은 마이 페이지에서 코인을 사용해 등급을 유지할 수 있습니다.\n브론즈는 최대 3개월간 유지됩니다.',
        'zh': '白銀及以上可透過在我的頁面消耗金幣來維持等級。\n青銅最多可維持 3 個月。',
        'zh-TW': '白银及以上可通过在“我的页面”消费金币来维持等级。\n青铜最多可维持3个月。',
      },
      'ご検討ありがとうございます。まずはこちらよりお問合せをお願いいたします。': {
        'en': 'Thank you for your consideration. Please contact us from here first.',
        'it': 'Grazie per la Sua considerazione. La preghiamo di contattarci prima da qui.',
        'de': 'Vielen Dank für Ihre Aufmerksamkeit. Bitte kontaktieren Sie uns zuerst von hier aus.',
        'es': 'Gracias por su consideración. Por favor, contáctenos primero desde aquí.',
        'fr': 'Merci pour votre considération. Veuillez nous contacter d’abord à partir d’ici.',
        'ko': '검토해 주셔서 감사합니다. 먼저 이곳으로 연락해 주세요.',
        'zh': '感謝您的考慮。請先從這裡聯絡我們。',
        'zh-TW': '感谢您的考虑。请先通过这里联系我们。',
      },
      '原則2営業日以内にお返事いたします。': {
        'en': 'We usually respond within 2 business days.',
        'it': 'Di solito rispondiamo entro 2 giorni lavorativi.',
        'de': 'Wir antworten in der Regel innerhalb von 2 Werktagen.',
        'es': 'Normalmente respondemos en un plazo de 2 días laborables.',
        'fr': 'Nous répondons généralement sous 2 jours ouvrés.',
        'ko': '저희는 보통 영업일 기준 2일 이내에 답변드립니다.',
        'zh': '我們通常會在 2 個工作天內回覆。',
        'zh-TW': '我们通常会在 2 个工作日内回复。',
      },
      '動画を離脱することなく、最後までご視聴ください。\nそれでも反映されない場合は恐れ入りますがお問い合わせくださいませ。': {
        'en': 'Watch the full video without skipping.\nIf coins are not added, contact support.',
        'it': 'Guarda il video completo senza saltare.\nSe le monete non vengono aggiunte, contatta il supporto.',
        'de': 'Sieh dir das vollständige Video an, ohne zu überspringen.\nWenn keine Münzen hinzugefügt werden, kontaktiere den Support.',
        'es': 'Mira el video completo sin saltarlo.\nSi no se agregan monedas, contacta con soporte.',
        'fr': 'Regardez la vidéo complète sans la passer.\nSi les pièces ne sont pas ajoutées, contactez l’assistance.',
        'ko': '건너뛰지 말고 전체 영상을 시청하세요.\n코인이 추가되지 않으면 지원팀에 문의하세요.',
        'zh': '請完整觀看影片，不要跳過。\n如果硬幣未入帳，請聯絡客服。',
        'zh-TW': '完整观看视频，不要跳过。\n如果硬币未添加，请联系客服。',
      },
      '発送は、毎月5日・10日・15日・20日・25日・月末におこなわせていただきます。': {
        'en': 'Orders are shipped around the 10th, 20th, and 30th each month.\nDelays may occur depending on volume.',
        'it': 'Gli ordini vengono spediti intorno al 10, al 20 e al 30 di ogni mese.\nPotrebbero verificarsi ritardi a seconda del volume.',
        'de': 'Bestellungen werden jeweils um den 10., 20. und 30. eines jeden Monats versandt.\nJe nach Auftragsvolumen kann es zu Verzögerungen kommen.',
        'es': 'Los pedidos se envían alrededor de los días 10, 20 y 30 de cada mes.\nPueden producirse retrasos según el volumen.',
        'fr': 'Les commandes sont expédiées autour des 10, 20 et 30 de chaque mois.\nDes retards peuvent survenir en fonction du volume.',
        'ko': '주문은 매월 10일, 20일, 30일경에 발송됩니다.\n물량에 따라 지연이 발생할 수 있습니다.',
        'zh': '訂單通常會在每月的10日、20日和30日前後出貨。\n視訂單量而定，可能會有所延遲。',
        'zh-TW': '订单通常会在每月10日、20日和30日前后发货。\n根据订单量情况，可能会出现延迟。',
      },
      '配送過程で傷が付かないよう丁寧に梱包することを心掛けます。\nもし、ご希望やご要望等がございましたらご遠慮なく本サイトのチャットよりお申し付けくださいませ。': {
        'en': 'Items are securely packaged to prevent damage.',
        'it': 'Gli articoli sono imballati in modo sicuro per evitare danni.',
        'de': 'Die Artikel sind sicher verpackt, um Schäden zu vermeiden.',
        'es': 'Los artículos están embalados de forma segura para evitar daños.',
        'fr': 'Les articles sont soigneusement emballés pour éviter tout dommage.',
        'ko': '상품은 손상을 방지하기 위해 안전하게 포장됩니다.',
        'zh': '物品均經過安全包裝，以防止損壞。',
        'zh-TW': '物品经过安全包装，以防止损坏。',
      },
      'ヤマト運輸にて発送いたします。': {
        'en': 'We use Japan Post, FedEx, and other carriers.',
        'it': 'Utilizziamo Japan Post, FedEx e altri corrieri.',
        'de': 'Wir nutzen Japan Post, FedEx und andere Versanddienstleister.',
        'es': 'Usamos Japan Post, FedEx y otros transportistas.',
        'fr': 'Nous utilisons Japan Post, FedEx et d’autres transporteurs.',
        'ko': '저희는 일본우편, FedEx 및 기타 운송업체를 이용합니다.',
        'zh': '我們使用日本郵政、FedEx 和其他承運商。',
        'zh-TW': '我们使用日本邮政、联邦快递和其他承运商。',
      },
      '送料は弊社が全額負担で元払いで発送いたします。': {
        'en': 'Shipping is free.\nCustoms duties are the customer\'s responsibility.',
        'it': 'La spedizione è gratuita.\nI dazi doganali sono a carico del cliente.',
        'de': 'Der Versand ist kostenlos.\nZollgebühren liegen in der Verantwortung des Kunden.',
        'es': 'El envío es gratis.\nLos aranceles aduaneros son responsabilidad del cliente.',
        'fr': 'La livraison est gratuite.\nLes droits de douane sont à la charge du client.',
        'ko': '배송은 무료입니다.\n관세는 고객 부담입니다.',
        'zh': '免運費。\n關稅由顧客自行負擔。',
        'zh-TW': '免运费。\n关税由客户承担。',
      },
      'こちらよりご確認をお願いいたします。': {
        'en': 'Tracking may be updated the next business day after shipment.',
        'it': 'Il tracciamento potrebbe essere aggiornato il giorno lavorativo successivo alla spedizione.',
        'de': 'Die Sendungsverfolgung wird möglicherweise am nächsten Werktag nach dem Versand aktualisiert.',
        'es': 'El seguimiento puede actualizarse el siguiente día hábil después del envío.',
        'fr': 'Le suivi peut être mis à jour le jour ouvrable suivant après l’expédition.',
        'ko': '배송 후 다음 영업일에 배송 추적 정보가 업데이트될 수 있습니다.',
        'zh': '出貨後的下一個工作日可能會更新追蹤資訊。',
        'zh-TW': '发货后下一个工作日可能会更新物流信息。',
      },
      '発送通知日と実際の発送日は配送業務の関係上異なってしまうことがございます。\nそのため、毎月5日・10日・15日・20日・25日・月末の夕方以降にご確認をお願いいたします。': {
        'en': 'Tracking may be available the next business day after shipment.',
        'it': 'Il tracciamento potrebbe essere disponibile il giorno lavorativo successivo alla spedizione.',
        'de': 'Die Sendungsverfolgung ist möglicherweise am nächsten Werktag nach dem Versand verfügbar.',
        'es': 'Es posible que el seguimiento esté disponible el siguiente día hábil después del envío.',
        'fr': 'Le suivi peut être disponible le jour ouvrable suivant l’expédition.',
        'ko': '배송 후 다음 영업일에 배송 추적이 가능할 수 있습니다.',
        'zh': '貨件寄出後的下一個工作天可能可提供追蹤資訊。',
        'zh-TW': '发货后的下一个工作日可能可以查询物流信息。',
      },
      'マイページよりご変更をお願いいたします。': {
        'en': 'You can update your address on My Page.',
        'it': 'Puoi aggiornare il tuo indirizzo nella tua pagina personale.',
        'de': 'Sie können Ihre Adresse auf „Meine Seite“ aktualisieren.',
        'es': 'Puedes actualizar tu dirección en Mi página.',
        'fr': 'Vous pouvez mettre à jour votre adresse sur Ma page.',
        'ko': '마이 페이지에서 주소를 업데이트할 수 있습니다.',
        'zh': '您可以在我的頁面更新您的地址。',
        'zh-TW': '您可以在“我的页面”上更新您的地址。',
      },
      '一律「中古品(二次流通品)・傷あり品」というご認識でお願いいたします。\nご留意事項等はこちらよりご確認をお願いいたします。': {
        'en': 'All items are second-hand and may have minor scratches.',
        'it': 'Tutti gli articoli sono di seconda mano e potrebbero presentare piccoli graffi.',
        'de': 'Alle Artikel sind gebraucht und können leichte Kratzer aufweisen.',
        'es': 'Todos los artículos son de segunda mano y pueden tener pequeños arañazos.',
        'fr': 'Tous les articles sont d’occasion et peuvent présenter de légères rayures.',
        'ko': '모든 상품은 중고이며 약간의 흠집이 있을 수 있습니다.',
        'zh': '所有商品皆為二手，可能有輕微刮痕。',
        'zh-TW': '所有物品均为二手，可能有轻微划痕。',
      },
      '弊社で保管しているデータと確認させていただきます。\n恐れ入りますが、こちらよりお問い合わせくださいませ。': {
        'en': 'Contact support immediately.',
        'it': 'Contatta immediatamente il supporto.',
        'de': 'Wenden Sie sich umgehend an den Support.',
        'es': 'Contacte con el soporte inmediatamente.',
        'fr': 'Contactez immédiatement le support.',
        'ko': '즉시 지원팀에 문의하세요.',
        'zh': '立即聯絡客服支援。',
        'zh-TW': '立即联系支持人员。',
      },
      '出品は、ブロンズ会員以上の方のみとなります。\nまた、当該ガチャの1回あたりの販売コイン数を上回る還元コイン数以上のお品物しか出品できません。': {
        'en': 'Only Bronze members and above can list items for sale.\n\nFurthermore, you can only list items whose value in return exceeds the number of coins earned per single draw of the gacha.',
        'it': 'Solo i membri Bronze e superiori possono mettere in vendita gli oggetti.\n\nInoltre, puoi mettere in vendita solo gli oggetti il cui valore in cambio supera il numero di monete ottenute per una singola estrazione del gacha.',
        'de': 'Nur Bronze-Mitglieder und höher können Gegenstände zum Verkauf anbieten.\n\nAußerdem können Sie nur Gegenstände anbieten, deren Gegenwert die Anzahl der Münzen übersteigt, die bei einer einzelnen Ziehung der Gacha verdient werden.',
        'es': 'Solo los miembros Bronze y superiores pueden poner artículos a la venta.\n\nAdemás, solo puedes poner a la venta artículos cuyo valor de retorno supere la cantidad de monedas obtenidas por una sola tirada de la gacha.',
        'fr': 'Seuls les membres Bronze et supérieurs peuvent mettre des objets en vente.\n\nDe plus, vous ne pouvez mettre en vente que des objets dont la valeur en retour dépasse le nombre de pièces obtenues pour un seul tirage du gacha.',
        'ko': '브론즈 회원 이상만 상품을 판매 등록할 수 있습니다.\n\n또한, 가챠 1회 뽑기당 획득하는 코인 수보다 더 높은 가치의 상품만 판매 등록할 수 있습니다.',
        'zh': '只有青銅會員以上才能刊登商品出售。\n\n此外，你只能刊登可換回價值高於扭蛋單次抽取所獲得硬幣數量的商品。',
        'zh-TW': '只有青铜会员及以上级别的会员才能上架出售物品。\n\n此外，你只能上架那些换回价值高于扭蛋单次抽取所获得金币数量的物品。',
      },
      'ログイン画面よりパスワード再発行をクリックして、仮パスワードでログインしてください。\nその後、マイページよりパスワードをご変更ください。': {
        'en': 'Use "Reset Password" on the login screen.',
        'it': 'Usa "Reimposta password" nella schermata di accesso.',
        'de': 'Verwenden Sie auf dem Anmeldebildschirm „Passwort zurücksetzen“.',
        'es': 'Usa "Restablecer contraseña" en la pantalla de inicio de sesión.',
        'fr': 'Utilisez « Réinitialiser le mot de passe » sur l’écran de connexion.',
        'ko': '로그인 화면에서 "비밀번호 재설정"을 사용하세요.',
        'zh': '在登入畫面上使用「重設密碼」。',
        'zh-TW': '在登录界面上使用“重置密码”。',
      },
      '恐れ入りますが、こちらよりその旨のご連絡をお願いいたします。': {
        'en': 'Contact support to request account closure.',
        'it': 'Contatta l\'assistenza per richiedere la chiusura dell\'account.',
        'de': 'Kontaktieren Sie den Support, um die Schließung des Kontos zu beantragen.',
        'es': 'Contacta con soporte para solicitar el cierre de la cuenta.',
        'fr': 'Contactez l’assistance pour demander la fermeture du compte.',
        'ko': '계정 폐쇄를 요청하려면 지원팀에 문의하세요.',
        'zh': '聯絡支援以申請關閉帳戶。',
        'zh-TW': '联系支持团队以申请关闭账户。',
      },
      '複数アカウントの所持は禁止しております。\n発覚した際は、告知なくアカウント制限の対象となりますので、ご留意くださいませ。': {
        'en': 'No. Multiple accounts are not allowed.',
        'it': 'No. Non sono consentiti account multipli.',
        'de': 'Nein. Mehrere Konten sind nicht erlaubt.',
        'es': 'No. No se permiten varias cuentas.',
        'fr': 'Non. Les comptes multiples ne sont pas autorisés.',
        'ko': '아니요. 여러 계정은 허용되지 않습니다.',
        'zh': '不可以。禁止使用多個帳號。',
        'zh-TW': '不允许拥有多个账户。',
      },
      '可能です。\n※1台で複数アカウントの利用はアカウント制限の対象にもなり得ますためお控えくださいませ。': {
        'en': 'Yes. However, misuse may result in restrictions.',
        'it': 'Sì. Tuttavia, un uso improprio può comportare restrizioni.',
        'de': 'Ja. Ein Missbrauch kann jedoch zu Einschränkungen führen.',
        'es': 'Sí. Sin embargo, el uso indebido puede dar lugar a restricciones.',
        'fr': 'Oui. Cependant, une mauvaise utilisation peut entraîner des restrictions.',
        'ko': '예. 하지만 오용할 경우 제한이 있을 수 있습니다.',
        'zh': '是的。但若使用不當，可能會導致受到限制。',
        'zh-TW': '是的。不过，滥用可能会导致限制。',
      },
      '弊社に到着後、原則2営業日には査定結果をお送りいたします。': {
        'en': 'Results are usually sent within 2 business days after arrival.',
        'it': 'I risultati vengono solitamente inviati entro 2 giorni lavorativi dall\'arrivo.',
        'de': 'Ergebnisse werden in der Regel innerhalb von 2 Werktagen nach Eingang versendet.',
        'es': 'Los resultados generalmente se envían dentro de los 2 días hábiles posteriores a la llegada.',
        'fr': 'Les résultats sont généralement envoyés dans un délai de 2 jours ouvrables après l’arrivée.',
        'ko': '결과는 보통 도착 후 영업일 기준 2일 이내에 발송됩니다.',
        'zh': '結果通常會在送達後 2 個工作天內寄出。',
        'zh-TW': '结果通常会在收到后 2 个工作日内发送。',
      },
      '査定結果へご同意から2営業日以内にお振込いたします。': {
        'en': 'Payment is made within 2 business days after approval.',
        'it': 'Il pagamento viene effettuato entro 2 giorni lavorativi dall\'approvazione.',
        'de': 'Die Zahlung erfolgt innerhalb von 2 Werktagen nach der Genehmigung.',
        'es': 'El pago se realiza dentro de los 2 días hábiles posteriores a la aprobación.',
        'fr': 'Le paiement est effectué dans les 2 jours ouvrables suivant l’approbation.',
        'ko': '승인 후 영업일 기준 2일 이내에 결제가 이루어집니다.',
        'zh': '付款將於核准後 2 個工作天內完成。',
        'zh-TW': '款项将在批准后的 2 个工作日内支付。',
      },
      '可能です。1枚からでもご返送を承ります。\n着払いにてご返送をさせていただきます。': {
        'en': 'Yes. Returns are accepted.',
        'it': 'Sì. I resi sono accettati.',
        'de': 'Ja. Rücksendungen werden akzeptiert.',
        'es': 'Sí. Se aceptan devoluciones.',
        'fr': 'Oui. Les retours sont acceptés.',
        'ko': '예. 반품이 가능합니다.',
        'zh': '是的。接受退貨。',
        'zh-TW': '是的。接受退货。',
      },
      '買取表に記載のカードのみとなります。\n予めご容赦くださいませ。': {
        'en': 'Only items listed in the buyback form are accepted.',
        'it': 'Sono accettati solo gli articoli elencati nel modulo di riacquisto.',
        'de': 'Es werden nur Artikel akzeptiert, die im Rückkaufformular aufgeführt sind.',
        'es': 'Solo se aceptan los artículos enumerados en el formulario de recompra.',
        'fr': 'Seuls les articles indiqués dans le formulaire de reprise sont acceptés.',
        'ko': '매입 신청서에 기재된 품목만 접수됩니다.',
        'zh': '僅接受列於回購表單中的商品。',
        'zh-TW': '仅接受回购表单中列出的物品。',
      },
      'はい。取得日より6ヶ月となります。': {
        'en': 'Yes. Coins are valid for 6 months.',
        'it': 'Sì. Le monete sono valide per 6 mesi.',
        'de': 'Ja. Münzen sind 6 Monate gültig.',
        'es': 'Sí. Las monedas son válidas durante 6 meses.',
        'fr': 'Oui. Les pièces sont valables pendant 6 mois.',
        'ko': '네. 코인은 6개월 동안 유효합니다.',
        'zh': '是。硬幣的有效期限為 6 個月。',
        'zh-TW': '是的。硬币的有效期为6个月。',
      },
      '現金への換金はできません。': {
        'en': 'No. Coins cannot be converted to cash.',
        'it': 'No. I Coins non possono essere convertiti in contanti.',
        'de': 'Nein. Münzen können nicht in Bargeld umgewandelt werden.',
        'es': 'No. Las monedas no se pueden convertir en efectivo.',
        'fr': 'Non. Les pièces ne peuvent pas être converties en espèces.',
        'ko': '아니요. 코인은 현금으로 전환할 수 없습니다.',
        'zh': '不可以。硬幣無法兌換成現金。',
        'zh-TW': '不可以。金币不能兑换成现金。',
      },
      '「商品名」の方が優先されます。ご心配をおかけしてしまい、大変申し訳ございません。': {
        'en': 'The product name takes priority.',
        'it': 'Il nome del prodotto ha la priorità.',
        'de': 'Der Produktname hat Vorrang.',
        'es': 'El nombre del producto tiene prioridad.',
        'fr': 'Le nom du produit est prioritaire.',
        'ko': '제품명이 우선합니다.',
        'zh': '產品名稱優先。',
        'zh-TW': '产品名称优先。',
      },
      '一度ご決定いただいたものは変更いたしかねます。予めご容赦くださいませ。': {
        'en': 'No. This action cannot be reversed.',
        'it': 'No. Questa azione non può essere annullata.',
        'de': 'Nein. Diese Aktion kann nicht rückgängig gemacht werden.',
        'es': 'No. Esta acción no se puede revertir.',
        'fr': 'Non. Cette action ne peut pas être annulée.',
        'ko': '아니요. 이 작업은 되돌릴 수 없습니다.',
        'zh': '不。此操作無法復原。',
        'zh-TW': '不。此操作无法撤销。',
      },
      '返金は原則不可となります。': {
        'en': 'Refunds are generally not available.',
        'it': 'I rimborsi generalmente non sono disponibili.',
        'de': 'Rückerstattungen sind in der Regel nicht möglich.',
        'es': 'Por lo general, no hay reembolsos disponibles.',
        'fr': 'Les remboursements ne sont généralement pas disponibles.',
        'ko': '환불은 일반적으로 불가능합니다.',
        'zh': '退款通常不提供。',
        'zh-TW': '通常不提供退款。',
      },
      'ガチャで当たった景品を出品できたり、欲しいカードを購入できます。\n詳細はこちらをクリックしてください。': {
        'en': 'You can list the prizes you won in the gacha or purchase the cards you want. Please click here for details.',
        'it': 'Puoi elencare i premi che hai vinto nel gacha o acquistare le carte che desideri. Fai clic qui per i dettagli.',
        'de': 'Du kannst die Preise auflisten, die du in der Gacha gewonnen hast, oder die Karten kaufen, die du möchtest. Bitte klicke hier für Details.',
        'es': 'Puedes consultar los premios que obtuviste en la gacha o comprar las cartas que quieras. Haz clic aquí para ver los detalles.',
        'fr': 'Vous pouvez lister les prix que vous avez remportés dans le gacha ou acheter les cartes que vous souhaitez. Veuillez cliquer ici pour plus de détails.',
        'ko': '가챠에서 획득한 상품을 목록으로 확인하거나 원하는 카드를 구매할 수 있습니다. 자세한 내용은 여기를 클릭해 주세요.',
        'zh': '您可以列出您在扭蛋中獲得的獎品，或購買您想要的卡片。詳情請點擊這裡。',
        'zh-TW': '您可以列出您在扭蛋中获得的奖品，或购买您想要的卡片。详情请点击这里。',
      },
      '日本のさまざまな法人さまの商品をガチャで購入することができるページです。': {
        'en': 'A section where products are sold through gacha.',
        'it': 'Una sezione in cui i prodotti vengono venduti tramite gacha.',
        'de': 'Ein Bereich, in dem Produkte über Gacha verkauft werden.',
        'es': 'Una sección donde los productos se venden a través de gacha.',
        'fr': 'Une section où les produits sont vendus via gacha.',
        'ko': '가챠를 통해 상품을 판매하는 섹션.',
        'zh': '以轉蛋方式販售商品的區域。',
        'zh-TW': '通过扭蛋销售商品的区域。',
      },
      'サイトについて': {
        'en': 'About Our Service',
        'it': 'Informazioni sul nostro servizio',
        'de': 'Über unseren Service',
        'es': 'Acerca de nuestro servicio',
        'fr': 'À propos de notre service',
        'ko': '당사 서비스 소개',
        'zh': '關於我們的服務',
        'zh-TW': '关于我们的服务',
      },
      '発送について': {
        'en': 'Shipping & Delivery',
        'it': 'Spedizione e consegna',
        'de': 'Versand & Lieferung',
        'es': 'Envío y entrega',
        'fr': 'Expédition et livraison',
        'ko': '배송 및 배달',
        'zh': '運送與配送',
        'zh-TW': '运输与交付',
      },
      '商品について': {
        'en': 'Products & Items',
        'it': 'Prodotti e articoli',
        'de': 'Produkte & Artikel',
        'es': 'Productos y artículos',
        'fr': 'Produits et articles',
        'ko': '제품 및 항목',
        'zh': '產品與品項',
        'zh-TW': '产品和物品',
      },
      'shopについて': {
        'en': 'Shop',
        'it': 'Negozio',
        'de': 'Shop',
        'es': 'Tienda',
        'fr': 'Boutique',
        'ko': '가게',
        'zh': '商店',
        'zh-TW': '商店',
      },
      'X marketについて': {
        'en': '',
        'it': '',
        'de': '',
        'es': '',
        'fr': '',
        'ko': '',
        'zh': '',
        'zh-TW': '',
      },
      'アカウントについて': {
        'en': 'Account',
        'it': 'Account',
        'de': 'Konto',
        'es': 'Cuenta',
        'fr': 'Compte',
        'ko': '계정',
        'zh': '帳戶',
        'zh-TW': '账户',
      },
      '郵送買取について': {
        'en': 'Sell to Us',
        'it': 'Vendici',
        'de': 'Verkaufen Sie an uns',
        'es': 'Véndenos',
        'fr': 'Vendez-nous',
        'ko': '우리에게 판매하기',
        'zh': '賣給我們',
        'zh-TW': '卖给我们',
      },
      'コインについて': {
        'en': 'Coins',
        'it': 'Monete',
        'de': 'Münzen',
        'es': 'Monedas',
        'fr': 'Pièces',
        'ko': '동전',
        'zh': '硬幣',
        'zh-TW': '硬币',
      },
      'キャンセル・返品・返金について': {
        'en': 'Cancellations, Returns & Refunds',
        'it': 'Cancellazioni, Resi e Rimborsi',
        'de': 'Stornierungen, Rückgaben & Rückerstattungen',
        'es': 'Cancelaciones, devoluciones y reembolsos',
        'fr': 'Annulations, retours et remboursements',
        'ko': '취소, 반품 및 환불',
        'zh': '取消、退貨與退款',
        'zh-TW': '取消、退货和退款',
      },
      '友達を紹介してコインを貰いたいけど、どうすればいいですか？': {
        'en': 'How can I earn coins by referring a friend?',
        'it': 'Come posso guadagnare monete invitando un amico?',
        'de': 'Wie kann ich Münzen verdienen, indem ich einen Freund werbe?',
        'es': '¿Cómo puedo ganar monedas al invitar a un amigo?',
        'fr': 'Comment puis-je gagner des pièces en parrainant un ami ?',
        'ko': '친구를 추천하여 코인을 어떻게 얻을 수 있나요?',
        'zh': '如何透過推薦朋友來賺取金幣？',
        'zh-TW': '如何通过推荐朋友来赚取金币？',
      },
      '会員ランクを翌月も維持することはできますか？': {
        'en': 'Can I maintain my membership rank?',
        'it': 'Posso mantenere il mio livello di iscrizione?',
        'de': 'Kann ich meinen Mitgliedschaftsstatus beibehalten?',
        'es': '¿Puedo mantener mi rango de membresía?',
        'fr': 'Puis-je conserver mon niveau d’adhésion ?',
        'ko': '회원 등급을 유지할 수 있나요?',
        'zh': '我可以保留我的會員等級嗎？',
        'zh-TW': '我可以保留我的会员等级吗？',
      },
      '私の会社の商材もガチャで販売できますか？': {
        'en': 'Can I sell my products through your gacha platform?',
        'it': 'Posso vendere i miei prodotti tramite la vostra piattaforma gacha?',
        'de': 'Kann ich meine Produkte über Ihre Gacha-Plattform verkaufen?',
        'es': '¿Puedo vender mis productos a través de su plataforma gacha?',
        'fr': 'Puis-je vendre mes produits via votre plateforme gacha ?',
        'ko': '귀사의 가챠 플랫폼을 통해 제 상품을 판매할 수 있나요?',
        'zh': '我可以透過你們的扭蛋平台販售我的產品嗎？',
        'zh-TW': '我可以通过你们的扭蛋平台销售我的产品吗？',
      },
      '問い合わせへの返信はどのくらいの時間で返ってきますか？': {
        'en': 'How long does it take to get a reply?',
        'it': 'Quanto tempo ci vuole per ricevere una risposta?',
        'de': 'Wie lange dauert es, bis ich eine Antwort bekomme?',
        'es': '¿Cuánto tiempo se tarda en recibir una respuesta?',
        'fr': 'Combien de temps faut-il pour obtenir une réponse ?',
        'ko': '답변을 받는 데 얼마나 걸리나요?',
        'zh': '需要多久才能收到回覆？',
        'zh-TW': '多久能收到回复？',
      },
      '動画を見たのにコインが貰えなかった。なぜでしょうか？': {
        'en': 'I watched a video but didn’t receive coins. Why?',
        'it': 'Ho guardato un video ma non ho ricevuto monete. Perché?',
        'de': 'Ich habe ein Video angesehen, aber keine Münzen erhalten. Warum?',
        'es': 'Vi un video pero no recibí monedas. ¿Por qué?',
        'fr': 'J’ai regardé une vidéo mais je n’ai pas reçu de pièces. Pourquoi ?',
        'ko': '동영상을 시청했는데 코인을 받지 못했어요. 왜 그런가요?',
        'zh': '我看了一部影片，但沒有收到金幣。為什麼？',
        'zh-TW': '我看了一个视频，但没有收到金币。为什么？',
      },
      '発送はいつですか？': {
        'en': 'When will my order be shipped?',
        'it': 'Quando verrà spedito il mio ordine?',
        'de': 'Wann wird meine Bestellung versandt?',
        'es': '¿Cuándo se enviará mi pedido?',
        'fr': 'Quand ma commande sera-t-elle expédiée ?',
        'ko': '주문한 상품은 언제 배송되나요?',
        'zh': '我的訂單何時會出貨？',
        'zh-TW': '我的订单什么时候发货？',
      },
      '梱包は丁寧ですか？': {
        'en': 'Is the packaging secure?',
        'it': 'L\'imballaggio è sicuro?',
        'de': 'Ist die Verpackung sicher?',
        'es': '¿Es seguro el embalaje?',
        'fr': 'L’emballage est-il sécurisé ?',
        'ko': '포장이 안전한가요?',
        'zh': '包裝安全嗎？',
        'zh-TW': '包装安全吗？',
      },
      '配送業者はどこですか？': {
        'en': 'Which shipping carrier do you use?',
        'it': 'Quale corriere di spedizione utilizzi?',
        'de': 'Welchen Versanddienstleister verwenden Sie?',
        'es': '¿Qué transportista utilizas?',
        'fr': 'Quel transporteur utilisez-vous ?',
        'ko': '어느 배송 업체를 이용하시나요?',
        'zh': '您使用哪家運輸公司？',
        'zh-TW': '您使用哪家运输承运商？',
      },
      '送料はかかりますか？': {
        'en': 'Is there a shipping fee?',
        'it': 'Ci sono spese di spedizione?',
        'de': 'Gibt es eine Versandgebühr?',
        'es': '¿Hay una tarifa de envío?',
        'fr': 'Y a-t-il des frais de livraison ?',
        'ko': '배송비가 있나요?',
        'zh': '有運費嗎？',
        'zh-TW': '有运费吗？',
      },
      '追跡番号はどこでわかりますか？': {
        'en': 'When will tracking be available?',
        'it': 'Quando sarà disponibile il tracciamento?',
        'de': 'Wann wird die Sendungsverfolgung verfügbar sein?',
        'es': '¿Cuándo estará disponible el seguimiento?',
        'fr': 'Quand le suivi sera-t-il disponible ?',
        'ko': '추적은 언제 가능해지나요?',
        'zh': '何時可以追蹤？',
        'zh-TW': '什么时候可以查看物流跟踪信息？',
      },
      '発送通知からどのくらいで追跡番号がインターネットで確認できますか？': {
        'en': 'When will tracking be available after shipment?',
        'it': 'Quando sarà disponibile il tracciamento dopo la spedizione?',
        'de': 'Wann wird die Sendungsverfolgung nach dem Versand verfügbar sein?',
        'es': '¿Cuándo estará disponible el seguimiento después del envío?',
        'fr': 'Quand le suivi sera-t-il disponible après l’expédition ?',
        'ko': '배송 후 언제부터 배송 추적이 가능하나요?',
        'zh': '出貨後多久可以查詢物流追蹤？',
        'zh-TW': '发货后多久可以查询物流信息？',
      },
      '住所変更はどこからできますか？': {
        'en': 'Where can I change my address?',
        'it': 'Dove posso cambiare il mio indirizzo?',
        'de': 'Wo kann ich meine Adresse ändern?',
        'es': '¿Dónde puedo cambiar mi dirección?',
        'fr': 'Où puis-je changer mon adresse ?',
        'ko': '주소는 어디에서 변경할 수 있나요?',
        'zh': '我可以在哪裡更改我的地址？',
        'zh-TW': '我可以在哪里更改我的地址？',
      },
      'X marketで買った商品は何日くらいで届きますか？': {
        'en': 'How many days does it take for the products bought at X market to arrive?',
        'it': 'Quanti giorni ci vogliono perché i prodotti acquistati al mercato X arrivino?',
        'de': 'Wie viele Tage dauert es, bis die bei X market gekauften Produkte ankommen?',
        'es': '¿Cuántos días tardan en llegar los productos comprados en el mercado X?',
        'fr': 'Combien de jours faut-il pour que les produits achetés au marché X arrivent ?',
        'ko': 'X 마켓에서 구매한 상품은 도착하는 데 며칠이 걸리나요?',
        'zh': '在 X 市場購買的商品需要幾天才會送達？',
        'zh-TW': '在X市场购买的产品需要多少天才能送达？',
      },
      'カードの状態は綺麗ですか？': {
        'en': 'What condition are the cards in?',
        'it': 'In che condizioni sono le carte?',
        'de': 'In welchem Zustand sind die Karten?',
        'es': '¿En qué estado están las tarjetas?',
        'fr': 'Dans quel état sont les cartes ?',
        'ko': '카드 상태가 어떤가요?',
        'zh': '卡片的狀況如何？',
        'zh-TW': '卡片的状况如何？',
      },
      '違う商品が届いた。どうすればいいですか？': {
        'en': 'I received a different item. What should I do?',
        'it': 'Ho ricevuto un articolo diverso. Cosa devo fare?',
        'de': 'Ich habe einen anderen Artikel erhalten. Was soll ich tun?',
        'es': 'Recibí un artículo diferente. ¿Qué debo hacer?',
        'fr': 'J’ai reçu un article différent. Que dois-je faire ?',
        'ko': '다른 상품을 받았습니다. 어떻게 해야 하나요?',
        'zh': '我收到的商品與訂購的不一樣。我該怎麼辦？',
        'zh-TW': '我收到了不同的商品。我该怎么办？',
      },
      '私たちの会社の商品を販売して欲しい。どうしたらいいですか？': {
        'en': 'Can I sell my products on your platform?',
        'it': 'Posso vendere i miei prodotti sulla vostra piattaforma?',
        'de': 'Kann ich meine Produkte auf Ihrer Plattform verkaufen?',
        'es': '¿Puedo vender mis productos en su plataforma?',
        'fr': 'Puis-je vendre mes produits sur votre plateforme ?',
        'ko': '귀하의 플랫폼에서 제 제품을 판매할 수 있나요?',
        'zh': '我可以在你們的平台上販售我的產品嗎？',
        'zh-TW': '我可以在你们的平台上销售我的产品吗？',
      },
      'X marketに出品できないのはなぜですか？': {
        'en': 'Why can\'t I list it on X market?',
        'it': 'Perché non posso metterlo in vendita sul mercato X?',
        'de': 'Warum kann ich es nicht auf dem X-Markt anbieten?',
        'es': '¿Por qué no puedo ponerlo a la venta en el mercado X?',
        'fr': 'Pourquoi ne puis-je pas le lister sur le marché X ?',
        'ko': '왜 X 마켓에 등록할 수 없나요?',
        'zh': '為什麼我不能在 X 市場上架它？',
        'zh-TW': '为什么我不能在 X 市场上架它？',
      },
      'パスワードを忘れた。どうすればいいですか？': {
        'en': 'I forgot my password. What should I do?',
        'it': 'Ho dimenticato la password. Cosa devo fare?',
        'de': 'Ich habe mein Passwort vergessen. Was soll ich tun?',
        'es': 'Olvidé mi contraseña. ¿Qué debo hacer?',
        'fr': 'J’ai oublié mon mot de passe. Que dois-je faire ?',
        'ko': '비밀번호를 잊어버렸습니다. 어떻게 해야 하나요?',
        'zh': '我忘記密碼了。我該怎麼辦？',
        'zh-TW': '我忘记密码了。我该怎么办？',
      },
      '退会したい場合はどうすればいいですか？': {
        'en': 'How do I close my account?',
        'it': 'Come faccio a chiudere il mio account?',
        'de': 'Wie schließe ich mein Konto?',
        'es': '¿Cómo cierro mi cuenta?',
        'fr': 'Comment fermer mon compte ?',
        'ko': '계정을 어떻게 해지하나요?',
        'zh': '如何關閉我的帳戶？',
        'zh-TW': '我如何关闭我的账户？',
      },
      '1人で複数のアカウントを所有することは可能ですか？': {
        'en': 'Can I have multiple accounts?',
        'it': 'Posso avere più account?',
        'de': 'Kann ich mehrere Konten haben?',
        'es': '¿Puedo tener varias cuentas?',
        'fr': 'Puis-je avoir plusieurs comptes ?',
        'ko': '여러 계정을 가질 수 있나요?',
        'zh': '我可以有多個帳號嗎？',
        'zh-TW': '我可以有多个账户吗？',
      },
      '1アカウントを複数台の端末を利用することは可能ですか？': {
        'en': 'Can I use my account on multiple devices?',
        'it': 'Posso usare il mio account su più dispositivi?',
        'de': 'Kann ich mein Konto auf mehreren Geräten verwenden?',
        'es': '¿Puedo usar mi cuenta en varios dispositivos?',
        'fr': 'Puis-je utiliser mon compte sur plusieurs appareils ?',
        'ko': '내 계정을 여러 기기에서 사용할 수 있나요?',
        'zh': '我可以在多個裝置上使用我的帳戶嗎？',
        'zh-TW': '我可以在多台设备上使用我的账户吗？',
      },
      '何日くらいで査定結果がでますか？': {
        'en': 'How long does appraisal take?',
        'it': 'Quanto tempo richiede la valutazione?',
        'de': 'Wie lange dauert die Bewertung?',
        'es': '¿Cuánto tarda la tasación?',
        'fr': 'Combien de temps prend l’évaluation ?',
        'ko': '감정 평가는 얼마나 걸리나요?',
        'zh': '房屋估價需要多久？',
        'zh-TW': '评估需要多长时间？',
      },
      'いつ入金されますか？': {
        'en': 'When will I receive payment?',
        'it': 'Quando riceverò il pagamento?',
        'de': 'Wann erhalte ich die Zahlung?',
        'es': '¿Cuándo recibiré el pago?',
        'fr': 'Quand recevrai-je le paiement ?',
        'ko': '언제 결제를 받게 되나요?',
        'zh': '我何時會收到款項？',
        'zh-TW': '我什么时候会收到付款？',
      },
      '返却は可能ですか？': {
        'en': 'Can I return items?',
        'it': 'Posso restituire gli articoli?',
        'de': 'Kann ich Artikel zurückgeben?',
        'es': '¿Puedo devolver artículos?',
        'fr': 'Puis-je retourner des articles ?',
        'ko': '반품할 수 있나요?',
        'zh': '我可以退貨嗎？',
        'zh-TW': '我可以退货吗？',
      },
      '買取表に載っていないカードの買取は可能ですか？': {
        'en': 'Can I sell you cards that aren\'t listed on the buyback list?',
        'it': 'Posso vendervi carte che non sono elencate nella lista di riacquisto?',
        'de': 'Kann ich Ihnen Karten verkaufen, die nicht auf der Ankaufsliste stehen?',
        'es': '¿Puedo venderles tarjetas que no figuran en la lista de recompra?',
        'fr': 'Puis-je vous vendre des cartes qui ne figurent pas sur la liste de rachat ?',
        'ko': '매입 목록에 없는 카드도 판매할 수 있나요?',
        'zh': '我可以賣給你們不在回收清單上的卡片嗎？',
        'zh-TW': '我可以把不在回收清单上的卡卖给你们吗？',
      },
      '有効期限はありますか？': {
        'en': 'Is there an expiration date?',
        'it': 'C\'è una data di scadenza?',
        'de': 'Gibt es ein Ablaufdatum?',
        'es': '¿Hay una fecha de vencimiento?',
        'fr': 'Y a-t-il une date d’expiration ?',
        'ko': '유효기간이 있나요?',
        'zh': '有有效期限嗎？',
        'zh-TW': '有截止日期吗？',
      },
      '換金できますか？': {
        'en': 'Can coins be exchanged for cash?',
        'it': 'Le monete possono essere cambiate in contanti?',
        'de': 'Können Münzen gegen Bargeld umgetauscht werden?',
        'es': '¿Se pueden cambiar monedas por efectivo?',
        'fr': 'Les pièces peuvent-elles être échangées contre de l’argent liquide ?',
        'ko': '동전을 현금으로 바꿀 수 있나요?',
        'zh': '硬幣可以兌換成現金嗎？',
        'zh-TW': '硬币可以兑换成现金吗？',
      },
      'カードの画像と商品名が違うカードが当たった。どっちが正しいですか？': {
        'en': 'The product image and name are different. Which is correct?',
        'it': 'L\'immagine e il nome del prodotto sono diversi. Quale è corretto?',
        'de': 'Das Produktbild und der Name sind unterschiedlich. Welches ist korrekt?',
        'es': 'La imagen y el nombre del producto son diferentes. ¿Cuál es correcto?',
        'fr': 'L’image du produit et son nom sont différents. Lequel est correct ?',
        'ko': '상품 이미지와 이름이 다릅니다. 어느 것이 맞나요?',
        'zh': '產品圖片和名稱不同。哪個是正確的？',
        'zh-TW': '产品图片和名称不一致。哪个是正确的？',
      },
      '発送を希望している商品を誤ってコインに還元してしまった。変更できますか？': {
        'en': 'I accidentally converted an item to coins. Can I undo it?',
        'it': 'Ho convertito per sbaglio un oggetto in monete. Posso annullare l’operazione?',
        'de': 'Ich habe einen Gegenstand versehentlich in Münzen umgewandelt. Kann ich das rückgängig machen?',
        'es': 'Convertí un objeto en monedas por accidente. ¿Puedo deshacerlo?',
        'fr': 'J’ai accidentellement converti un objet en pièces. Puis-je annuler cela ?',
        'ko': '실수로 아이템을 코인으로 전환했어요. 되돌릴 수 있나요?',
        'zh': '我不小心把一個物品轉換成硬幣了。我可以復原嗎？',
        'zh-TW': '我不小心把一个物品转换成金币了。可以撤销吗？',
      },
      '返金は可能でしょうか？': {
        'en': 'Can I get a refund?',
        'it': 'Posso ottenere un rimborso?',
        'de': 'Kann ich eine Rückerstattung bekommen?',
        'es': '¿Puedo obtener un reembolso?',
        'fr': 'Puis-je obtenir un remboursement ?',
        'ko': '환불받을 수 있나요?',
        'zh': '我可以退款嗎？',
        'zh-TW': '我可以退款吗？',
      },
      'Xmarketとはなんですか？': {
        'en': 'What is Xmarket?',
        'it': 'Che cos\'è Xmarket?',
        'de': 'Was ist Xmarket?',
        'es': '¿Qué es Xmarket?',
        'fr': 'Qu’est-ce que Xmarket ?',
        'ko': '엑스마켓이란 무엇인가요?',
        'zh': '什麼是 Xmarket？',
        'zh-TW': '什么是 Xmarket？',
      },
      'shopとはなんですか？': {
        'en': 'What is the Shop feature?',
        'it': 'Che cos\'è la funzione Shop?',
        'de': 'Was ist die Shop-Funktion?',
        'es': '¿Qué es la función Tienda?',
        'fr': 'Qu’est-ce que la fonctionnalité Boutique ?',
        'ko': 'Shop 기능이 무엇인가요?',
        'zh': '什麼是商店功能？',
        'zh-TW': '什么是商店功能？',
      },
    },
  }),
  computed: {
    ...mapGetters({
      currentLanguage: 'user/currentLanguage',
    }),
  },
  methods: {
    t(code) {
      if (this.currentLanguage === 'jp') {
        return code;
      }
      if (this.i18n_message[code]) {
        if (this.i18n_message[code][this.currentLanguage]) {
          return this.i18n_message[code][this.currentLanguage];
        }
      }

      if (this.currentLanguage !== 'jp') {
        // console.log(`紐づけなし:${code}`);
      }
      return code;
    },
  },
};
